/**
* This is an automatically generated file. Do not edit. See README.md for more information.
*/

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: any;
  Short: any;
};

export type ActivateMerchantCarrierCommand = {
  carrier: Scalars['String'];
  merchantId: Scalars['String'];
  upsParameters?: InputMaybe<UpsCarrierAccountInput>;
};

/** The address of the user */
export type Address = {
  __typename?: 'Address';
  /** The address city. */
  city?: Maybe<Scalars['String']>;
  /** The address country. */
  country?: Maybe<Scalars['String']>;
  /** The address postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** The address state. */
  state?: Maybe<Scalars['String']>;
  /** The street1 address. */
  street1?: Maybe<Scalars['String']>;
  /** The street2 address. */
  street2?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  isResidential?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  street3?: InputMaybe<Scalars['String']>;
  streetNo?: InputMaybe<Scalars['String']>;
  validate?: InputMaybe<Scalars['Boolean']>;
  zip: Scalars['String'];
};

export type AddressModel = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  alternatePhone?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['Int']>;
  fax?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDefaultBillingAddress: Scalars['Boolean'];
  isDefaultShippingAddress: Scalars['Boolean'];
  isNew?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AppMetaData = {
  __typename?: 'AppMetaData';
  /** The wms of the user. */
  wms: Scalars['String'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AFTER_RESOLVER = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BEFORE_RESOLVER = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  VALIDATION = 'VALIDATION'
}

/** An assigned permission record is a large scale pivot between multiple resources that allows a permission to be assigned to a role, service account, or a user. Additionally, a sales channel, business, or organization may be specified for the assigned permission. */
export type AssignedPermission = {
  __typename?: 'AssignedPermission';
  /** The business for the assigned permission. */
  business?: Maybe<Business>;
  /** The id of the business for the assigned permission. */
  businessId?: Maybe<Scalars['Int']>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the assigned permission record. */
  id: Scalars['Int'];
  /** The organization for the assigned permission. */
  organization?: Maybe<Organization>;
  /** The id of the organization for the assigned permission. */
  organizationId?: Maybe<Scalars['Int']>;
  /** The permission for the new assigned permission. */
  permission?: Maybe<Permission>;
  /** The id of the permission you wish to assign. */
  permissionId?: Maybe<Scalars['Int']>;
  /** The role of the assigned permission */
  role?: Maybe<Role>;
  /** The role id of the assigned permission record. */
  roleId?: Maybe<Scalars['Int']>;
  /** The sales channel for the assigned permission. */
  salesChannel?: Maybe<SalesChannel>;
  /** The id of the sales channel for the assigned permission. */
  salesChannelId?: Maybe<Scalars['Int']>;
  /** The service account for the assigned permission. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** The id of the service account for the assigned permission. */
  serviceAccountId?: Maybe<Scalars['Int']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user for the new assigned permission. */
  user?: Maybe<User>;
  /** The id of the user for the assigned permission. */
  userId?: Maybe<Scalars['Int']>;
};

/** An assigned role record is a large scale pivot between multiple resources that allows a role to be assigned to a service account or user. Additionally, a sales channel, business, or organization may be specified for the assigned role. */
export type AssignedRole = {
  __typename?: 'AssignedRole';
  /** The permissions assigned to this role. */
  assignedPermissions?: Maybe<Array<AssignedPermission>>;
  /** The business for the role. */
  business?: Maybe<Business>;
  /** The id of the business for the role. */
  businessId?: Maybe<Scalars['Int']>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the assigned role record. */
  id: Scalars['Int'];
  /** The organization for the role. */
  organization?: Maybe<Organization>;
  /** The id of the organization for the role. */
  organizationId?: Maybe<Scalars['Int']>;
  /** The role you wish to assign. */
  role?: Maybe<Role>;
  /** The id of the role you wish to assign. */
  roleId?: Maybe<Scalars['Int']>;
  /** The sales channel for the role. */
  salesChannel?: Maybe<SalesChannel>;
  /** The id of the sales channel for the role. */
  salesChannelId?: Maybe<Scalars['Int']>;
  /** The service account for the role. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** The id of the service account for the role. */
  serviceAccountId?: Maybe<Scalars['Int']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user for the role. */
  user?: Maybe<User>;
  /** The id of the user for the role. */
  userId?: Maybe<Scalars['Int']>;
};

export type AttributeGroupModel = {
  allowDrillDown?: InputMaybe<Scalars['Boolean']>;
  allowMultiple?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  tieVariantInventory?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AttributeModel = {
  attributeGroupId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlRewrite?: InputMaybe<Scalars['String']>;
};

/** The auth methods associated with the email. */
export type AuthMethod = {
  __typename?: 'AuthMethod';
  /** The auth method */
  methods: Array<AuthMethodEnum>;
};

/** The authentication method. */
export enum AuthMethodEnum {
  AZURE = 'AZURE',
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  PASSWORD = 'PASSWORD'
}

export type AuthMethodInput = {
  /** It's an email address. */
  email: Scalars['String'];
};

export type Batch = {
  __typename?: 'Batch';
  batchLabels?: Maybe<Array<Maybe<Label>>>;
  batchShipments?: Maybe<batchShipments>;
  defaultCarrierAccount?: Maybe<Scalars['String']>;
  defaultServicelevelToken?: Maybe<Scalars['String']>;
  labelFiletype?: Maybe<Scalars['String']>;
  labelUrl?: Maybe<Array<Maybe<Scalars['String']>>>;
  merchantId: Scalars['Int'];
  metadata?: Maybe<Scalars['String']>;
  objectCreated: Scalars['DateTime'];
  objectId?: Maybe<Scalars['String']>;
  objectOwner?: Maybe<Scalars['String']>;
  objectResults?: Maybe<objectResults>;
  objectUpdated: Scalars['DateTime'];
  status?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['Boolean']>;
};

/** A Cart business record. */
export type Business = {
  __typename?: 'Business';
  /** The assigned roles that belong to the business. */
  assignedRoles?: Maybe<Array<AssignedRole>>;
  /** The information about the business. */
  businessData?: Maybe<BusinessData>;
  /**
   * The business services that belong to the business.
   * @deprecated Use ProductInstance instead.
   */
  businessServices?: Maybe<BusinessService>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** whether or not a business record is disabled. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The reason a business record has been disabled. */
  disabledReason?: Maybe<Scalars['String']>;
  /** The id of the record. */
  id: Scalars['Int'];
  members: Array<Member>;
  /** The name of the business. */
  name: Scalars['String'];
  /** The number of unique users that have an assigned role to the business. */
  numUsers?: Maybe<Scalars['Int']>;
  /** The parent organization. */
  organization?: Maybe<Organization>;
  /** The parent organization id. */
  organizationId?: Maybe<Scalars['Int']>;
  /** The product instances that belong to the business. */
  productInstances?: Maybe<Array<ProductInstance>>;
  roleName?: Maybe<Scalars['String']>;
  salesChannels: Array<SalesChannel>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  userStatus?: Maybe<Scalars['String']>;
};


/** A Cart business record. */
export type BusinessassignedRolesArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  primaryEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};


/** A Cart business record. */
export type BusinessproductInstancesArgs = {
  instanceType?: InputMaybe<InstanceType>;
};

/** Additional metadata for a Cart business record. */
export type BusinessData = {
  __typename?: 'BusinessData';
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the record. */
  id: Scalars['Int'];
  /** The phone number for the business. */
  phone?: Maybe<Scalars['String']>;
  /** The revenue for the business. */
  revenue?: Maybe<Scalars['String']>;
  /** The sales channel for the business. */
  salesChannel?: Maybe<Scalars['String']>;
  /** The shipHero Id for the business. */
  shipHeroId?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The website for the business. */
  website?: Maybe<Scalars['String']>;
};

/** A Cart business record. */
export type BusinessService = {
  __typename?: 'BusinessService';
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Feed management data for the business. */
  feedManagementData?: Maybe<Scalars['String']>;
  /** Whether or not feed management is enabled. */
  feedManagementEnabled: Scalars['Boolean'];
  /** Whether or not the feed management is requested. */
  feedManagementRequested: Scalars['Boolean'];
  /** Fulfillment data for the business. */
  fulfillmentData?: Maybe<Scalars['String']>;
  /** Whether or not fulfillment is enabled. */
  fulfillmentEnabled: Scalars['Boolean'];
  /** Whether or not fulfillment is requested. */
  fulfillmentRequested: Scalars['Boolean'];
  /** The id of the record. */
  id: Scalars['Int'];
  /** Mcm data for the business. */
  mcmData?: Maybe<Scalars['String']>;
  /** Whether or not mcm is enabled. */
  mcmEnabled: Scalars['Boolean'];
  /** Whether or not mcm is requested. */
  mcmRequested: Scalars['Boolean'];
  /** Storefront data for the business. */
  storefrontData?: Maybe<Scalars['String']>;
  /** Whether or not storefront is enabled. */
  storefrontEnabled: Scalars['Boolean'];
  /** Whether or not storefront is requested. */
  storefrontRequested: Scalars['Boolean'];
  /** Unified analytics data for the business. */
  unifiedAnalyticsData?: Maybe<Scalars['String']>;
  /** Whether or not unified analytics is enabled. */
  unifiedAnalyticsEnabled: Scalars['Boolean'];
  /** Whether or not unified analytics is requested. */
  unifiedAnalyticsRequested: Scalars['Boolean'];
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CarrierAccount = {
  __typename?: 'CarrierAccount';
  active: Scalars['Boolean'];
  carrier?: Maybe<Scalars['String']>;
  carrierAccountId?: Maybe<Scalars['String']>;
};

export type CartInfoModel = {
  additionalFees?: InputMaybe<Scalars['Decimal']>;
  associatedOrderId?: InputMaybe<Scalars['Int']>;
  cartType?: InputMaybe<Scalars['String']>;
  couponCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['Int']>;
  customerPaymentMethodId?: InputMaybe<Scalars['Int']>;
  discountTotal?: InputMaybe<Scalars['Decimal']>;
  discountedShippingTotal?: InputMaybe<Scalars['Decimal']>;
  giftCertificateDiscount?: InputMaybe<Scalars['Decimal']>;
  grandTotal?: InputMaybe<Scalars['Decimal']>;
  handlingTotal?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isPaymentCartOnly?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isShippingBilledToAccount?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<CartModel>>>;
  lookupKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nonShippingDiscount?: InputMaybe<Scalars['Decimal']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  regionMarkupAmount?: InputMaybe<Scalars['Decimal']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  shippingEstimateCity?: InputMaybe<Scalars['String']>;
  shippingEstimateCountryCode?: InputMaybe<Scalars['String']>;
  shippingEstimatePostalCode?: InputMaybe<Scalars['String']>;
  shippingEstimateStateCode?: InputMaybe<Scalars['String']>;
  shippingTotal?: InputMaybe<Scalars['Decimal']>;
  storeId?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Decimal']>;
  taxRate?: InputMaybe<Scalars['Decimal']>;
  taxTotal?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CartItemPersonalizationModel = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CartItemVariantModel = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  variantGroupId?: InputMaybe<Scalars['Int']>;
};

export type CartModel = {
  cartId?: InputMaybe<Scalars['Int']>;
  childItems?: InputMaybe<Array<InputMaybe<CartModel>>>;
  configuration?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fitment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionProduct?: InputMaybe<Scalars['Boolean']>;
  itemName?: InputMaybe<Scalars['String']>;
  itemNumber?: InputMaybe<Scalars['String']>;
  itemThumbnail?: InputMaybe<Scalars['String']>;
  itemUrl?: InputMaybe<Scalars['String']>;
  parentCartItemId?: InputMaybe<Scalars['Int']>;
  parentProductId?: InputMaybe<Scalars['Int']>;
  personalizations?: InputMaybe<Array<InputMaybe<CartItemPersonalizationModel>>>;
  price?: InputMaybe<Scalars['Decimal']>;
  productId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shippingAddressID?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variants?: InputMaybe<Array<InputMaybe<CartItemVariantModel>>>;
  vendorStoreId?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['Int']>;
};

export type CategoryModel = {
  alternateThumbnail?: InputMaybe<Scalars['String']>;
  areSubcategoryProductsDisplayed?: InputMaybe<Scalars['Boolean']>;
  catImageAltText?: InputMaybe<Scalars['String']>;
  categoryImage?: InputMaybe<Scalars['String']>;
  categoryThumbnail?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customFields?: InputMaybe<Array<InputMaybe<store_customFieldValueInputSimple>>>;
  defaultProductPicture?: InputMaybe<Scalars['String']>;
  externalContentUrl?: InputMaybe<Scalars['String']>;
  headTags?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCategoryContentDisplayed?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isHideFromSiteMaps?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  lookupPath?: InputMaybe<Scalars['String']>;
  maxQuantity?: InputMaybe<Scalars['Int']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  parentCategoryId?: InputMaybe<Scalars['Int']>;
  products?: InputMaybe<Array<InputMaybe<ProductModel>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  thumbImageAltText?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlRewrite?: InputMaybe<Scalars['String']>;
  vendorStoreId?: InputMaybe<Scalars['Int']>;
};

export type ChangeInventoryModel = {
  gtin?: InputMaybe<Scalars['String']>;
  itemName?: InputMaybe<Scalars['String']>;
  itemNumber?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  variantInventoryId?: InputMaybe<Scalars['Int']>;
};

export type ChangeOwnPasswordInput = {
  /** The user's current password for validation. */
  currentPassword: Scalars['String'];
  /** The new password. */
  newPassword: Scalars['String'];
};

export type ChangeUserPasswordInput = {
  /** The user's email address. */
  email: Scalars['String'];
  /** The new password. */
  newPassword: Scalars['String'];
};

export type CompleteLabelRefundCommand = {
  dateCompleted: Scalars['DateTime'];
  labelIDs: Array<Scalars['String']>;
};

export type ConfirmMfaEnrollmentInput = {
  /** The code the user recieves via text after requesting the SMS authentication */
  bindingcode?: InputMaybe<Scalars['String']>;
  /** The mfa token obtained to call auth0 mfa api. */
  mfatoken: Scalars['String'];
  /** The code returned in the response from the initial request SMS authentication */
  oobcode?: InputMaybe<Scalars['String']>;
  /** The code the user is challenged with after requesting OTP authentication */
  otpcode?: InputMaybe<Scalars['String']>;
  /** The type of enrollment we are confirming */
  type: Scalars['String'];
};

/** Consumes the invite and assigns roles based on the invitation sent. */
export type ConsumeInviteUserInput = {
  /** The first name for the user. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The invitation token for the user. */
  inviteToken: Scalars['String'];
  /** The last name for the user. */
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateAssignedPermissionInput = {
  /** The id of the business for the new permission. */
  businessId?: InputMaybe<Scalars['Int']>;
  /** The id of the organization for the new permission. */
  organizationId?: InputMaybe<Scalars['Int']>;
  /** The id of the permission you wish to assign. */
  permissionId?: InputMaybe<Scalars['Int']>;
  /** The name of the permission you wish to assign. */
  permissionName?: InputMaybe<Scalars['String']>;
  /** The id of the role for the new permission. */
  roleId?: InputMaybe<Scalars['Int']>;
  /** The id of the sales channel for the new permission. */
  salesChannelId?: InputMaybe<Scalars['Int']>;
  /** The id of the service account for the new permission. */
  serviceAccountId?: InputMaybe<Scalars['Int']>;
  /** The id of the user for the new permission. */
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateAssignedRoleInput = {
  /** The id of the business for the new role. */
  businessId?: InputMaybe<Scalars['Int']>;
  /** The id of the organization for the new role. */
  organizationId?: InputMaybe<Scalars['Int']>;
  /** The id of the role you wish to assign. */
  roleId: Scalars['Int'];
  /** The id of the sales channel for the new role. */
  salesChannelId?: InputMaybe<Scalars['Int']>;
  /** The id of the service account for the new role. */
  serviceAccountId?: InputMaybe<Scalars['Int']>;
  /** The id of the user for the new role. */
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateAuthMethodInput = {
  /** It's the authMethod. */
  authMethod: AuthMethodEnum;
  /** Why does this user need an authMethod override? */
  description?: InputMaybe<Scalars['String']>;
  /** It's an email address. */
  email: Scalars['String'];
};

export type CreateBatchCommand = {
  batchShipments: Array<batchShipmentInput>;
  defaultCarrierAccount: Scalars['String'];
  defaultServiceLevelToken: Scalars['String'];
  labelFileType?: InputMaybe<LabelFileTypeEnum>;
  merchantId: Scalars['String'];
  metadata?: InputMaybe<Scalars['String']>;
};

export type CreateBusinessInput = {
  /** Whether or not a Business record is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The reason a Business record has been disabled. */
  disabledReason?: InputMaybe<Scalars['String']>;
  /** Feed management data for the business service. */
  feedManagementData?: InputMaybe<Scalars['String']>;
  /** Whether or not feed management is enabled. */
  feedManagementEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not the feed management is requested. */
  feedManagementRequested?: InputMaybe<Scalars['Boolean']>;
  /** Fulfillment data for the business service. */
  fulfillmentData?: InputMaybe<Scalars['String']>;
  /** Whether or not fulfillment is enabled. */
  fulfillmentEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not fulfillment is requested. */
  fulfillmentRequested?: InputMaybe<Scalars['Boolean']>;
  /** Mcm data for the business service. */
  mcmData?: InputMaybe<Scalars['String']>;
  /** Whether or not mcm is enabled. */
  mcmEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not mcm is requested. */
  mcmRequested?: InputMaybe<Scalars['Boolean']>;
  /** The business name. */
  name: Scalars['String'];
  /** The organization id the business belongs to. */
  organizationId: Scalars['Int'];
  /** The phone number for the business. */
  phone?: InputMaybe<Scalars['String']>;
  /** The revenue for the business. */
  revenue?: InputMaybe<Scalars['String']>;
  /** The sales channel for the business. */
  salesChannel?: InputMaybe<Scalars['String']>;
  /** The shipHero Id for the business. */
  shipHeroId?: InputMaybe<Scalars['String']>;
  /** Storefront data for the business service. */
  storefrontData?: InputMaybe<Scalars['String']>;
  /** Whether or not storefront is enabled. */
  storefrontEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not storefront is requested. */
  storefrontRequested?: InputMaybe<Scalars['Boolean']>;
  /** Unified analytics data for the business service. */
  unifiedAnalyticsData?: InputMaybe<Scalars['String']>;
  /** Whether or not unified analytics is enabled. */
  unifiedAnalyticsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not unified analytics is requested. */
  unifiedAnalyticsRequested?: InputMaybe<Scalars['Boolean']>;
  /** The website for the business. */
  website?: InputMaybe<Scalars['String']>;
};

export type CreateEmailInput = {
  /** The email attachemnts. */
  attachments?: InputMaybe<Array<EmailAttachment>>;
  /** The SendGrind dynamic transactional template ID. */
  dynamicTemplateData?: InputMaybe<EmailTemplateVariables>;
  /** The address the email comes from. */
  from: FromEmail;
  /** The HTML representation of the body of the email. */
  html?: InputMaybe<Scalars['String']>;
  /** The subject of the email. */
  subject: Scalars['String'];
  /** The SendGrind dynamic transactional template ID. */
  templateId?: InputMaybe<Scalars['String']>;
  /** Choose from the standard template types. */
  templateType?: InputMaybe<TemplateType>;
  /** The text-only representation of the body of the email. */
  text?: InputMaybe<Scalars['String']>;
  /** The target email address. */
  to: Array<Scalars['String']>;
};

export type CreateLabelFromRateInput = {
  labelFileType?: InputMaybe<Scalars['String']>;
  rateObjectId: Scalars['String'];
};

export type CreateMerchantCommand = {
  accountID: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  markupPercent?: InputMaybe<Scalars['Decimal']>;
  merchantName: Scalars['String'];
  planLevel?: InputMaybe<Scalars['String']>;
  rechargeThreshold?: Scalars['Decimal'];
};

export type CreateMerchantLabelCommand = {
  labelRateInput: CreateLabelFromRateInput;
  merchantId: Scalars['String'];
};

export type CreateMerchantLabelSurchargeCommand = {
  amount: Scalars['Decimal'];
  currency: Scalars['String'];
  details: Scalars['String'];
  surchargeDate: Scalars['DateTime'];
  trackingNumber: Scalars['String'];
  type: Scalars['String'];
};

export type CreateMerchantRefundCommand = {
  merchantId: Scalars['String'];
  refundInput: CreateRefundInput;
};

export type CreateMerchantShipmentCommand = {
  createShipmentInput: CreateShipmentInput;
  merchantId: Scalars['String'];
};

export type CreateOrganizationInput = {
  /** Custom terminology for businesses in this organization. */
  businessEntityTerminology?: InputMaybe<Scalars['String']>;
  /** The name of the first business for this organization. This will create a business under this organization. */
  businessName?: InputMaybe<Scalars['String']>;
  /** The name of the organization. */
  name: Scalars['String'];
  /** The phone number for the organization. */
  phone?: InputMaybe<Scalars['String']>;
  /** The revenue for the organization. */
  revenue?: InputMaybe<Scalars['String']>;
  /** The sales channel for the organization. */
  salesChannel?: InputMaybe<Scalars['String']>;
  /** The name of the first sales channel for the business. This will create a sales channel under the first business. Note: You must have inputted a business name. */
  salesChannelName?: InputMaybe<Scalars['String']>;
  /** The shipHero id for the organization. */
  shipHeroId?: InputMaybe<Scalars['String']>;
  /** The website for the organization. */
  website?: InputMaybe<Scalars['String']>;
};

export type CreatePermissionInput = {
  /** An alternative name for the permission */
  alias?: InputMaybe<Scalars['String']>;
  /** The business the permission belongs to */
  businessId: Scalars['Int'];
  /** The name of the permission. */
  name: Scalars['String'];
  /** The organization the permission belongs to */
  organizationId: Scalars['Int'];
};

export type CreateRefundInput = {
  labelObjectId: Scalars['String'];
};

export type CreateRoleInput = {
  /** An alternative name for the role */
  alias?: InputMaybe<Scalars['String']>;
  /** The role description. */
  description?: InputMaybe<Scalars['String']>;
  /** A human-readable representation of the name to be displayed in the UI. */
  displayName: Scalars['String'];
  /** The name of the role. */
  name: Scalars['String'];
  /** The organization the role belongs to */
  organizationId: Scalars['Int'];
};

export type CreateSalesChannelInput = {
  /** The identity of the parent business. */
  businessId: Scalars['Int'];
  /** An indication that the sales channel has been deleted. */
  deleted?: InputMaybe<Scalars['DateTime']>;
  /** An indication that the sales channel has been disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** An explanation for why the sales channel has been disabled. */
  disabledReason?: InputMaybe<Scalars['String']>;
  /** The sales channel instance JSON data stringified. */
  instanceData?: InputMaybe<Scalars['String']>;
  /** The instance type of the saleschannel. */
  instanceType?: InputMaybe<InstanceType>;
  /** The name of the sales hannel. */
  name: Scalars['String'];
  /** The phone number for the sales channel. */
  phone?: InputMaybe<Scalars['String']>;
  /** The amount of revenue associated with the sales channel. */
  revenue?: InputMaybe<Scalars['String']>;
  /** The ShipHero ID for the sales channel. */
  shipHeroId?: InputMaybe<Scalars['String']>;
  /** The website for the sales channel. */
  website?: InputMaybe<Scalars['String']>;
};

/** The input for creating a service account. Note: The user creating this service account must also have the roles or permissions they are trying to assign to the service account being created. */
export type CreateServiceAccountInput = {
  /** The business id for the service account. */
  businessId?: InputMaybe<Scalars['Int']>;
  /** The organization id for the service account. */
  organizationId?: InputMaybe<Scalars['Int']>;
  /** The permission ids to give to the service account. */
  permissionIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The role ids to give to the service account. */
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The sales channel id for the service account. */
  salesChannelId?: InputMaybe<Scalars['Int']>;
  /** The shipHero id for the service account. */
  shipHeroId?: InputMaybe<Scalars['String']>;
};

export type CreateShipmentInput = {
  addressFrom: AddressInput;
  addressReturn?: InputMaybe<AddressInput>;
  addressTo: AddressInput;
  extra?: InputMaybe<ExtraInput>;
  parcels: Array<ParcelInput>;
  shipmentDate?: InputMaybe<Scalars['DateTime']>;
};

export type CreateUserInput = {
  /** Line 1 of the address for the user. */
  address1?: InputMaybe<Scalars['String']>;
  /** Line 2 of the address for the user. */
  address2?: InputMaybe<Scalars['String']>;
  /** The Auth0 ID of the user. */
  auth0Id: Scalars['String'];
  /** The city of the address for the user. */
  city?: InputMaybe<Scalars['String']>;
  /** The company for the user. */
  company?: InputMaybe<Scalars['String']>;
  /** The country of the address for the user. */
  country?: InputMaybe<Scalars['String']>;
  /** The default business a user will see when they log in. */
  defaultBusinessId?: InputMaybe<Scalars['Int']>;
  /** Whether or not a User record is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The reason a User record has been disabled. */
  disabledReason?: InputMaybe<Scalars['String']>;
  /** The first name the user. */
  firstName: Scalars['String'];
  /** The invitation expiration date of the user. */
  inviteExpiration?: InputMaybe<Scalars['DateTime']>;
  /** The invitation token for the user. */
  inviteToken?: InputMaybe<Scalars['String']>;
  /** The last name the user. */
  lastName: Scalars['String'];
  /** The phone number for the user. */
  phone?: InputMaybe<Scalars['String']>;
  /** The primary email of the user. */
  primaryEmail: Scalars['String'];
  /** The state of the address for the user. */
  state?: InputMaybe<Scalars['String']>;
  /** The date a User accepted the Terms of Service. */
  tosAccepted?: InputMaybe<Scalars['DateTime']>;
  /** The zip code of the address for the user. */
  zip?: InputMaybe<Scalars['String']>;
};

export type CustomFieldListItemModel = {
  customFieldId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CustomFieldModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<Scalars['String']>;
  fieldWidth?: InputMaybe<Scalars['Int']>;
  formatString?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  inputType?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  isMultiSelect?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  isVisibleAllStores?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  listItems?: InputMaybe<Array<InputMaybe<CustomFieldListItemModel>>>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  showOnOnePageCheckout?: InputMaybe<Scalars['Boolean']>;
  showOnOrderPage?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  stores?: InputMaybe<Array<InputMaybe<CustomFieldStoresModel>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  valueType?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<store_customFieldValueInput>>>;
};

export type CustomFieldStoresModel = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CustomFieldValueModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customFieldId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CustomerModel = {
  adcode?: InputMaybe<Scalars['String']>;
  adcodeId?: InputMaybe<Scalars['Int']>;
  addresses?: InputMaybe<Array<InputMaybe<AddressModel>>>;
  affiliateId?: InputMaybe<Scalars['Int']>;
  alternatePhoneNumber?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creditLimit?: InputMaybe<Scalars['Decimal']>;
  customFields?: InputMaybe<Array<InputMaybe<store_customFieldValueInputSimple>>>;
  customerNumber?: InputMaybe<Scalars['String']>;
  customerPaymentMethodsAvailability?: InputMaybe<Array<InputMaybe<CustomerPaymentMethodsAvailabilityModel>>>;
  customerTypeId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isAffiliateCustomer?: InputMaybe<Scalars['Boolean']>;
  isContactInformationOnly?: InputMaybe<Scalars['Boolean']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isNoTaxCustomer?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastVisitAt?: InputMaybe<Scalars['DateTime']>;
  lockDefaultAddress?: InputMaybe<Scalars['Boolean']>;
  noAccount?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  paymentNetTerm?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  registeredAt?: InputMaybe<Scalars['DateTime']>;
  rewardPoints?: InputMaybe<Array<InputMaybe<RewardPointsModel>>>;
  rewardTierId?: InputMaybe<Scalars['Int']>;
  salesPerson?: InputMaybe<Scalars['String']>;
  salesPersonUserID?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceGroup?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
  storePaymentMethodsEnabled?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sub?: InputMaybe<Scalars['String']>;
  taxExemptionNumber?: InputMaybe<Scalars['String']>;
  taxRate?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  username?: InputMaybe<Scalars['String']>;
};

export type CustomerPaymentFieldModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerPaymentMethodId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isEncrypted?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isValueMasked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CustomerPaymentMethodModel = {
  addressID?: InputMaybe<Scalars['Int']>;
  cardId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['Int']>;
  fields?: InputMaybe<Array<InputMaybe<CustomerPaymentFieldModel>>>;
  id?: InputMaybe<Scalars['Int']>;
  isDefault: Scalars['Boolean'];
  isNew?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerPaymentMethodsAvailabilityModel = {
  customerId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  storePaymentMethodId?: InputMaybe<Scalars['Int']>;
};

export type DeactivateMerchantCarrierCommand = {
  carrier: Scalars['String'];
  merchantId: Scalars['String'];
};

export type DeleteAuthMethodInput = {
  /** It's the authMethod. */
  authMethod: AuthMethodEnum;
  /** It's an email address. */
  email: Scalars['String'];
};

export type Email = {
  __typename?: 'Email';
  /** A field to determine if the mail was sent successfully. */
  success: Scalars['Boolean'];
};

export type EmailAttachment = {
  /** The Base64 encoded content of the attachment. */
  content: Scalars['String'];
  /** The attachment content ID. */
  contentId: Scalars['String'];
  /** The attachment content-disposition, specifying how to display content. */
  disposition: Scalars['String'];
  /** The filename of the attachment. */
  fileName: Scalars['String'];
  /** The MIME type of the attached content. */
  type: Scalars['String'];
};

export type EmailDFW = {
  /** The business the request is coming from */
  business?: InputMaybe<Scalars['String']>;
  /** Company/Organization */
  company?: InputMaybe<Scalars['String']>;
  /** email of requesting user */
  email?: InputMaybe<Scalars['String']>;
  /** Name of user signing up */
  fullName?: InputMaybe<Scalars['String']>;
  /** The organization the request is coming from */
  organization?: InputMaybe<Scalars['String']>;
  /** phone # of requesting use */
  phone?: InputMaybe<Scalars['String']>;
};

export type EmailTemplateVariables = {
  /** The first additional information field for the email body. */
  additionalInformation1?: InputMaybe<Scalars['String']>;
  /** The second additional information field for the email body. */
  additionalInformation2?: InputMaybe<Scalars['String']>;
  /** The text of the main email body CTA. */
  buttonText?: InputMaybe<Scalars['String']>;
  /** The URI of the main email body CTA. */
  buttonURI?: InputMaybe<Scalars['String']>;
  /** Short description for the email body. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Title for the email body. */
  title?: InputMaybe<Scalars['String']>;
};

export type ExtraInput = {
  insurance?: InputMaybe<InsuranceInput>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  boolValue: Scalars['Boolean'];
  intValue: Scalars['Int'];
  stringValue?: Maybe<Scalars['String']>;
};

export enum FeatureFlagTypeEnum {
  BOOL = 'BOOL',
  INT = 'INT',
  STRING = 'STRING'
}

export type FindBusinessByExternalCartId = {
  /** An MCM id. */
  mcmId?: InputMaybe<Scalars['Int']>;
};

/** The allowed FROM addresses approved in the Cart.com SendGrid account. */
export enum FromEmail {
  support = 'support'
}

export type GetBatchQuery = {
  batchId: Scalars['String'];
  merchantId: Scalars['String'];
};

export type GetFeatureFlagQuery = {
  flagType: FeatureFlagTypeEnum;
  key: Scalars['String'];
  userInfo?: InputMaybe<UserInfoInput>;
};

export type GetMerchantLabelListQuery = {
  merchantId: Scalars['String'];
  paginationOptions?: InputMaybe<paginationOptions>;
  purchaseDateAfter?: InputMaybe<Scalars['DateTime']>;
  purchaseDateBefore?: InputMaybe<Scalars['DateTime']>;
  unbilledOnly: Scalars['Boolean'];
};

export type GetMerchantLabelQuery = {
  labelId: Scalars['String'];
  merchantId: Scalars['String'];
};

export type GetMerchantRefundQuery = {
  merchantId: Scalars['String'];
  refundId: Scalars['String'];
};

export type GetMerchantShipmentQuery = {
  merchantId: Scalars['String'];
  shipmentId: Scalars['String'];
};

export type GetMerchantsListQuery = {
  lastBilledBefore?: InputMaybe<Scalars['DateTime']>;
};

export type GetProductInstanceInput = {
  /** ID of the business */
  businessId: Scalars['Int'];
  /** Instance Type for the business */
  instanceType: InstanceType;
};

export type GetRefundedLabelListQuery = {
  merchantId?: InputMaybe<Scalars['Int']>;
  noUpdate: Scalars['Boolean'];
  successesOnly: Scalars['Boolean'];
  unbilledOnly: Scalars['Boolean'];
};

export type Health = {
  __typename?: 'Health';
  /** The health status for the organization database. */
  database: Scalars['String'];
  /** The health status for the organization service. */
  service: Scalars['String'];
};

/** The type of the instance. */
export enum InstanceType {
  BRAND_CONSOLE = 'BRAND_CONSOLE',
  FEED_MARKETING = 'FEED_MARKETING',
  FULFILLMENT = 'FULFILLMENT',
  MCM = 'MCM',
  ORDERS = 'ORDERS',
  STOREFRONT = 'STOREFRONT',
  UNIFIED_ANALYTICS = 'UNIFIED_ANALYTICS'
}

export type InsuranceInput = {
  amount: Scalars['Decimal'];
  content: Scalars['String'];
  currency: Scalars['String'];
  provider: Scalars['String'];
};

/** The invite status. */
export enum InviteStatusEnum {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING'
}

export type InviteUserInput = {
  /** The id of the business for the user. */
  businessId?: InputMaybe<Scalars['Int']>;
  /** The organization for the user. */
  organizationId?: InputMaybe<Scalars['Int']>;
  /** The primary email(s) of the user(s) to be invited. */
  primaryEmails: Array<Scalars['String']>;
  /** The names of the roles the user will be. */
  roleNames: Array<Scalars['String']>;
};

export type Label = {
  __typename?: 'Label';
  billedInOrderId?: Maybe<Scalars['Int']>;
  billing?: Maybe<billing>;
  commercialInvoiceUrl?: Maybe<Scalars['String']>;
  datePaid?: Maybe<Scalars['DateTime']>;
  eta?: Maybe<Scalars['String']>;
  isRefunded: Scalars['Boolean'];
  labelId?: Maybe<Scalars['String']>;
  labelUrl?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['Int']>;
  messages?: Maybe<Array<Maybe<transactionMessage>>>;
  metadata?: Maybe<Scalars['String']>;
  objectCreated: Scalars['DateTime'];
  objectOwner?: Maybe<Scalars['String']>;
  objectState?: Maybe<Scalars['String']>;
  objectUpdated: Scalars['DateTime'];
  rate?: Maybe<rate>;
  rateObjectId?: Maybe<Scalars['String']>;
  refundCompletedDate?: Maybe<Scalars['DateTime']>;
  refundDate?: Maybe<Scalars['DateTime']>;
  refundObjectId?: Maybe<Scalars['String']>;
  refundStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  test: Scalars['Boolean'];
  trackingNumber?: Maybe<Scalars['String']>;
  trackingStatus?: Maybe<Scalars['String']>;
  trackingUrlProvider?: Maybe<Scalars['String']>;
};

export enum LabelFileTypeEnum {
  PDF = 'PDF',
  PDFA_4 = 'PDFA_4',
  PDFA_6 = 'PDFA_6',
  PDF_4_X_6 = 'PDF_4_X_6',
  PDF_4_X_8 = 'PDF_4_X_8',
  PDF_23_X_75 = 'PDF_23_X_75',
  PNG = 'PNG',
  PNG_23_X_75 = 'PNG_23_X_75',
  ZPLII = 'ZPLII'
}

export type LabelSurcharge = {
  __typename?: 'LabelSurcharge';
  amount: Scalars['Decimal'];
  billedInOrderId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  datePaid?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  surchargeDate: Scalars['DateTime'];
  trackingNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** The time that Auth0 says the user last changed their password. */
export type LastPasswordReset = {
  __typename?: 'LastPasswordReset';
  /** When the user's password was last changed. */
  passwordLastResetAt?: Maybe<Scalars['DateTime']>;
};

export type ListProductInstanceInput = {
  /** ID of the business */
  businessId: Scalars['Int'];
};

export type ListProductInstanceOrgInput = {
  /** Instance Type to filter by */
  instanceType?: InputMaybe<InstanceType>;
  /** ID of the organization */
  organizationId: Scalars['Int'];
};

export type ManufacturerModel = {
  brandCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  headTags?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  manufacturerLogoUrl?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlRewrite?: InputMaybe<Scalars['String']>;
};

export type Me = {
  __typename?: 'Me';
  /** The ServiceAccount object for the requesting user. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** The User object for the requesting user. */
  user?: Maybe<User>;
};

export type Member = {
  __typename?: 'Member';
  /** The Auth0 ID of the user. */
  auth0Id?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']>;
  /** The id of the user */
  id: Scalars['Int'];
  /** The invite associated with the member's role */
  invite?: Maybe<UserInvite>;
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']>;
  /** The primary email of the user. */
  primaryEmail: Scalars['String'];
  /** The Role the user has for the business */
  role: Role;
  /** The status of the member calculated based on assignedRole invite statuses for the user's role */
  status: Scalars['String'];
};

export type Merchant = {
  __typename?: 'Merchant';
  accountID: Scalars['Int'];
  apiToken?: Maybe<Scalars['String']>;
  carrierAccounts?: Maybe<Array<Maybe<CarrierAccount>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inactivationDate?: Maybe<Scalars['DateTime']>;
  inactivationReason?: Maybe<Scalars['String']>;
  isInActive: Scalars['Boolean'];
  labelCount?: Maybe<Scalars['Int']>;
  labelSurcharges?: Maybe<Array<Maybe<LabelSurcharge>>>;
  labels?: Maybe<Array<Maybe<Label>>>;
  lastInvoicePaid?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  markupPercent?: Maybe<Scalars['Decimal']>;
  merchantId?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
  objectCreated: Scalars['DateTime'];
  objectUpdated: Scalars['DateTime'];
  openBalance?: Maybe<Scalars['Decimal']>;
  platformId?: Maybe<Scalars['String']>;
  rechargeThreshold: Scalars['Decimal'];
};


export type MerchantlabelSurchargesArgs = {
  filter?: InputMaybe<MerchantLabelSurchargesFilter>;
};


export type MerchantlabelsArgs = {
  filter?: InputMaybe<MerchantLabelsFilter>;
};

export type MerchantLabelSurchargesFilter = {
  unbilledOnly: Scalars['Boolean'];
};

export type MerchantLabelsFilter = {
  unbilledOnly: Scalars['Boolean'];
};

/** MFA Data for a Cart user record / Confirm Enrollment Response. */
export type MfaData = {
  __typename?: 'MfaData';
  /** The MFA Access token for a user */
  access_token: Scalars['String'];
  /** Duration of the MFA access token. */
  expires_in?: Maybe<Scalars['Int']>;
  /** Scopes enabled for the token */
  scope?: Maybe<Scalars['String']>;
  /** The type of token provided */
  token_type?: Maybe<Scalars['String']>;
};

export type MfaDataInput = {
  /** The password for the user. */
  password: Scalars['String'];
  /** The username for the user. */
  username: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  comm_sendTemplateEmail: Email;
  /** Disables Integration for Amazon channels */
  mcm_disableIntegration: Scalars['Boolean'];
  mcm_emailSubscriptionUpdate?: Maybe<Array<Maybe<mcm_emailSubscription>>>;
  /** Queues a job to run immediately. */
  mcm_jobQueue?: Maybe<mcm_QueueJobPayload>;
  /** Updates a job schedule or adds a new one. This will be used by the job scheduler. */
  mcm_jobScheduleUpsert?: Maybe<mcm_jobSchedule>;
  mcm_orderCreate?: Maybe<mcm_CreateOrderPayload>;
  /** Updates the ship to address for a MCM order. Must contain the id of the order that is to be updated */
  mcm_orderShippingAddressUpdate?: Maybe<mcm_ShippingAddressPayload>;
  mcm_productRemove?: Maybe<mcm_DeleteProductPayload>;
  mcm_vendorRemove?: Maybe<mcm_RemoveVendorPayload>;
  mcm_vendorUpsert?: Maybe<mcm_UpsertVendorPayload>;
  /**
   * Create/Update a product instance for a business.
   * @deprecated Use org_productInstanceUpsert instead.
   */
  org_ProductInstanceUpsert: ProductInstance;
  /** Create a new assiged permission, associates a permission with a user, service account, or role. */
  org_assignedPermissionCreate: AssignedPermission;
  /** Removes an assigned permission from a user. */
  org_assignedPermissionDelete: AssignedPermission;
  /** Create a new assiged role, associates a role with a user, service account, or role. */
  org_assignedRoleCreate: AssignedRole;
  /** Removes one or more assigned roles from a user. */
  org_assignedRoleDelete: Array<AssignedRole>;
  /** Adds an auth method to a user. */
  org_authMethodsCreate: AuthMethod;
  /** Removes an auth method for a user. */
  org_authMethodsDelete: AuthMethod;
  /** Creates a business. */
  org_businessCreate: Business;
  /** Deletes a business. */
  org_businessDelete: Business;
  /** Removes all assigned roles and assigned permissions to users in a given business. */
  org_businessRemoveUser: Array<User>;
  /** Updates a business. */
  org_businessUpdate: Business;
  /**
   * Create/Update a product instance for a business.
   * @deprecated Use org_ProductInstanceUpsert instead.
   */
  org_businessUpsertProductInstance: ProductInstance;
  /** Sends an email to product operations with user details */
  org_emailDFW: Scalars['String'];
  /** Creates an organization. */
  org_organizationCreate: Organization;
  /** Deletes an organization. */
  org_organizationDelete: Organization;
  /** Removes all roles assigned to users in a given organization. */
  org_organizationRemoveUser: Array<User>;
  /** Updates an organization. */
  org_organizationUpdate: Organization;
  /** Creates a permission. */
  org_permissionCreate: Permission;
  /** Deletes a permission. */
  org_permissionDelete: Permission;
  /** Updates a permission. */
  org_permissionUpdate: Permission;
  /** Create/Update a product instance for a business. */
  org_productInstanceUpsert: ProductInstance;
  /** Registers a new user by both generating an Auth0 user and creating a Cart User object. */
  org_registerUser: User;
  /** Creates a role. */
  org_roleCreate: Role;
  /** Deletes a role. */
  org_roleDelete: Role;
  /** Updates a role. */
  org_roleUpdate: Role;
  /** Creates a sales channel. */
  org_salesChannelCreate: SalesChannel;
  /** Deletes a sales channel. */
  org_salesChannelDelete: SalesChannel;
  /** Removes all assigned roles and assigned permissions to users in a given salesChannel. */
  org_salesChannelRemoveUser: Array<User>;
  /** Updates a sales channel */
  org_salesChannelUpdate: SalesChannel;
  /** Creates a service account. */
  org_serviceAccountCreate: ServiceAccount;
  /** Deletes a service account. */
  org_serviceAccountDelete: ServiceAccount;
  /** Logout the user. */
  org_sessionEnd: Session;
  /** Register the user. */
  org_sessionRegister: Session;
  /** Login the user. */
  org_sessionStart: Session;
  /** Upsert a user app setting */
  org_userAppSettingUpsert: UserAppSetting;
  /** Returns a Canny redirect url with a signed JWT */
  org_userCannySso: Scalars['String'];
  /** Allows a user to change their own password. */
  org_userChangeOwnPassword: User;
  /** Allows a user with the proper permissions to change another user password. */
  org_userChangePassword: User;
  /** Confirms Mfa Enrollment for a User */
  org_userConfirmMfaEnrollment: MfaData;
  /** Consumes a user invite. */
  org_userConsumeInvite: User;
  /** Creates a user. */
  org_userCreate: User;
  /** Deletes one or more user. */
  org_userDelete: Array<User>;
  /** Permanently deletes one or more users. */
  org_userDeleteHard: Scalars['String'];
  /** Invites one ore more new user(s). */
  org_userInvite: Array<UserInvite>;
  /** Remove the user's MFA authenticators */
  org_userMfaDelete: Scalars['Boolean'];
  /** Kick off a reset password user on behalf of another user (superadmin/CSR only) */
  org_userResetPassword: User;
  /** resends a verification email to the provided user email. */
  org_userSendVerificationEmail: User;
  /** Toggles user_metadata use_mfa */
  org_userToggleMfa: ToggleMfaData;
  /** Unblock a user that was blocked due to an excessive amount of incorrectly provided credentials */
  org_userUnblock: User;
  /** Updates a user. */
  org_userUpdate: User;
  shipping_batchCreate?: Maybe<Batch>;
  shipping_batchPurchase?: Maybe<Batch>;
  shipping_completeLabelRefunds?: Maybe<Array<Maybe<Label>>>;
  shipping_merchantAccountUpdate?: Maybe<Merchant>;
  shipping_merchantBalanceUpdate?: Maybe<Merchant>;
  shipping_merchantCarrierActivate?: Maybe<CarrierAccount>;
  shipping_merchantCarrierDeactivate?: Maybe<CarrierAccount>;
  shipping_merchantCreate?: Maybe<Merchant>;
  shipping_merchantLabelCreate?: Maybe<Label>;
  shipping_merchantLabelSurchargeCreate?: Maybe<LabelSurcharge>;
  shipping_merchantRefundCreate: Refund;
  shipping_merchantShipmentCreate: Shipment;
  shipping_merchantUpdate?: Maybe<Merchant>;
  store_OrderPaymentCreate: store_orderPayment;
  store_OrderPaymentDelete: store_deleteMessage;
  store_OrderPaymentUpdate: store_orderPayment;
  store_attributeCreate: store_attribute;
  store_attributeDelete: store_deleteMessage;
  store_attributeGroupCreate: store_attributeGroup;
  store_attributeGroupDelete: store_deleteMessage;
  store_attributeGroupUpdate: store_attributeGroup;
  store_attributeUpdate: store_attribute;
  store_categoriesDelete: store_deleteMessage;
  store_categoryCreate: store_categories;
  store_categoryUpdate: store_categories;
  store_customFieldCreate: store_customField;
  store_customFieldDelete: store_deleteMessage;
  store_customFieldUpdate: store_customField;
  store_customFieldValueCreate: store_customFieldValue;
  store_customFieldValueDelete: store_deleteMessage;
  store_customFieldValueUpdate: store_customFieldValue;
  store_customerCreate: store_customer;
  store_customerDelete: store_deleteMessage;
  store_customerUpdate: store_customer;
  store_inventoryAdd: store_changeInventory;
  store_inventoryRemove: store_changeInventory;
  store_inventorySet: store_changeInventory;
  store_manufacturerCreate: store_manufacturer;
  store_manufacturerDelete: store_deleteMessage;
  store_manufacturerUpdate: store_manufacturer;
  store_orderAddressCreate: store_orderAddress;
  store_orderAddressDelete: store_deleteMessage;
  store_orderAddressUpdate: store_orderAddress;
  store_orderCreate: store_order;
  store_orderDelete: store_deleteMessage;
  store_orderItemCreate: store_orderItem;
  store_orderItemDelete: store_deleteMessage;
  store_orderItemUpdate: store_orderItem;
  store_orderShippingCreate: store_orderShipping;
  store_orderShippingDelete: store_deleteMessage;
  store_orderShippingUpdate: store_orderShipping;
  store_orderStatusCreate: store_orderStatus;
  store_orderStatusDelete: store_deleteMessage;
  store_orderStatusUpdate: store_orderStatus;
  store_orderUpdate: store_order;
  store_productCreate: store_product;
  store_productDelete: store_deleteMessage;
  store_productImportMany: store_postManyResult;
  store_productStatusCreate: store_productStatus;
  store_productStatusDelete: store_deleteMessage;
  store_productStatusUpdate: store_productStatus;
  store_productUpdate: store_product;
  store_productVariantCreate: store_productVariant;
  store_productVariantDelete: store_deleteMessage;
  store_productVariantGroupCreate: store_productVariantGroup;
  store_productVariantGroupDelete: store_deleteMessage;
  store_productVariantGroupUpdate: store_productVariantGroup;
  store_productVariantUpdate: store_productVariant;
  store_quoteCreate: store_quote;
  store_quoteDelete: store_deleteMessage;
  store_quoteUpdate: store_quote;
  store_subscriptionCreate: store_subscription;
  store_subscriptionDelete: store_deleteMessage;
  store_subscriptionUpdate: store_subscription;
  store_variantInventoryCreate: store_variantInventory;
  store_variantInventoryDelete: store_deleteMessage;
  store_variantInventoryUpdate: store_variantInventory;
};


export type Mutationcomm_sendTemplateEmailArgs = {
  sendTemplateEmailArgs: CreateEmailInput;
};


export type Mutationmcm_disableIntegrationArgs = {
  arguments?: InputMaybe<mcm_DisableIntegrationInput>;
};


export type Mutationmcm_emailSubscriptionUpdateArgs = {
  arguments?: InputMaybe<mcm_UpdateEmailSubscriptionInput>;
};


export type Mutationmcm_jobQueueArgs = {
  input?: InputMaybe<mcm_QueueJobInput>;
};


export type Mutationmcm_jobScheduleUpsertArgs = {
  input?: InputMaybe<mcm_UpsertJobScheduleInput>;
};


export type Mutationmcm_orderCreateArgs = {
  arguments?: InputMaybe<mcm_CreateOrderInput>;
};


export type Mutationmcm_orderShippingAddressUpdateArgs = {
  arguments?: InputMaybe<mcm_shippingAddressUpdateInput>;
};


export type Mutationmcm_productRemoveArgs = {
  arguments?: InputMaybe<mcm_RemoveProductInput>;
};


export type Mutationmcm_vendorRemoveArgs = {
  arguments?: InputMaybe<mcm_RemoveVendorInput>;
};


export type Mutationmcm_vendorUpsertArgs = {
  arguments?: InputMaybe<mcm_UpsertVendorInput>;
};


export type Mutationorg_ProductInstanceUpsertArgs = {
  upsertProductInstanceInput: UpsertProductInstanceInput;
};


export type Mutationorg_assignedPermissionCreateArgs = {
  createAssignedPermissionInput: CreateAssignedPermissionInput;
};


export type Mutationorg_assignedPermissionDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationorg_assignedRoleCreateArgs = {
  createAssignedroleInput: CreateAssignedRoleInput;
};


export type Mutationorg_assignedRoleDeleteArgs = {
  ids: Array<Scalars['Int']>;
};


export type Mutationorg_authMethodsCreateArgs = {
  input: CreateAuthMethodInput;
};


export type Mutationorg_authMethodsDeleteArgs = {
  input: DeleteAuthMethodInput;
};


export type Mutationorg_businessCreateArgs = {
  createBusinessInput: CreateBusinessInput;
};


export type Mutationorg_businessDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationorg_businessRemoveUserArgs = {
  businessId: Scalars['Int'];
  userIds: Array<Scalars['Int']>;
};


export type Mutationorg_businessUpdateArgs = {
  updateBusinessInput: UpdateBusinessInput;
};


export type Mutationorg_businessUpsertProductInstanceArgs = {
  upsertProductInstanceInput: UpsertProductInstanceInput;
};


export type Mutationorg_emailDFWArgs = {
  emailDFW: EmailDFW;
};


export type Mutationorg_organizationCreateArgs = {
  createOrganizationInput: CreateOrganizationInput;
};


export type Mutationorg_organizationDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationorg_organizationRemoveUserArgs = {
  organizationId: Scalars['Int'];
  userIds: Array<Scalars['Int']>;
};


export type Mutationorg_organizationUpdateArgs = {
  updateOrganizationInput: UpdateOrganizationInput;
};


export type Mutationorg_permissionCreateArgs = {
  createPermissionInput: CreatePermissionInput;
};


export type Mutationorg_permissionDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationorg_permissionUpdateArgs = {
  updatePermissionInput: UpdatePermissionInput;
};


export type Mutationorg_productInstanceUpsertArgs = {
  upsertProductInstanceInput: UpsertProductInstanceInput;
};


export type Mutationorg_registerUserArgs = {
  registerUserInput: RegisterUserInput;
};


export type Mutationorg_roleCreateArgs = {
  createRoleInput: CreateRoleInput;
};


export type Mutationorg_roleDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationorg_roleUpdateArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type Mutationorg_salesChannelCreateArgs = {
  createSalesChannelInput: CreateSalesChannelInput;
};


export type Mutationorg_salesChannelDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationorg_salesChannelRemoveUserArgs = {
  salesChannelId: Scalars['Int'];
  userIds: Array<Scalars['Int']>;
};


export type Mutationorg_salesChannelUpdateArgs = {
  updateSalesChannelInput: UpdateSalesChannelInput;
};


export type Mutationorg_serviceAccountCreateArgs = {
  createServiceAccountInput: CreateServiceAccountInput;
};


export type Mutationorg_serviceAccountDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationorg_sessionRegisterArgs = {
  input: SessionRegisterInput;
};


export type Mutationorg_sessionStartArgs = {
  input: SessionStartInput;
};


export type Mutationorg_userAppSettingUpsertArgs = {
  input: UpsertUserAppSettingInput;
};


export type Mutationorg_userChangeOwnPasswordArgs = {
  input: ChangeOwnPasswordInput;
};


export type Mutationorg_userChangePasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type Mutationorg_userConfirmMfaEnrollmentArgs = {
  confirmEnrollmentInput: ConfirmMfaEnrollmentInput;
};


export type Mutationorg_userConsumeInviteArgs = {
  consumeInviteUserInput: ConsumeInviteUserInput;
};


export type Mutationorg_userCreateArgs = {
  createUserInput: CreateUserInput;
};


export type Mutationorg_userDeleteArgs = {
  id: Array<Scalars['Int']>;
};


export type Mutationorg_userDeleteHardArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type Mutationorg_userInviteArgs = {
  inviteUserInput: InviteUserInput;
};


export type Mutationorg_userResetPasswordArgs = {
  userEmail: Scalars['String'];
};


export type Mutationorg_userSendVerificationEmailArgs = {
  auth0Sub: Scalars['String'];
};


export type Mutationorg_userToggleMfaArgs = {
  toggleUserMfaInput: ToggleUserMfaInput;
};


export type Mutationorg_userUnblockArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type Mutationorg_userUpdateArgs = {
  updateUserInput: UpdateUserInput;
};


export type Mutationshipping_batchCreateArgs = {
  batchInput: CreateBatchCommand;
};


export type Mutationshipping_batchPurchaseArgs = {
  batchPurchaseInput: PurchaseCommand;
};


export type Mutationshipping_completeLabelRefundsArgs = {
  completeLabelRefundInput: CompleteLabelRefundCommand;
};


export type Mutationshipping_merchantAccountUpdateArgs = {
  merchantInput: UpdateMerchantAccountCommand;
};


export type Mutationshipping_merchantBalanceUpdateArgs = {
  updateMerchantBalanceInput: UpdateMerchantBalanceCommand;
};


export type Mutationshipping_merchantCarrierActivateArgs = {
  input: ActivateMerchantCarrierCommand;
};


export type Mutationshipping_merchantCarrierDeactivateArgs = {
  input: DeactivateMerchantCarrierCommand;
};


export type Mutationshipping_merchantCreateArgs = {
  merchantInput: CreateMerchantCommand;
};


export type Mutationshipping_merchantLabelCreateArgs = {
  labelInput: CreateMerchantLabelCommand;
};


export type Mutationshipping_merchantLabelSurchargeCreateArgs = {
  input: CreateMerchantLabelSurchargeCommand;
};


export type Mutationshipping_merchantRefundCreateArgs = {
  refundInput: CreateMerchantRefundCommand;
};


export type Mutationshipping_merchantShipmentCreateArgs = {
  shipmentInput: CreateMerchantShipmentCommand;
};


export type Mutationshipping_merchantUpdateArgs = {
  merchantInput: UpdateMerchantCommand;
};


export type Mutationstore_OrderPaymentCreateArgs = {
  orderPayment: OrderPaymentModel;
};


export type Mutationstore_OrderPaymentDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_OrderPaymentUpdateArgs = {
  id: Scalars['Int'];
  orderPayment: OrderPaymentModel;
};


export type Mutationstore_attributeCreateArgs = {
  attribute: AttributeModel;
};


export type Mutationstore_attributeDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_attributeGroupCreateArgs = {
  attributeGroup: AttributeGroupModel;
};


export type Mutationstore_attributeGroupDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_attributeGroupUpdateArgs = {
  attributeGroup: AttributeGroupModel;
  id: Scalars['Int'];
};


export type Mutationstore_attributeUpdateArgs = {
  attribute: AttributeModel;
  id: Scalars['Int'];
};


export type Mutationstore_categoriesDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_categoryCreateArgs = {
  category: CategoryModel;
};


export type Mutationstore_categoryUpdateArgs = {
  category: CategoryModel;
  id: Scalars['Int'];
};


export type Mutationstore_customFieldCreateArgs = {
  customField: CustomFieldModel;
};


export type Mutationstore_customFieldDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_customFieldUpdateArgs = {
  customField: CustomFieldModel;
  id: Scalars['Int'];
};


export type Mutationstore_customFieldValueCreateArgs = {
  customFieldValue: CustomFieldValueModel;
};


export type Mutationstore_customFieldValueDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_customFieldValueUpdateArgs = {
  customFieldValue: CustomFieldValueModel;
  id: Scalars['Int'];
};


export type Mutationstore_customerCreateArgs = {
  customer: CustomerModel;
};


export type Mutationstore_customerDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_customerUpdateArgs = {
  customer: CustomerModel;
  id: Scalars['Int'];
};


export type Mutationstore_inventoryAddArgs = {
  changeInventoryOptions: ChangeInventoryModel;
};


export type Mutationstore_inventoryRemoveArgs = {
  changeInventoryOptions: ChangeInventoryModel;
};


export type Mutationstore_inventorySetArgs = {
  changeInventoryOptions: ChangeInventoryModel;
};


export type Mutationstore_manufacturerCreateArgs = {
  manufacturer: ManufacturerModel;
};


export type Mutationstore_manufacturerDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_manufacturerUpdateArgs = {
  id: Scalars['Int'];
  manufacturer: ManufacturerModel;
};


export type Mutationstore_orderAddressCreateArgs = {
  orderAddress: OrderAddressModel;
};


export type Mutationstore_orderAddressDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_orderAddressUpdateArgs = {
  id: Scalars['Int'];
  orderAddress: OrderAddressModel;
};


export type Mutationstore_orderCreateArgs = {
  order: OrderModel;
};


export type Mutationstore_orderDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_orderItemCreateArgs = {
  orderItem: OrderItemModel;
};


export type Mutationstore_orderItemDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_orderItemUpdateArgs = {
  id: Scalars['Int'];
  orderItem: OrderItemModel;
};


export type Mutationstore_orderShippingCreateArgs = {
  orderShipping: OrderShippingModel;
};


export type Mutationstore_orderShippingDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_orderShippingUpdateArgs = {
  id: Scalars['Int'];
  orderShipping: OrderShippingModel;
};


export type Mutationstore_orderStatusCreateArgs = {
  orderStatus: OrderStatusModel;
};


export type Mutationstore_orderStatusDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_orderStatusUpdateArgs = {
  id: Scalars['Int'];
  orderStatus: OrderStatusModel;
};


export type Mutationstore_orderUpdateArgs = {
  id: Scalars['Int'];
  order: OrderModel;
};


export type Mutationstore_productCreateArgs = {
  product: ProductModel;
};


export type Mutationstore_productDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_productImportManyArgs = {
  products?: InputMaybe<Array<InputMaybe<ProductImportModel>>>;
};


export type Mutationstore_productStatusCreateArgs = {
  productStatus: ProductStatusModel;
};


export type Mutationstore_productStatusDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_productStatusUpdateArgs = {
  id: Scalars['Int'];
  productStatus: ProductStatusModel;
};


export type Mutationstore_productUpdateArgs = {
  id: Scalars['Int'];
  product: ProductModel;
};


export type Mutationstore_productVariantCreateArgs = {
  productVariant: ProductVariantModel;
};


export type Mutationstore_productVariantDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_productVariantGroupCreateArgs = {
  productVariantGroup: ProductVariantGroupModel;
};


export type Mutationstore_productVariantGroupDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_productVariantGroupUpdateArgs = {
  id: Scalars['Int'];
  productVariantGroup: ProductVariantGroupModel;
};


export type Mutationstore_productVariantUpdateArgs = {
  id: Scalars['Int'];
  productVariant: ProductVariantModel;
};


export type Mutationstore_quoteCreateArgs = {
  quote: QuoteModel;
};


export type Mutationstore_quoteDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_quoteUpdateArgs = {
  id: Scalars['Int'];
  quote: QuoteModel;
};


export type Mutationstore_subscriptionCreateArgs = {
  subscription: SubscriptionModel;
};


export type Mutationstore_subscriptionDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_subscriptionUpdateArgs = {
  id: Scalars['Int'];
  subscription: SubscriptionModel;
};


export type Mutationstore_variantInventoryCreateArgs = {
  variantInventory: VariantInventoryModel;
};


export type Mutationstore_variantInventoryDeleteArgs = {
  id: Scalars['Int'];
};


export type Mutationstore_variantInventoryUpdateArgs = {
  id: Scalars['Int'];
  variantInventory: VariantInventoryModel;
};

export type OrderAddressModel = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  alternatePhone?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['Int']>;
  fax?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OrderItemModel = {
  adminComments?: InputMaybe<Scalars['String']>;
  configuration?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  doNotDiscount?: InputMaybe<Scalars['Boolean']>;
  fitment?: InputMaybe<Scalars['String']>;
  giftMessage?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isDiscountItem?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isNonShippingItem?: InputMaybe<Scalars['Boolean']>;
  isQuantityBoundToParent?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionProduct?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  itemName?: InputMaybe<Scalars['String']>;
  itemNumber?: InputMaybe<Scalars['String']>;
  itemNumberFull?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Decimal']>;
  lineItemNote?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  orderShippingAddressId?: InputMaybe<Scalars['Int']>;
  parentOrderItemId?: InputMaybe<Scalars['Int']>;
  personalizations?: InputMaybe<Array<InputMaybe<OrderItemPersonalizationModel>>>;
  price?: InputMaybe<Scalars['Decimal']>;
  productId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedShippingMethod?: InputMaybe<Scalars['String']>;
  selectedShippingMethodId?: InputMaybe<Scalars['Int']>;
  selectedShippingProviderService?: InputMaybe<Scalars['String']>;
  shippingClassificationCode?: InputMaybe<Scalars['String']>;
  shippingTotal?: InputMaybe<Scalars['Decimal']>;
  sizeUnit?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['Decimal']>;
  taxCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantInventoryID?: InputMaybe<Scalars['Int']>;
  variants?: InputMaybe<Array<InputMaybe<OrderItemVariantModel>>>;
  vendorStoreId?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightUnit?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

export type OrderItemPersonalizationModel = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type OrderItemVariantModel = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  variantGroupId?: InputMaybe<Scalars['Int']>;
};

export type OrderModel = {
  adcode?: InputMaybe<Scalars['String']>;
  adcodeId?: InputMaybe<Scalars['Int']>;
  additionalFees?: InputMaybe<Scalars['Decimal']>;
  adminComments?: InputMaybe<Scalars['String']>;
  affiliateId?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<OrderAddressModel>;
  campaignCode?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  costTotal?: InputMaybe<Scalars['Decimal']>;
  couponCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customFields?: InputMaybe<Array<InputMaybe<store_customFieldValueInputSimple>>>;
  customer?: InputMaybe<CustomerModel>;
  customerId?: InputMaybe<Scalars['Int']>;
  customerTypeId?: InputMaybe<Scalars['Int']>;
  deliveryTax?: InputMaybe<Scalars['Decimal']>;
  device?: InputMaybe<Scalars['String']>;
  discountTotal?: InputMaybe<Scalars['Decimal']>;
  discountedShippingTotal?: InputMaybe<Scalars['Decimal']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  enteredBy?: InputMaybe<Scalars['String']>;
  enteredByType?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Boolean']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  exportedToAccountingSystem?: InputMaybe<Scalars['Int']>;
  fromQuoteId?: InputMaybe<Scalars['Int']>;
  fromSubscriptionId?: InputMaybe<Scalars['Int']>;
  giftMessage?: InputMaybe<Scalars['String']>;
  grandTotal?: InputMaybe<Scalars['Decimal']>;
  handlingTotal?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isPaymentOrderOnly?: InputMaybe<Scalars['Boolean']>;
  isPpc?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<OrderItemModel>>>;
  manufacturerInvoiceAmount?: InputMaybe<Scalars['Decimal']>;
  manufacturerInvoiceNumber?: InputMaybe<Scalars['String']>;
  manufacturerInvoicePaid?: InputMaybe<Scalars['Boolean']>;
  orderBillingAddressId?: InputMaybe<Scalars['Int']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderShippingAddressId?: InputMaybe<Scalars['Int']>;
  orderStatus?: InputMaybe<OrderStatusModel>;
  orderStatusId?: InputMaybe<Scalars['Int']>;
  orderStatusLastChangedAt?: InputMaybe<Scalars['DateTime']>;
  orderType?: InputMaybe<Scalars['String']>;
  orderedAt?: InputMaybe<Scalars['DateTime']>;
  payments?: InputMaybe<Array<InputMaybe<OrderPaymentModel>>>;
  ppcKeyword?: InputMaybe<Scalars['String']>;
  previousOrderStatusId?: InputMaybe<Scalars['Int']>;
  publicComments?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
  rewardPointsCredited?: InputMaybe<Scalars['Boolean']>;
  salesAgentUserID?: InputMaybe<Scalars['Int']>;
  searchPhrase?: InputMaybe<Scalars['String']>;
  selectedShippingMethod?: InputMaybe<Scalars['String']>;
  selectedShippingProviderService?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  shipments?: InputMaybe<Array<InputMaybe<OrderShippingModel>>>;
  shippingAddress?: InputMaybe<OrderAddressModel>;
  shippingSelections?: InputMaybe<Array<InputMaybe<OrderShippingSelectionsModel>>>;
  shippingTotal?: InputMaybe<Scalars['Decimal']>;
  source?: InputMaybe<Scalars['String']>;
  sourceGroup?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Decimal']>;
  taxTotal?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OrderPaymentFieldModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isEncrypted?: InputMaybe<Scalars['Boolean']>;
  isMasked?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderPaymentId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OrderPaymentModel = {
  amount?: InputMaybe<Scalars['Decimal']>;
  approvedAt?: InputMaybe<Scalars['String']>;
  authorizationCode?: InputMaybe<Scalars['String']>;
  avsCode?: InputMaybe<Scalars['String']>;
  cardExpirationMonth: Scalars['Int'];
  cardExpirationYear: Scalars['Int'];
  cardNumber?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<Scalars['String']>;
  cardholderName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['Int']>;
  customerPaymentMethodId?: InputMaybe<Scalars['Int']>;
  cvv?: InputMaybe<Scalars['String']>;
  cvvResponseCode?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<InputMaybe<OrderPaymentFieldModel>>>;
  gatewayResponseCode?: InputMaybe<Scalars['String']>;
  giftCertificateId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isCaptured?: InputMaybe<Scalars['Boolean']>;
  isDeclined?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isVoid?: InputMaybe<Scalars['Boolean']>;
  lastFour?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  paidAt?: InputMaybe<Scalars['DateTime']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  paymentMethodName?: InputMaybe<Scalars['String']>;
  paymentNote?: InputMaybe<Scalars['String']>;
  paymentRefNum?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  sentToSparkPay?: InputMaybe<Scalars['Boolean']>;
  storePaymentMethodId?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OrderShippingModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  emailSent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<OrderShippingOrderItemsModel>>>;
  numberOfPackages?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['Int']>;
  privateComment?: InputMaybe<Scalars['String']>;
  providerBaseShippingCost?: InputMaybe<Scalars['String']>;
  providerHandlingCost?: InputMaybe<Scalars['Decimal']>;
  providerInsuranceCost?: InputMaybe<Scalars['Decimal']>;
  providerOtherCharges?: InputMaybe<Scalars['Decimal']>;
  providerTotalShippingCost?: InputMaybe<Scalars['Decimal']>;
  shipmentName?: InputMaybe<Scalars['String']>;
  shippedAt?: InputMaybe<Scalars['DateTime']>;
  shippingComment?: InputMaybe<Scalars['String']>;
  shippingMethod?: InputMaybe<Scalars['String']>;
  shippingMethodId?: InputMaybe<Scalars['Int']>;
  shippingMethodType?: InputMaybe<Scalars['String']>;
  shippingProviderName?: InputMaybe<Scalars['String']>;
  totalWeight?: InputMaybe<Scalars['Decimal']>;
  trackingNumbers?: InputMaybe<Scalars['String']>;
  trackingUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OrderShippingOrderItemsModel = {
  id?: InputMaybe<Scalars['Int']>;
  itemName?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  quantityShipped?: InputMaybe<Scalars['Int']>;
};

export type OrderShippingSelectionsModel = {
  classificationCode?: InputMaybe<Scalars['String']>;
  shippingMethod?: InputMaybe<Scalars['String']>;
  shippingProvider?: InputMaybe<Scalars['String']>;
};

export type OrderStatusModel = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  emailTemplateId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isCancelled?: InputMaybe<Scalars['Boolean']>;
  isDeclined?: InputMaybe<Scalars['Boolean']>;
  isFullyRefunded?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  isPartiallyRefunded?: InputMaybe<Scalars['Boolean']>;
  isPartiallyShipped?: InputMaybe<Scalars['Boolean']>;
  isQuoteStatus?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** A Cart organization record. */
export type Organization = {
  __typename?: 'Organization';
  /** Assigned roles that belong to the organization. */
  assignedRoles?: Maybe<Array<AssignedRole>>;
  /** Custom terminology for the businesses in this organization. */
  businessEntityTerminology?: Maybe<Scalars['String']>;
  /** The businesses that belong to the organization. */
  businesses?: Maybe<Array<Business>>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the record. */
  id: Scalars['Int'];
  members: Array<Member>;
  /** The organization name. */
  name: Scalars['String'];
  organizationData?: Maybe<OrganizationData>;
  roleName?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** A Cart organization record. */
export type OrganizationassignedRolesArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  primaryEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};


/** A Cart organization record. */
export type OrganizationbusinessesArgs = {
  userId?: InputMaybe<Scalars['Int']>;
};

/** Additional metadata for a Cart organization record. */
export type OrganizationData = {
  __typename?: 'OrganizationData';
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the record. */
  id: Scalars['Int'];
  /** The phone number for the organization. */
  phone?: Maybe<Scalars['String']>;
  /** The revenue for the organization. */
  revenue?: Maybe<Scalars['String']>;
  /** The sales channel for the organization. */
  salesChannel?: Maybe<Scalars['String']>;
  /** The shipHero Id for the organization. */
  shipHeroId?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The website for the organization. */
  website?: Maybe<Scalars['String']>;
};

export type PaginatedAssignedPermission = {
  __typename?: 'PaginatedAssignedPermission';
  data?: Maybe<Array<AssignedPermission>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedAssignedRole = {
  __typename?: 'PaginatedAssignedRole';
  data?: Maybe<Array<AssignedRole>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedBusiness = {
  __typename?: 'PaginatedBusiness';
  data?: Maybe<Array<Business>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedOrganization = {
  __typename?: 'PaginatedOrganization';
  data?: Maybe<Array<Organization>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedPermission = {
  __typename?: 'PaginatedPermission';
  data?: Maybe<Array<Permission>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedRole = {
  __typename?: 'PaginatedRole';
  data?: Maybe<Array<Role>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedSalesChannel = {
  __typename?: 'PaginatedSalesChannel';
  data?: Maybe<Array<SalesChannel>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedServiceAccount = {
  __typename?: 'PaginatedServiceAccount';
  data?: Maybe<Array<ServiceAccount>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  data?: Maybe<Array<User>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginationArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ParcelExtraInput = {
  insurance?: InputMaybe<ParcelInsuranceInput>;
};

export type ParcelInput = {
  distanceUnit?: InputMaybe<Scalars['String']>;
  extra?: InputMaybe<ParcelExtraInput>;
  height?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['String']>;
  massUnit: Scalars['String'];
  package?: InputMaybe<Scalars['String']>;
  weight: Scalars['String'];
  width?: InputMaybe<Scalars['String']>;
};

export type ParcelInsuranceInput = {
  amount: Scalars['Decimal'];
  content: Scalars['String'];
  currency: Scalars['String'];
  provider: Scalars['String'];
};

/** A permission that exists in the Cart Organization service. */
export type Permission = {
  __typename?: 'Permission';
  /** The alternate name of the permission. */
  alias?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The id of the record. */
  id: Scalars['Int'];
  /** The name of the permission. */
  name: Scalars['String'];
  /** The id of the org the permission belongs to */
  organizationId?: Maybe<Scalars['Int']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** This entity provides a single boolean that shows if a user or service account has access to a specific permission. */
export type PermissionCheck = {
  __typename?: 'PermissionCheck';
  /** Whether or not this user or service account has access to the assigned permission specified. */
  access: Scalars['Boolean'];
};

export type PersonalizeModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  displayType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isMultiLine?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isStep?: InputMaybe<Scalars['Boolean']>;
  markupFee?: InputMaybe<Scalars['Decimal']>;
  maxLength?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  stepGroup?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductAttributeModel = {
  attributeGroupId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlRewrite?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProductCategoriesModel = {
  id?: InputMaybe<Scalars['Int']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lookupPath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type ProductGroupRelationsModel = {
  addToCartMessage?: InputMaybe<Scalars['String']>;
  additionalAttributes?: InputMaybe<Scalars['String']>;
  additionalPointsEarned?: InputMaybe<Scalars['Int']>;
  allowedVariableSubscriptionTypes?: InputMaybe<Scalars['String']>;
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  attributes?: InputMaybe<Array<InputMaybe<ProductAttributeModel>>>;
  autoEntryLower?: InputMaybe<Scalars['Int']>;
  autoEntryUpper?: InputMaybe<Scalars['Int']>;
  availableRegionId?: InputMaybe<Scalars['Int']>;
  averageReviewRating?: InputMaybe<Scalars['Decimal']>;
  bindQuantityToParent?: InputMaybe<Scalars['Boolean']>;
  breakOutShipping?: InputMaybe<Scalars['Boolean']>;
  bullets?: InputMaybe<Scalars['String']>;
  bulletsExternalUrl?: InputMaybe<Scalars['String']>;
  callForPricing?: InputMaybe<Scalars['Int']>;
  callForShipping?: InputMaybe<Scalars['Int']>;
  callForShippingOnWholeOrder?: InputMaybe<Scalars['Boolean']>;
  cartProductId?: InputMaybe<Scalars['ID']>;
  categories?: InputMaybe<Array<InputMaybe<ProductCategoriesModel>>>;
  categoryList?: InputMaybe<Scalars['String']>;
  childIsRequired?: InputMaybe<Scalars['Boolean']>;
  childProducts?: InputMaybe<Array<InputMaybe<ProductGroupRelationsModel>>>;
  childRequiredQuantity?: InputMaybe<Scalars['Int']>;
  childSortOrder?: InputMaybe<Scalars['Int']>;
  cost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customFields?: InputMaybe<Array<InputMaybe<store_customFieldValueInputSimple>>>;
  customFlag1?: InputMaybe<Scalars['Boolean']>;
  customFlag2?: InputMaybe<Scalars['Boolean']>;
  customFlag3?: InputMaybe<Scalars['Boolean']>;
  customFlag4?: InputMaybe<Scalars['Boolean']>;
  customFlag5?: InputMaybe<Scalars['Boolean']>;
  customUpsellUrl?: InputMaybe<Scalars['String']>;
  daysUntilReorderAllowed?: InputMaybe<Scalars['Int']>;
  doNotDiscount?: InputMaybe<Scalars['Boolean']>;
  doNotSendReviewRequest?: InputMaybe<Scalars['Boolean']>;
  dropShip?: InputMaybe<Scalars['Boolean']>;
  eProductAllowMultipleDeliveries?: InputMaybe<Scalars['Int']>;
  eProductDeliveryAction?: InputMaybe<Scalars['String']>;
  eProductEmail?: InputMaybe<Scalars['String']>;
  eProductGenericPassword?: InputMaybe<Scalars['String']>;
  eProductGenericUsername?: InputMaybe<Scalars['String']>;
  eProductPassword?: InputMaybe<Scalars['String']>;
  eProductSerialNumberFilePath?: InputMaybe<Scalars['String']>;
  eProductType?: InputMaybe<Scalars['String']>;
  eProductUrl?: InputMaybe<Scalars['String']>;
  eProductVerificationLinkExpiration?: InputMaybe<Scalars['Int']>;
  earnsPoints?: InputMaybe<Scalars['Boolean']>;
  enableLowStockWarning?: InputMaybe<Scalars['Boolean']>;
  enabledConfigurator?: InputMaybe<Scalars['String']>;
  etaDate?: InputMaybe<Scalars['DateTime']>;
  excludeChildrenFromDisplay?: InputMaybe<Scalars['Boolean']>;
  excludeFromCommissions?: InputMaybe<Scalars['Boolean']>;
  excludeParentFromDisplay?: InputMaybe<Scalars['Boolean']>;
  extUpdateDate?: InputMaybe<Scalars['DateTime']>;
  forceSeparateOrder?: InputMaybe<Scalars['Boolean']>;
  freightClass?: InputMaybe<Scalars['String']>;
  gtin?: InputMaybe<Scalars['String']>;
  hSCode?: InputMaybe<Scalars['String']>;
  handlingFee?: InputMaybe<Scalars['Decimal']>;
  hasVisibleVariants?: InputMaybe<Scalars['Boolean']>;
  headTags?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['String']>;
  hideVariantSurcharges?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  inStockNotificationEmailTemplateId?: InputMaybe<Scalars['Int']>;
  inactiveStoreIds?: InputMaybe<Array<Scalars['Int']>>;
  insuranceCost?: InputMaybe<Scalars['Decimal']>;
  isChildProduct?: InputMaybe<Scalars['Boolean']>;
  isDefaultChild?: InputMaybe<Scalars['Boolean']>;
  isDiscontinued?: InputMaybe<Scalars['Boolean']>;
  isEnableVariantsOnParent?: InputMaybe<Scalars['Boolean']>;
  isFeaturedItem?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Int']>;
  isHideChildrenOnParent?: InputMaybe<Scalars['Boolean']>;
  isKit?: InputMaybe<Scalars['Boolean']>;
  isLinkedProduct?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isNonInventory?: InputMaybe<Scalars['Boolean']>;
  isNonShippingItem?: InputMaybe<Scalars['Boolean']>;
  isNonTaxable?: InputMaybe<Scalars['Int']>;
  isShippedIndividually?: InputMaybe<Scalars['Int']>;
  isSpotlightItem?: InputMaybe<Scalars['Int']>;
  isSubscriptionProduct?: InputMaybe<Scalars['Boolean']>;
  itemName?: InputMaybe<Scalars['String']>;
  itemNumber?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Scalars['String']>;
  lastItemNumber?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['String']>;
  longDescription1?: InputMaybe<Scalars['String']>;
  longDescription2?: InputMaybe<Scalars['String']>;
  longDescription3?: InputMaybe<Scalars['String']>;
  longDescription4?: InputMaybe<Scalars['String']>;
  longDescription5?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl1?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl2?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl3?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl4?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl5?: InputMaybe<Scalars['String']>;
  longDescriptionTabName1?: InputMaybe<Scalars['String']>;
  longDescriptionTabName2?: InputMaybe<Scalars['String']>;
  longDescriptionTabName3?: InputMaybe<Scalars['String']>;
  longDescriptionTabName4?: InputMaybe<Scalars['String']>;
  longDescriptionTabName5?: InputMaybe<Scalars['String']>;
  lowStockWarningThreshold?: InputMaybe<Scalars['Int']>;
  manufacturerId?: InputMaybe<Scalars['Int']>;
  manufacturerPartNumber?: InputMaybe<Scalars['String']>;
  masterProductId?: InputMaybe<Scalars['Int']>;
  materialCode?: InputMaybe<Scalars['String']>;
  maximumQuantity?: InputMaybe<Scalars['Short']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  minimumQuantity?: InputMaybe<Scalars['Short']>;
  noPriceMask?: InputMaybe<Scalars['String']>;
  offsetType?: InputMaybe<Scalars['String']>;
  overrideThemeUseTabs?: InputMaybe<Scalars['Boolean']>;
  packSlipSortOrder?: InputMaybe<Scalars['Int']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  parentProductId?: InputMaybe<Scalars['Int']>;
  personalizations?: InputMaybe<Array<InputMaybe<PersonalizeModel>>>;
  pictures?: InputMaybe<Array<InputMaybe<ProductPictureModel>>>;
  price?: InputMaybe<Scalars['Decimal']>;
  priceOffset?: InputMaybe<Scalars['Decimal']>;
  pricing?: InputMaybe<Array<InputMaybe<ProductPricingModel>>>;
  primaryCategoryId?: InputMaybe<Scalars['Int']>;
  productLineCode?: InputMaybe<Scalars['String']>;
  productRatingDimensionGroupOverrideId?: InputMaybe<Scalars['Int']>;
  productStatusId?: InputMaybe<Scalars['Int']>;
  profileId?: InputMaybe<Scalars['Int']>;
  quantityIncrement?: InputMaybe<Scalars['Int']>;
  quantityOnHand?: InputMaybe<Scalars['Int']>;
  quantityOnOrder?: InputMaybe<Scalars['Int']>;
  quickbooksItemId?: InputMaybe<Scalars['String']>;
  rateAdjustmentType?: InputMaybe<Scalars['String']>;
  related?: InputMaybe<Array<InputMaybe<RelatedProductsModel>>>;
  relatedName?: InputMaybe<Scalars['String']>;
  relationDescription?: InputMaybe<Scalars['String']>;
  retail?: InputMaybe<Scalars['Decimal']>;
  reviewCount?: InputMaybe<Scalars['Int']>;
  reviews?: InputMaybe<Array<InputMaybe<ProfilePostModel>>>;
  shipperHQDimensionalRuleGroups?: InputMaybe<Scalars['String']>;
  shipperHQPackingBoxes?: InputMaybe<Scalars['String']>;
  shipperHQShippingGroups?: InputMaybe<Scalars['String']>;
  shippingClassificationCode?: InputMaybe<Scalars['String']>;
  shippingOverride?: InputMaybe<Scalars['Decimal']>;
  shippingRateAdjustments?: InputMaybe<Array<InputMaybe<ShippingRateAdjustmentsModel>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  sizeUnit?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startingQuantity?: InputMaybe<Scalars['Int']>;
  subscriptionFrequency?: InputMaybe<Scalars['Int']>;
  subscriptionFrequencyType?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlRewrite?: InputMaybe<Scalars['String']>;
  useMapPricing?: InputMaybe<Scalars['Boolean']>;
  usePricingFromParent?: InputMaybe<Scalars['Boolean']>;
  useTabs?: InputMaybe<Scalars['Boolean']>;
  useVariantInventory?: InputMaybe<Scalars['Boolean']>;
  variantInvID?: InputMaybe<Scalars['Int']>;
  variantInventory?: InputMaybe<Array<InputMaybe<VariantInventoryModel>>>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantModel>>>;
  vendorStoreId?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightUnit?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['String']>;
};

export type ProductImportModel = {
  category?: InputMaybe<CategoryModel>;
  lookupBySKU?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<ManufacturerModel>;
  product?: InputMaybe<ProductModel>;
};

/** A business product instance record. */
export type ProductInstance = {
  __typename?: 'ProductInstance';
  /** The app instance id. Only required if product instance does not exist. */
  appInstanceId?: Maybe<Scalars['String']>;
  /** The billing url. */
  billingURL?: Maybe<Scalars['String']>;
  /** The Id for the business. */
  businessId?: Maybe<Scalars['Int']>;
  /** The Id for the product instance. */
  id?: Maybe<Scalars['Int']>;
  /** The product instance data. */
  instanceData?: Maybe<Scalars['String']>;
  /** The product instance type. */
  instanceType?: Maybe<InstanceType>;
  /** Whether or not the product is in trial. */
  isTrial?: Maybe<Scalars['Boolean']>;
  /** The lifetime non rr. */
  lifetimeNonRR?: Maybe<Scalars['Float']>;
  /** The lifetime value. */
  lifetimeValue?: Maybe<Scalars['Float']>;
  /** The plan code. */
  planCode?: Maybe<Scalars['String']>;
  /** The renewal date. */
  renewalDate?: Maybe<Scalars['DateTime']>;
  /** The saas mrr. */
  saasMRR?: Maybe<Scalars['Float']>;
  /** The services mrr. */
  servicesMRR?: Maybe<Scalars['Float']>;
  /** The subscription status. */
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  /** The trial anticipated end date. */
  trialAnticipatedEnd?: Maybe<Scalars['DateTime']>;
  /** The trial end date. */
  trialEnd?: Maybe<Scalars['DateTime']>;
  /** The trial start date. */
  trialStart?: Maybe<Scalars['DateTime']>;
};

export type ProductModel = {
  addToCartMessage?: InputMaybe<Scalars['String']>;
  additionalAttributes?: InputMaybe<Scalars['String']>;
  additionalPointsEarned?: InputMaybe<Scalars['Int']>;
  allowedVariableSubscriptionTypes?: InputMaybe<Scalars['String']>;
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  attributes?: InputMaybe<Array<InputMaybe<ProductAttributeModel>>>;
  availableRegionId?: InputMaybe<Scalars['Int']>;
  averageReviewRating?: InputMaybe<Scalars['Decimal']>;
  breakOutShipping?: InputMaybe<Scalars['Boolean']>;
  bullets?: InputMaybe<Scalars['String']>;
  bulletsExternalUrl?: InputMaybe<Scalars['String']>;
  callForPricing?: InputMaybe<Scalars['Int']>;
  callForShipping?: InputMaybe<Scalars['Int']>;
  callForShippingOnWholeOrder?: InputMaybe<Scalars['Boolean']>;
  cartProductId?: InputMaybe<Scalars['ID']>;
  categories?: InputMaybe<Array<InputMaybe<ProductCategoriesModel>>>;
  categoryList?: InputMaybe<Scalars['String']>;
  childProducts?: InputMaybe<Array<InputMaybe<ProductGroupRelationsModel>>>;
  cost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customFields?: InputMaybe<Array<InputMaybe<store_customFieldValueInputSimple>>>;
  customFlag1?: InputMaybe<Scalars['Boolean']>;
  customFlag2?: InputMaybe<Scalars['Boolean']>;
  customFlag3?: InputMaybe<Scalars['Boolean']>;
  customFlag4?: InputMaybe<Scalars['Boolean']>;
  customFlag5?: InputMaybe<Scalars['Boolean']>;
  customUpsellUrl?: InputMaybe<Scalars['String']>;
  daysUntilReorderAllowed?: InputMaybe<Scalars['Int']>;
  doNotDiscount?: InputMaybe<Scalars['Boolean']>;
  doNotSendReviewRequest?: InputMaybe<Scalars['Boolean']>;
  dropShip?: InputMaybe<Scalars['Boolean']>;
  eProductAllowMultipleDeliveries?: InputMaybe<Scalars['Int']>;
  eProductDeliveryAction?: InputMaybe<Scalars['String']>;
  eProductEmail?: InputMaybe<Scalars['String']>;
  eProductGenericPassword?: InputMaybe<Scalars['String']>;
  eProductGenericUsername?: InputMaybe<Scalars['String']>;
  eProductPassword?: InputMaybe<Scalars['String']>;
  eProductSerialNumberFilePath?: InputMaybe<Scalars['String']>;
  eProductType?: InputMaybe<Scalars['String']>;
  eProductUrl?: InputMaybe<Scalars['String']>;
  eProductVerificationLinkExpiration?: InputMaybe<Scalars['Int']>;
  earnsPoints?: InputMaybe<Scalars['Boolean']>;
  enableLowStockWarning?: InputMaybe<Scalars['Boolean']>;
  enabledConfigurator?: InputMaybe<Scalars['String']>;
  etaDate?: InputMaybe<Scalars['DateTime']>;
  excludeChildrenFromDisplay?: InputMaybe<Scalars['Boolean']>;
  excludeFromCommissions?: InputMaybe<Scalars['Boolean']>;
  excludeParentFromDisplay?: InputMaybe<Scalars['Boolean']>;
  extUpdateDate?: InputMaybe<Scalars['DateTime']>;
  forceSeparateOrder?: InputMaybe<Scalars['Boolean']>;
  freightClass?: InputMaybe<Scalars['String']>;
  gtin?: InputMaybe<Scalars['String']>;
  hSCode?: InputMaybe<Scalars['String']>;
  handlingFee?: InputMaybe<Scalars['Decimal']>;
  hasVisibleVariants?: InputMaybe<Scalars['Boolean']>;
  headTags?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['String']>;
  hideVariantSurcharges?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  inStockNotificationEmailTemplateId?: InputMaybe<Scalars['Int']>;
  inactiveStoreIds?: InputMaybe<Array<Scalars['Int']>>;
  insuranceCost?: InputMaybe<Scalars['Decimal']>;
  isChildProduct?: InputMaybe<Scalars['Boolean']>;
  isDiscontinued?: InputMaybe<Scalars['Boolean']>;
  isEnableVariantsOnParent?: InputMaybe<Scalars['Boolean']>;
  isFeaturedItem?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Int']>;
  isHideChildrenOnParent?: InputMaybe<Scalars['Boolean']>;
  isKit?: InputMaybe<Scalars['Boolean']>;
  isLinkedProduct?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isNonInventory?: InputMaybe<Scalars['Boolean']>;
  isNonShippingItem?: InputMaybe<Scalars['Boolean']>;
  isNonTaxable?: InputMaybe<Scalars['Int']>;
  isShippedIndividually?: InputMaybe<Scalars['Int']>;
  isSpotlightItem?: InputMaybe<Scalars['Int']>;
  isSubscriptionProduct?: InputMaybe<Scalars['Boolean']>;
  itemName?: InputMaybe<Scalars['String']>;
  itemNumber?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Scalars['String']>;
  lastItemNumber?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['String']>;
  longDescription1?: InputMaybe<Scalars['String']>;
  longDescription2?: InputMaybe<Scalars['String']>;
  longDescription3?: InputMaybe<Scalars['String']>;
  longDescription4?: InputMaybe<Scalars['String']>;
  longDescription5?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl1?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl2?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl3?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl4?: InputMaybe<Scalars['String']>;
  longDescriptionExternalUrl5?: InputMaybe<Scalars['String']>;
  longDescriptionTabName1?: InputMaybe<Scalars['String']>;
  longDescriptionTabName2?: InputMaybe<Scalars['String']>;
  longDescriptionTabName3?: InputMaybe<Scalars['String']>;
  longDescriptionTabName4?: InputMaybe<Scalars['String']>;
  longDescriptionTabName5?: InputMaybe<Scalars['String']>;
  lowStockWarningThreshold?: InputMaybe<Scalars['Int']>;
  manufacturerId?: InputMaybe<Scalars['Int']>;
  manufacturerPartNumber?: InputMaybe<Scalars['String']>;
  masterProductId?: InputMaybe<Scalars['Int']>;
  materialCode?: InputMaybe<Scalars['String']>;
  maximumQuantity?: InputMaybe<Scalars['Short']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  minimumQuantity?: InputMaybe<Scalars['Short']>;
  noPriceMask?: InputMaybe<Scalars['String']>;
  overrideThemeUseTabs?: InputMaybe<Scalars['Boolean']>;
  packSlipSortOrder?: InputMaybe<Scalars['Int']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  personalizations?: InputMaybe<Array<InputMaybe<PersonalizeModel>>>;
  pictures?: InputMaybe<Array<InputMaybe<ProductPictureModel>>>;
  price?: InputMaybe<Scalars['Decimal']>;
  pricing?: InputMaybe<Array<InputMaybe<ProductPricingModel>>>;
  primaryCategoryId?: InputMaybe<Scalars['Int']>;
  productLineCode?: InputMaybe<Scalars['String']>;
  productRatingDimensionGroupOverrideId?: InputMaybe<Scalars['Int']>;
  productStatusId?: InputMaybe<Scalars['Int']>;
  profileId?: InputMaybe<Scalars['Int']>;
  quantityIncrement?: InputMaybe<Scalars['Int']>;
  quantityOnHand?: InputMaybe<Scalars['Int']>;
  quantityOnOrder?: InputMaybe<Scalars['Int']>;
  quickbooksItemId?: InputMaybe<Scalars['String']>;
  rateAdjustmentType?: InputMaybe<Scalars['String']>;
  related?: InputMaybe<Array<InputMaybe<RelatedProductsModel>>>;
  relatedName?: InputMaybe<Scalars['String']>;
  retail?: InputMaybe<Scalars['Decimal']>;
  reviewCount?: InputMaybe<Scalars['Int']>;
  reviews?: InputMaybe<Array<InputMaybe<ProfilePostModel>>>;
  shipperHQDimensionalRuleGroups?: InputMaybe<Scalars['String']>;
  shipperHQPackingBoxes?: InputMaybe<Scalars['String']>;
  shipperHQShippingGroups?: InputMaybe<Scalars['String']>;
  shippingClassificationCode?: InputMaybe<Scalars['String']>;
  shippingOverride?: InputMaybe<Scalars['Decimal']>;
  shippingRateAdjustments?: InputMaybe<Array<InputMaybe<ShippingRateAdjustmentsModel>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  sizeUnit?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startingQuantity?: InputMaybe<Scalars['Int']>;
  subscriptionFrequency?: InputMaybe<Scalars['Int']>;
  subscriptionFrequencyType?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlRewrite?: InputMaybe<Scalars['String']>;
  useMapPricing?: InputMaybe<Scalars['Boolean']>;
  usePricingFromParent?: InputMaybe<Scalars['Boolean']>;
  useTabs?: InputMaybe<Scalars['Boolean']>;
  useVariantInventory?: InputMaybe<Scalars['Boolean']>;
  variantInventory?: InputMaybe<Array<InputMaybe<VariantInventoryModel>>>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantModel>>>;
  vendorStoreId?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightUnit?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['String']>;
};

export type ProductPictureModel = {
  alt?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  downloadExternalImage?: InputMaybe<Scalars['Boolean']>;
  flashPath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageFile?: InputMaybe<Scalars['String']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  isVideoScreenShot?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  thumbnailFile?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  videoContent?: InputMaybe<Scalars['String']>;
};

export type ProductPricingModel = {
  cost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerTypeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Decimal']>;
  priceCalculationId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  saleTypeId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startingQuantity?: InputMaybe<Scalars['Int']>;
  storeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantId?: InputMaybe<Scalars['Int']>;
  variantInventoryId?: InputMaybe<Scalars['Int']>;
  variantPriceSurcharge?: InputMaybe<Scalars['String']>;
};

export type ProductStatusModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isBackOrdered?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isUnavailable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  showQuantity?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductVariantGroupModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  displayType?: InputMaybe<Scalars['String']>;
  groupFooterHtml?: InputMaybe<Scalars['String']>;
  groupHeaderHtml?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isNonInventory?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  publicDescriptionHtml?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantModel>>>;
};

export type ProductVariantModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDefaultSelection?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  itemNumberExtension?: InputMaybe<Scalars['String']>;
  itemNumberSortOrder?: InputMaybe<Scalars['Short']>;
  priceAdjustment?: InputMaybe<Scalars['Decimal']>;
  priceAdjustmentType?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Short']>;
  swatchFile?: InputMaybe<Scalars['String']>;
  swatchThumbnail?: InputMaybe<Scalars['String']>;
  swatchThumbnailColor?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantGroupId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightType?: InputMaybe<Scalars['String']>;
};

export type ProfilePostModel = {
  approvalStatus?: InputMaybe<Scalars['String']>;
  approvedAt?: InputMaybe<Scalars['DateTime']>;
  approvedByUserId?: InputMaybe<Scalars['Int']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorEmail?: InputMaybe<Scalars['String']>;
  authorLocation?: InputMaybe<Scalars['String']>;
  authorWebsite?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  originStoreId?: InputMaybe<Scalars['Int']>;
  overallRating?: InputMaybe<Scalars['Decimal']>;
  productId?: InputMaybe<Scalars['Int']>;
  profileId?: InputMaybe<Scalars['Int']>;
  profilePostType?: InputMaybe<Scalars['String']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  ratings?: InputMaybe<Array<InputMaybe<ReviewRatingModel>>>;
  reviewCons?: InputMaybe<Scalars['String']>;
  reviewPros?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uploadedImage?: InputMaybe<Scalars['String']>;
};

export type PurchaseCommand = {
  batchId: Scalars['String'];
  merchantId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  comm_canSendEmails: Email;
  /** Lists channels and their basic info. */
  mcm_channels?: Maybe<Array<Maybe<mcm_ChannelType>>>;
  mcm_emailSubscriptions?: Maybe<Array<Maybe<mcm_emailSubscription>>>;
  mcm_health?: Maybe<mcm_HealthResult>;
  /** Lists job schedules. */
  mcm_jobSchedules?: Maybe<Array<Maybe<mcm_jobSchedule>>>;
  mcm_products?: Maybe<Array<Maybe<mcm_product>>>;
  mcm_vendor?: Maybe<mcm_vendor>;
  mcm_vendors?: Maybe<Array<Maybe<mcm_vendor>>>;
  /** Returns everything about the requesting user. */
  me: Me;
  /** Determines if the requesting user has the assigned permission. */
  org_assignedPermissionCheck: PermissionCheck;
  /** Determines if the specified user has the assigned permission. Superadmin only. */
  org_assignedPermissionExplicitCheck: PermissionCheck;
  /** Returns a list of all permissions assigned to the requesting user. */
  org_assignedPermissionListMe: PaginatedAssignedPermission;
  /** Determines if the requesting user has the assigned role to an organization, business, or sales channel. */
  org_assignedRoleCheck: RoleCheck;
  /** Determines if the specified user has the assigned role. Superadmin only. */
  org_assignedRoleExplicitCheck: RoleCheck;
  /** Returns a list of assigned roles according to the role and the business,organization, or sales channel. For example, if the arguments contained an organization id of 1 and the role of "orgAdmin", then this query would return all assigned roles of org admin assigned to organization 1. */
  org_assignedRoleList: PaginatedAssignedRole;
  /** Returns a list of all roles assigned to the requesting user. */
  org_assignedRoleListMe: PaginatedAssignedRole;
  /** Check your auth method */
  org_authMethods: AuthMethod;
  /** Lists all businesses. */
  org_businessList: PaginatedBusiness;
  /** Lists all businesses that belong to a specified organization id. */
  org_businessListByOrgId: PaginatedBusiness;
  /** Shows a business. */
  org_businessShow: Business;
  /** Shows a business by using an id outside of core but inside the ecosystem of Cart. */
  org_businessShowByExternalCartId: Business;
  org_health: Health;
  /** Lists all organizations. */
  org_organizationList: PaginatedOrganization;
  /** Shows an organization. */
  org_organizationShow: Organization;
  /** Returns all permissions. */
  org_permissionList: PaginatedPermission;
  /** Returns a single permission. */
  org_permissionShow: Permission;
  /** Get a list of product instances for a business. */
  org_productInstanceList: Array<ProductInstance>;
  /** Get a list of product instances for an organization. */
  org_productInstanceOrgList: Array<ProductInstance>;
  /** Get a product instance for a business. */
  org_productInstanceShow: ProductInstance;
  /** Lists all roles. */
  org_roleList: PaginatedRole;
  /** Shows a role. */
  org_roleShow: Role;
  /** List all sales channels. */
  org_salesChannelList: PaginatedSalesChannel;
  /** Lists all salesChannels that belong to a specified business ID. */
  org_salesChannelListByBusinessId: PaginatedSalesChannel;
  /** Shows a sales channel. */
  org_salesChannelShow: SalesChannel;
  /** Lists all service accounts. */
  org_serviceAccountList: PaginatedServiceAccount;
  /** Shows a service account. */
  org_serviceAccountShow: ServiceAccount;
  /** Validates the provided service account is valid. */
  org_serviceAccountValidate: Scalars['Boolean'];
  /** Check your auth session status. */
  org_sessionCheck: Session;
  /** Get all app settings for the current user */
  org_userAppSettingListMe: Array<UserAppSetting>;
  /** Get an app setting for the current user */
  org_userAppSettingShowMe: UserAppSetting;
  org_userInviteList: Array<UserInvite>;
  org_userInviteMe: Array<UserInvite>;
  /** Lists all users. */
  org_userList: PaginatedUser;
  /** Shows a user. */
  org_userShow: User;
  /** Show the user's last password reset date from their Auth0 profile. */
  org_userShowLastPasswordReset: LastPasswordReset;
  /** Validate a phone number */
  org_validatePhone: Scalars['Boolean'];
  shipping_batchShow?: Maybe<Batch>;
  shipping_featureFlagShow?: Maybe<FeatureFlag>;
  shipping_health: Health;
  shipping_merchantLabelList?: Maybe<Array<Maybe<Label>>>;
  shipping_merchantLabelShow?: Maybe<Label>;
  shipping_merchantRefundShow?: Maybe<Refund>;
  shipping_merchantShipmentShow?: Maybe<Shipment>;
  shipping_merchantShow?: Maybe<Merchant>;
  shipping_merchantsListShow?: Maybe<Array<Maybe<Merchant>>>;
  shipping_refundedLabelList?: Maybe<Array<Maybe<Label>>>;
  store_OrderPaymentList: store_orderPaymentListResult;
  store_OrderPaymentShow: store_orderPayment;
  store_attributeGroupList: store_attributeGroupListResult;
  store_attributeGroupShow: store_attributeGroup;
  store_attributeList: store_attributeListResult;
  store_attributeShow: store_attribute;
  store_categoryList: store_categoriesListResult;
  store_categoryShow: store_categories;
  store_customFieldList: store_customFieldListResult;
  store_customFieldShow: store_customField;
  store_customFieldValueList: store_customFieldValueListResult;
  store_customFieldValueShow: store_customFieldValue;
  store_customerList: store_customerListResult;
  store_customerShow: store_customer;
  store_health: Health;
  store_inventoryShow: store_changeInventory;
  store_manufacturerList: store_manufacturerListResult;
  store_manufacturerShow: store_manufacturer;
  store_orderAddressList: store_orderAddressListResult;
  store_orderAddressShow: store_orderAddress;
  store_orderItemList: store_orderItemListResult;
  store_orderItemShow: store_orderItem;
  store_orderList: store_orderListResult;
  store_orderShippingList: store_orderShippingListResult;
  store_orderShippingShow: store_orderShipping;
  store_orderShow: store_order;
  store_orderStatusList: store_orderStatusListResult;
  store_orderStatusShow: store_orderStatus;
  store_productList: store_productListResult;
  store_productShow: store_product;
  store_productStatusList: store_productStatusListResult;
  store_productStatusShow: store_productStatus;
  store_productVariantGroupList: store_productVariantGroupListResult;
  store_productVariantGroupShow: store_productVariantGroup;
  store_productVariantList: store_productVariantListResult;
  store_productVariantShow: store_productVariant;
  store_quoteList: store_quoteListResult;
  store_quoteShow: store_quote;
  store_storeList: store_storeListResult;
  store_storeShow: store_store;
  store_subscriptionList: store_subscriptionListResult;
  store_subscriptionShow: store_subscription;
  store_variantInventoryList: store_variantInventoryListResult;
  store_variantInventoryShow: store_variantInventory;
};


export type Querymcm_emailSubscriptionsArgs = {
  arguments?: InputMaybe<mcm_GetEmailSubscriptionsInput>;
};


export type Querymcm_productsArgs = {
  arguments?: InputMaybe<mcm_GetProductsInput>;
};


export type Querymcm_vendorArgs = {
  arguments?: InputMaybe<mcm_GetVendorInput>;
};


export type Querymcm_vendorsArgs = {
  arguments?: InputMaybe<mcm_GetVendorsInput>;
};


export type Queryorg_assignedPermissionCheckArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  permissionId?: InputMaybe<Scalars['Int']>;
  permissionName?: InputMaybe<Scalars['String']>;
};


export type Queryorg_assignedPermissionExplicitCheckArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  permissionId?: InputMaybe<Scalars['Int']>;
  permissionName?: InputMaybe<Scalars['String']>;
  serviceAccountId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type Queryorg_assignedPermissionListMeArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  permissionId?: InputMaybe<Scalars['Int']>;
  permissionName?: InputMaybe<Scalars['String']>;
};


export type Queryorg_assignedRoleCheckArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  salesChannelId?: InputMaybe<Scalars['Int']>;
};


export type Queryorg_assignedRoleExplicitCheckArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  salesChannelId?: InputMaybe<Scalars['Int']>;
  serviceAccountId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type Queryorg_assignedRoleListArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  roleId?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  salesChannelId?: InputMaybe<Scalars['Int']>;
};


export type Queryorg_assignedRoleListMeArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  roleId?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  salesChannelId?: InputMaybe<Scalars['Int']>;
};


export type Queryorg_authMethodsArgs = {
  input: AuthMethodInput;
};


export type Queryorg_businessListArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_businessListByOrgIdArgs = {
  organizationId: Scalars['Int'];
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_businessShowArgs = {
  id: Scalars['Int'];
};


export type Queryorg_businessShowByExternalCartIdArgs = {
  id: FindBusinessByExternalCartId;
};


export type Queryorg_organizationListArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
  searchArgs?: InputMaybe<SearchOrganizationInput>;
};


export type Queryorg_organizationShowArgs = {
  id: Scalars['Int'];
};


export type Queryorg_permissionListArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_permissionShowArgs = {
  id: Scalars['Int'];
};


export type Queryorg_productInstanceListArgs = {
  input: ListProductInstanceInput;
};


export type Queryorg_productInstanceOrgListArgs = {
  input: ListProductInstanceOrgInput;
};


export type Queryorg_productInstanceShowArgs = {
  input: GetProductInstanceInput;
};


export type Queryorg_roleListArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_roleShowArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type Queryorg_salesChannelListArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_salesChannelListByBusinessIdArgs = {
  businessId: Scalars['Int'];
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_salesChannelShowArgs = {
  id: Scalars['Int'];
};


export type Queryorg_serviceAccountListArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_serviceAccountShowArgs = {
  id: Scalars['Int'];
};


export type Queryorg_userAppSettingShowMeArgs = {
  input: UserAppSettingInput;
};


export type Queryorg_userInviteListArgs = {
  organizationId: Scalars['Int'];
};


export type Queryorg_userInviteMeArgs = {
  input: UserInviteMeInput;
};


export type Queryorg_userListArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  idOrEmail?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type Queryorg_userShowArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  primaryEmail?: InputMaybe<Scalars['String']>;
};


export type Queryorg_userShowLastPasswordResetArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  primaryEmail?: InputMaybe<Scalars['String']>;
};


export type Queryorg_validatePhoneArgs = {
  phone: Scalars['String'];
};


export type Queryshipping_batchShowArgs = {
  batchInput: GetBatchQuery;
};


export type Queryshipping_featureFlagShowArgs = {
  featureFlagInput: GetFeatureFlagQuery;
};


export type Queryshipping_merchantLabelListArgs = {
  merchantLabelListInput: GetMerchantLabelListQuery;
};


export type Queryshipping_merchantLabelShowArgs = {
  merchantLabelInput: GetMerchantLabelQuery;
};


export type Queryshipping_merchantRefundShowArgs = {
  merchantRefundInput: GetMerchantRefundQuery;
};


export type Queryshipping_merchantShipmentShowArgs = {
  merchantShipmentInput: GetMerchantShipmentQuery;
};


export type Queryshipping_merchantShowArgs = {
  id: Scalars['String'];
};


export type Queryshipping_merchantsListShowArgs = {
  merchantsListInput: GetMerchantsListQuery;
};


export type Queryshipping_refundedLabelListArgs = {
  refundedLabelListInput: GetRefundedLabelListQuery;
};


export type Querystore_OrderPaymentListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_OrderPaymentShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_attributeGroupListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_attributeGroupShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_attributeListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_attributeShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_categoryListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_categoryShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_customFieldListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_customFieldShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_customFieldValueListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_customFieldValueShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_customerListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_customerShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_inventoryShowArgs = {
  getInventoryOptions: getInventoryInput;
};


export type Querystore_manufacturerListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_manufacturerShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_orderAddressListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_orderAddressShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_orderItemListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_orderItemShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_orderListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_orderShippingListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_orderShippingShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_orderShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_orderStatusListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_orderStatusShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_productListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_productShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_productStatusListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_productStatusShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_productVariantGroupListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_productVariantGroupShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_productVariantListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_productVariantShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_quoteListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_quoteShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_storeListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_storeShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_subscriptionListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_subscriptionShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};


export type Querystore_variantInventoryListArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
};


export type Querystore_variantInventoryShowArgs = {
  getRequestOptions?: InputMaybe<getRequestInput>;
  id: Scalars['Int'];
};

export type QuoteModel = {
  adcode?: InputMaybe<Scalars['String']>;
  adcodeId?: InputMaybe<Scalars['Int']>;
  additionalFees?: InputMaybe<Scalars['Decimal']>;
  adminComments?: InputMaybe<Scalars['String']>;
  affiliateId?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<OrderAddressModel>;
  campaignCode?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  costTotal?: InputMaybe<Scalars['Decimal']>;
  couponCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customFields?: InputMaybe<Array<InputMaybe<store_customFieldValueInputSimple>>>;
  customer?: InputMaybe<CustomerModel>;
  customerId?: InputMaybe<Scalars['Int']>;
  customerTypeId?: InputMaybe<Scalars['Int']>;
  deliveryTax?: InputMaybe<Scalars['Decimal']>;
  device?: InputMaybe<Scalars['String']>;
  discountTotal?: InputMaybe<Scalars['Decimal']>;
  discountedShippingTotal?: InputMaybe<Scalars['Decimal']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  enteredBy?: InputMaybe<Scalars['String']>;
  enteredByType?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Boolean']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  exportedToAccountingSystem?: InputMaybe<Scalars['Int']>;
  fromQuoteId?: InputMaybe<Scalars['Int']>;
  fromSubscriptionId?: InputMaybe<Scalars['Int']>;
  giftMessage?: InputMaybe<Scalars['String']>;
  grandTotal?: InputMaybe<Scalars['Decimal']>;
  handlingTotal?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isPaymentOrderOnly?: InputMaybe<Scalars['Boolean']>;
  isPpc?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<OrderItemModel>>>;
  manufacturerInvoiceAmount?: InputMaybe<Scalars['Decimal']>;
  manufacturerInvoiceNumber?: InputMaybe<Scalars['String']>;
  manufacturerInvoicePaid?: InputMaybe<Scalars['Boolean']>;
  orderBillingAddressId?: InputMaybe<Scalars['Int']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderShippingAddressId?: InputMaybe<Scalars['Int']>;
  orderStatus?: InputMaybe<OrderStatusModel>;
  orderStatusId?: InputMaybe<Scalars['Int']>;
  orderStatusLastChangedAt?: InputMaybe<Scalars['DateTime']>;
  orderType?: InputMaybe<Scalars['String']>;
  orderedAt?: InputMaybe<Scalars['DateTime']>;
  payments?: InputMaybe<Array<InputMaybe<OrderPaymentModel>>>;
  ppcKeyword?: InputMaybe<Scalars['String']>;
  previousOrderStatusId?: InputMaybe<Scalars['Int']>;
  publicComments?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
  rewardPointsCredited?: InputMaybe<Scalars['Boolean']>;
  salesAgentUserID?: InputMaybe<Scalars['Int']>;
  searchPhrase?: InputMaybe<Scalars['String']>;
  selectedShippingMethod?: InputMaybe<Scalars['String']>;
  selectedShippingProviderService?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  shipments?: InputMaybe<Array<InputMaybe<OrderShippingModel>>>;
  shippingAddress?: InputMaybe<OrderAddressModel>;
  shippingSelections?: InputMaybe<Array<InputMaybe<OrderShippingSelectionsModel>>>;
  shippingTotal?: InputMaybe<Scalars['Decimal']>;
  source?: InputMaybe<Scalars['String']>;
  sourceGroup?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Decimal']>;
  taxTotal?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Refund = {
  __typename?: 'Refund';
  labelObjectId?: Maybe<Scalars['String']>;
  objectCreated: Scalars['DateTime'];
  objectOwner?: Maybe<Scalars['String']>;
  objectUpdated: Scalars['DateTime'];
  refundId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  test: Scalars['Boolean'];
};

export type RegisterUserInput = {
  /** Auth0 Identifier for the user. */
  auth0Id?: InputMaybe<Scalars['String']>;
  /** The email of the user. */
  email: Scalars['String'];
  /** The first name the user. */
  firstName: Scalars['String'];
  /** Set to true only if you know that a user’s email is verified. */
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  /** The last name the user. */
  lastName: Scalars['String'];
  /** The password for the users Auth0 account. */
  password: Scalars['String'];
  /** The phone number of the user. */
  phone?: InputMaybe<Scalars['String']>;
  /** The date a User accepted the Terms of Service. */
  tosAccepted?: InputMaybe<Scalars['DateTime']>;
};

export type RelatedProductsModel = {
  id?: InputMaybe<Scalars['Int']>;
  isHidden: Scalars['Boolean'];
  isUpsell?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  upsellAdjustedPrice?: InputMaybe<Scalars['Decimal']>;
  upsellFreeShipping?: InputMaybe<Scalars['Boolean']>;
  upsellQuantity?: InputMaybe<Scalars['Int']>;
};

export type ReviewRatingModel = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Decimal']>;
};

export type RewardPointsModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['Int']>;
  earnedAt?: InputMaybe<Scalars['DateTime']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  pointsEarned?: InputMaybe<Scalars['Int']>;
  pointsRemaining?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** A role that exists in the Cart Organization service. */
export type Role = {
  __typename?: 'Role';
  /** The alternate name of the role. */
  alias?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The role description. */
  description?: Maybe<Scalars['String']>;
  /** A human-readable representation of the name to be displayed in the UI. */
  displayName?: Maybe<Scalars['String']>;
  /** The id of the record. */
  id: Scalars['Int'];
  /** The name of the role. */
  name: Scalars['String'];
  /** The id of the org the role belongs to */
  organizationId?: Maybe<Scalars['Int']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** This entity provides a single boolean that shows if a user or service account has access to a specific role. */
export type RoleCheck = {
  __typename?: 'RoleCheck';
  /** Determines whether or not the requester is assigned to this role. */
  access: Scalars['Boolean'];
};

/** A Cart sales channel record.  The sales channel is the lowest resource tier (organization > business > salesChannel).  sales hannels relate to orders and shoppers. */
export type SalesChannel = {
  __typename?: 'SalesChannel';
  assignedRoles: Array<AssignedRole>;
  /** The business associated with the sales channel. */
  business: Business;
  /** The identity of the parent business. */
  businessId: Scalars['Int'];
  /** The date the sales channel was first created. */
  createdAt: Scalars['DateTime'];
  /** An indication that the sales channel has been deleted. */
  deleted?: Maybe<Scalars['DateTime']>;
  /** An indication that the sales channel has been disabled. */
  disabled: Scalars['Boolean'];
  /** An explanation for why the sales channel has been disabled. */
  disabledReason?: Maybe<Scalars['String']>;
  /** The cart sales channel id. */
  id: Scalars['Int'];
  /** The sales channel instance JSON data stringified. */
  instanceData?: Maybe<Scalars['String']>;
  /** The instance type of the saleschannel. */
  instanceType?: Maybe<InstanceType>;
  /** The name of the sales channel. */
  name: Scalars['String'];
  /**
   * The phone number for the sales channel.
   * @deprecated Use instanceData instead
   */
  phone?: Maybe<Scalars['String']>;
  /**
   * The amount of revenue associated with the sales channel.
   * @deprecated Use instanceData instead
   */
  revenue?: Maybe<Scalars['String']>;
  /**
   * The ShipHero ID for the sales channel.
   * @deprecated Use instanceData instead
   */
  shipHeroId?: Maybe<Scalars['String']>;
  /** The date the sales channel was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The website for the sales channel. */
  website?: Maybe<Scalars['String']>;
};

export type SearchOrganizationInput = {
  /** The name or id of the organization to search for. */
  idOrName?: InputMaybe<Scalars['String']>;
};

/** A Cart service account record. This service account can be provisioned permissions or roles to authorize for, similar to a user. */
export type ServiceAccount = {
  __typename?: 'ServiceAccount';
  assignedPermissions: PaginatedAssignedPermission;
  /** The business for the service account. */
  business?: Maybe<Business>;
  /** the id of the business for the service account */
  businessId?: Maybe<Scalars['Int']>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The hashed key for the service account. */
  hashedKey?: Maybe<Scalars['String']>;
  /** The id for the service account */
  id?: Maybe<Scalars['Int']>;
  /** The key for the service account.  This key is only returned on create. */
  key?: Maybe<Scalars['String']>;
  /** The organization for the service account. */
  organization?: Maybe<Organization>;
  /** the id of the organization for the service account */
  organizationId?: Maybe<Scalars['Int']>;
  /** the sales channel for the service account */
  salesChannel?: Maybe<SalesChannel>;
  /** the id of the sales channel for the service account */
  salesChannelId?: Maybe<Scalars['Int']>;
  /** The shipHero id for the service account. */
  shipHeroId?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** A Cart service account record. This service account can be provisioned permissions or roles to authorize for, similar to a user. */
export type ServiceAccountassignedPermissionsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

/** The session status of the current user. */
export type Session = {
  __typename?: 'Session';
  /** The user has a current valid session */
  isSessionValid: Scalars['Boolean'];
  /** The Org Service userId */
  userId: Scalars['Int'];
};

export type SessionRegisterInput = {
  /** The user's id from Auth0 */
  auth0Id: Scalars['String'];
  /** The user's email address. */
  email: Scalars['String'];
  /** The user's firstName from Auth0 */
  firstName?: InputMaybe<Scalars['String']>;
  /** The user's lastName from Auth0 */
  lastName?: InputMaybe<Scalars['String']>;
  /** The user's phone number from Auth0 */
  phone?: InputMaybe<Scalars['String']>;
};

export type SessionStartInput = {
  /** The user's email address. */
  email: Scalars['String'];
};

export type Shipment = {
  __typename?: 'Shipment';
  addressFrom?: Maybe<address>;
  addressReturn?: Maybe<address>;
  addressTo?: Maybe<address>;
  alternateAddressTo?: Maybe<Scalars['String']>;
  customsDeclaration?: Maybe<Scalars['String']>;
  extra?: Maybe<extra>;
  messages?: Maybe<Array<Maybe<message>>>;
  metaData?: Maybe<Scalars['String']>;
  objectCreated: Scalars['DateTime'];
  objectOwner?: Maybe<Scalars['String']>;
  objectUpdated: Scalars['DateTime'];
  parcels?: Maybe<Array<Maybe<parcel>>>;
  rates?: Maybe<Array<Maybe<rate>>>;
  shipmentDate: Scalars['DateTime'];
  shipmentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  test: Scalars['Boolean'];
};

export type ShippingRateAdjustmentsModel = {
  amount?: InputMaybe<Scalars['Decimal']>;
  availableRegionId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isUnavailable?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['Int']>;
  shippingMethodName?: InputMaybe<Scalars['String']>;
  shippingProvider?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  useCalculatedRate?: InputMaybe<Scalars['Boolean']>;
};

export type SubscriptionModel = {
  billingAddressId?: InputMaybe<Scalars['Int']>;
  cartInfo?: InputMaybe<CartInfoModel>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<CustomerModel>;
  customerId?: InputMaybe<Scalars['Int']>;
  customerNotice?: InputMaybe<Scalars['String']>;
  customerPaymentMethod?: InputMaybe<CustomerPaymentMethodModel>;
  customerPaymentMethodId?: InputMaybe<Scalars['Int']>;
  dripSeriesId?: InputMaybe<Scalars['Int']>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isRenewalPaymentDeclined?: InputMaybe<Scalars['Boolean']>;
  latestRenewalOrderId?: InputMaybe<Scalars['Int']>;
  nextDueAt?: InputMaybe<Scalars['DateTime']>;
  oneTimeCustomerNotice?: InputMaybe<Scalars['String']>;
  originalOrderId?: InputMaybe<Scalars['Int']>;
  renewalCount?: InputMaybe<Scalars['Int']>;
  savedCartId?: InputMaybe<Scalars['Int']>;
  shippingAddress?: InputMaybe<OrderAddressModel>;
  shippingAddressId?: InputMaybe<Scalars['Int']>;
  shippingMethodName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** The status of the subscription. */
export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  PAST_DUE = 'PAST_DUE',
  PENDING_CANCELLATION = 'PENDING_CANCELLATION',
  PENDING_RENEWAL = 'PENDING_RENEWAL',
  TRIAL = 'TRIAL'
}

/** Default templates that do not require a template ID. */
export enum TemplateType {
  basicText = 'basicText',
  dataScienceReport = 'dataScienceReport',
  simpleCTA = 'simpleCTA'
}

/** Boolean response for toggling user_metadata use_mfa. */
export type ToggleMfaData = {
  __typename?: 'ToggleMfaData';
  /** If the toggle was successful */
  success: Scalars['Boolean'];
};

export type ToggleUserMfaInput = {
  /** The setting for the use_mfa property in user_metadata */
  toggle: Scalars['Boolean'];
};

export type UpdateBusinessInput = {
  /** Whether or not a Business record is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The reason a Business record has been disabled. */
  disabledReason?: InputMaybe<Scalars['String']>;
  /** Feed management data for the business. */
  feedManagementData?: InputMaybe<Scalars['String']>;
  /** Whether or not feed management is enabled. */
  feedManagementEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Fulfillment data for the business. */
  fulfillmentData?: InputMaybe<Scalars['String']>;
  /** Whether or not fulfillment is enabled. */
  fulfillmentEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  /** Mcm data for the business. */
  mcmData?: InputMaybe<Scalars['String']>;
  /** Whether or not mcm is enabled. */
  mcmEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The business name. */
  name?: InputMaybe<Scalars['String']>;
  /** The Id for the parent organization of the business. Used to re-parent the business to a different oranization */
  organizationId?: InputMaybe<Scalars['Int']>;
  /** The phone number for the business. */
  phone?: InputMaybe<Scalars['String']>;
  /** The revenue for the business. */
  revenue?: InputMaybe<Scalars['String']>;
  /** The sales channel for the business. */
  salesChannel?: InputMaybe<Scalars['String']>;
  /** The shipHero Id for the business. */
  shipHeroId?: InputMaybe<Scalars['String']>;
  /** Storefront data for the business. */
  storefrontData?: InputMaybe<Scalars['String']>;
  /** Whether storefront is enabled. */
  storefrontEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Unified analytics data for the business. */
  unifiedAnalyticsData?: InputMaybe<Scalars['String']>;
  /** Whether or not unified analytics is enabled. */
  unifiedAnalyticsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The website for the business. */
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateMerchantAccountCommand = {
  inactivationReason?: InputMaybe<Scalars['String']>;
  isInActive?: InputMaybe<Scalars['Boolean']>;
  markupPercent?: InputMaybe<Scalars['Decimal']>;
  merchantId: Scalars['String'];
  rechargeThreshold?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateMerchantBalanceCommand = {
  datePaid?: InputMaybe<Scalars['DateTime']>;
  labelIDs?: InputMaybe<Array<Scalars['String']>>;
  labelSurchargeIDs?: InputMaybe<Array<Scalars['Int']>>;
  merchantID?: InputMaybe<Scalars['String']>;
  orderID: Scalars['Int'];
};

export type UpdateMerchantCommand = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  markupPercent?: InputMaybe<Scalars['Decimal']>;
  merchantId: Scalars['String'];
  merchantName: Scalars['String'];
};

export type UpdateOrganizationInput = {
  /** Custom terminology for businesses in this organization */
  businessEntityTerminology?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** The name of the organization. */
  name?: InputMaybe<Scalars['String']>;
  /** The phone number for the organization. */
  phone?: InputMaybe<Scalars['String']>;
  /** The revenue for the organization. */
  revenue?: InputMaybe<Scalars['String']>;
  /** The sales channel for the organization. */
  salesChannel?: InputMaybe<Scalars['String']>;
  /** The shipHero Id for the organization. */
  shipHeroId?: InputMaybe<Scalars['String']>;
  /** The website for the organization. */
  website?: InputMaybe<Scalars['String']>;
};

export type UpdatePermissionInput = {
  /** The alternate name of the permission */
  alias?: InputMaybe<Scalars['Int']>;
  /** The business the permission belongs to */
  businessId?: InputMaybe<Scalars['Int']>;
  /** The Id of the Permission. */
  id: Scalars['Int'];
  /** The name of the permission. */
  name?: InputMaybe<Scalars['String']>;
  /** The organization the permission belongs to */
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type UpdateRoleInput = {
  /** An alternative name for the role */
  alias?: InputMaybe<Scalars['String']>;
  /** The role description. */
  description?: InputMaybe<Scalars['String']>;
  /** A human-readable representation of the name to be displayed in the UI. */
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** The name of the role. */
  name?: InputMaybe<Scalars['String']>;
  /** The organization the role belongs to */
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type UpdateSalesChannelInput = {
  /** The identity of the parent business. */
  businessId?: InputMaybe<Scalars['Int']>;
  /** An indication that the sales channel has been deleted. */
  deleted?: InputMaybe<Scalars['DateTime']>;
  /** An indication that the sales channel has been disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** An explanation for why the sales channel has been disabled. */
  disabledReason?: InputMaybe<Scalars['String']>;
  /** The Cart sales channel ID. */
  id: Scalars['Int'];
  /** The sales channel instance JSON data stringified. */
  instanceData?: InputMaybe<Scalars['String']>;
  /** The instance type of the saleschannel. */
  instanceType?: InputMaybe<InstanceType>;
  /** The name of the sales hannel. */
  name?: InputMaybe<Scalars['String']>;
  /** The phone number for the sales channel. */
  phone?: InputMaybe<Scalars['String']>;
  /** The amount of revenue associated with the sales channel. */
  revenue?: InputMaybe<Scalars['String']>;
  /** The ShipHero ID for the sales channel. */
  shipHeroId?: InputMaybe<Scalars['String']>;
  /** The website for the sales channel. */
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  /** Line 1 of the address for the user. */
  address1?: InputMaybe<Scalars['String']>;
  /** Line 2 of the address for the user. */
  address2?: InputMaybe<Scalars['String']>;
  /** The city of the address for the user. */
  city?: InputMaybe<Scalars['String']>;
  /** The company for the user. */
  company?: InputMaybe<Scalars['String']>;
  /** The country of the address for the user. */
  country?: InputMaybe<Scalars['String']>;
  /** The default business a user will see when they log in. */
  defaultBusinessId?: InputMaybe<Scalars['Int']>;
  /** Whether or not a User record is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The reason a User record has been disabled. */
  disabledReason?: InputMaybe<Scalars['String']>;
  /** The first name the user. */
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** The last name the user. */
  lastName?: InputMaybe<Scalars['String']>;
  /** The phone number for the user. */
  phone?: InputMaybe<Scalars['String']>;
  /** The primary email of the user. */
  primaryEmail?: InputMaybe<Scalars['String']>;
  /** The state of the address for the user. */
  state?: InputMaybe<Scalars['String']>;
  /** The date a User accepted the Terms of Service. */
  tosAccepted?: InputMaybe<Scalars['DateTime']>;
  /** The zip code of the address for the user. */
  zip?: InputMaybe<Scalars['String']>;
};

export type UpsCarrierAccountInput = {
  accountNumber: Scalars['String'];
  aiaCountry?: InputMaybe<Scalars['String']>;
  billingCountry: Scalars['String'];
  billingZip: Scalars['String'];
  city: Scalars['String'];
  collectionCountry: Scalars['String'];
  collectionZip: Scalars['String'];
  company: Scalars['String'];
  currencyCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  hasInvoice: Scalars['Boolean'];
  invoiceControlId?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoiceValue?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpsertProductInstanceInput = {
  /** The app instance id. Only required if product instance does not exist. */
  appInstanceId?: InputMaybe<Scalars['String']>;
  /** The billing url. */
  billingURL?: InputMaybe<Scalars['String']>;
  /** The Id for the business. */
  businessId: Scalars['Int'];
  /** The product instance data.  The JSON will be upsert with the existing data. */
  instanceData?: InputMaybe<Scalars['String']>;
  /** The product instance type. */
  instanceType: InstanceType;
  /** Whether or not the product is in trial. */
  isTrial?: InputMaybe<Scalars['Boolean']>;
  /** The lifetime non rr. */
  lifetimeNonRR?: InputMaybe<Scalars['Float']>;
  /** The lifetime value. */
  lifetimeValue?: InputMaybe<Scalars['Float']>;
  /** The plan code. */
  planCode?: InputMaybe<Scalars['String']>;
  /** The renewal date. */
  renewalDate?: InputMaybe<Scalars['DateTime']>;
  /** The saas mrr. */
  saasMRR?: InputMaybe<Scalars['Float']>;
  /** The services mrr. */
  servicesMRR?: InputMaybe<Scalars['Float']>;
  /** The subscription status. */
  subscriptionStatus?: InputMaybe<SubscriptionStatus>;
  /** The trial anticipated end date. */
  trialAnticipatedEnd?: InputMaybe<Scalars['DateTime']>;
  /** The trial end date. */
  trialEnd?: InputMaybe<Scalars['DateTime']>;
  /** The trial start date. */
  trialStart?: InputMaybe<Scalars['DateTime']>;
};

/** The app settings of the current user. */
export type UpsertUserAppSettingInput = {
  /** The application. */
  app?: InputMaybe<InstanceType>;
  /** The setting in string form. */
  setting: Scalars['String'];
  /** The type of app setting. */
  type: UserAppSettingType;
};

/** A user that exists in the Cart Organization service. */
export type User = {
  __typename?: 'User';
  /** The Auth0 ID of the user. */
  auth0Id?: Maybe<Scalars['String']>;
  /** The businesses associated with a user. */
  businesses?: Maybe<Array<Business>>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Determine whether a User has been deleted. */
  deleted?: Maybe<Scalars['DateTime']>;
  /** Whether or not a User record is disabled. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The reason a User record has been disabled. */
  disabledReason?: Maybe<Scalars['String']>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']>;
  /** The id of the user */
  id: Scalars['Int'];
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']>;
  mfaData: MfaData;
  /** Determine whether a User has MFA enabled/disabled. */
  mfaDetails?: Maybe<Scalars['Boolean']>;
  /** The Organizations associated with a user */
  organizations?: Maybe<Array<Organization>>;
  /** The primary email of the user. */
  primaryEmail: Scalars['String'];
  /** Auth0 token - can only be returned from registerUser endpoint */
  token?: Maybe<Scalars['String']>;
  /** The date a User accepted the Terms of Service. */
  tosAccepted?: Maybe<Scalars['DateTime']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAppSettings: Array<UserAppSetting>;
  /** Information about the user. */
  userData?: Maybe<UserData>;
  /** Invitations assigned to this user. */
  userInvitations?: Maybe<Array<UserInvite>>;
};


/** A user that exists in the Cart Organization service. */
export type UsermfaDataArgs = {
  mfaInput: MfaDataInput;
};

/** The app settings of the current user. */
export type UserAppSetting = {
  __typename?: 'UserAppSetting';
  /** The application. */
  app?: Maybe<InstanceType>;
  /** The id of the userAppSetting in the DB. */
  id: Scalars['Int'];
  /** The setting in string form. */
  setting?: Maybe<Scalars['String']>;
  /** The type of app setting. */
  type: UserAppSettingType;
  /** The userId. */
  userId: Scalars['Int'];
};

/** The filters to get the appsettings for a current user. */
export type UserAppSettingInput = {
  /** The application. */
  app?: InputMaybe<InstanceType>;
  /** The type of app setting. */
  type: UserAppSettingType;
};

/** The type of the User App Setting. */
export enum UserAppSettingType {
  CURRENT_BUSINESS_CONTEXT = 'CURRENT_BUSINESS_CONTEXT',
  DEFAULT_BUSINESS = 'DEFAULT_BUSINESS'
}

/** Additional metadata for a Cart user record. */
export type UserData = {
  __typename?: 'UserData';
  /** Line 1 of the address for the user. */
  address1?: Maybe<Scalars['String']>;
  /** Line 2 of the address for the user. */
  address2?: Maybe<Scalars['String']>;
  /** The city of the address for the user. */
  city?: Maybe<Scalars['String']>;
  /** The company for the user. */
  company?: Maybe<Scalars['String']>;
  /** The country of the address for the user. */
  country?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The default business a user will see when they log in. */
  defaultBusinessId?: Maybe<Scalars['Int']>;
  /** The id of the record. */
  id: Scalars['Int'];
  /** The phone number for the user. */
  phone?: Maybe<Scalars['String']>;
  /** The state of the address for the user. */
  state?: Maybe<Scalars['String']>;
  /** The timestamp for when the record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The zip code of the address for the user. */
  zip?: Maybe<Scalars['String']>;
};

export type UserInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Scalars['String']>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  /**
   * Assigned roles for the invite
   * @deprecated Use inviteRoles instead
   */
  assignedRoles?: Maybe<Array<AssignedRole>>;
  business?: Maybe<Business>;
  /** The businessId of the user invite. */
  businessId?: Maybe<Scalars['Int']>;
  /** The name of the business the invite is for */
  businessName?: Maybe<Scalars['String']>;
  /** Date the invite was consumed */
  consumedDate?: Maybe<Scalars['DateTime']>;
  /** The Id of the user invite. */
  id: Scalars['Int'];
  /** The Email of the invited user. */
  inviteEmail: Scalars['String'];
  /** Expiration date of the invitation */
  inviteExpiration: Scalars['DateTime'];
  /** The status of the invite */
  inviteStatus?: Maybe<Scalars['String']>;
  /** The invite token for the invited user */
  inviteToken: Scalars['String'];
  organization?: Maybe<Organization>;
  /** The organizationId of the user invite. */
  organizationId?: Maybe<Scalars['Int']>;
  /** The name of the organization the invite is for */
  organizationName?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  /** The userId of the invited user */
  userId: Scalars['Int'];
};

export type UserInviteMeInput = {
  /** The status of the user invite. */
  status?: InputMaybe<InviteStatusEnum>;
};

/** A representation of all data regarding the requesting user. */
export type UserMetaData = {
  __typename?: 'UserMetaData';
  /** The address of the user. */
  address?: Maybe<Address>;
  /** The company name of the user. */
  company_name: Scalars['String'];
  /** The phone number of the user. */
  phone: Scalars['String'];
  /** The website url of the user. */
  website: Scalars['String'];
};

export type VariantInventoryModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  gtin?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inventory?: InputMaybe<Scalars['Int']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Decimal']>;
  lowStockWarningAt?: InputMaybe<Scalars['Int']>;
  lowStockWarningEnabled?: InputMaybe<Scalars['Boolean']>;
  manufacturerItemNumber?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Array<InputMaybe<ProductPricingModel>>>;
  productId?: InputMaybe<Scalars['Int']>;
  productStatusId?: InputMaybe<Scalars['Int']>;
  quickbooksItemId?: InputMaybe<Scalars['String']>;
  retail?: InputMaybe<Scalars['Decimal']>;
  shipperHQDimensionalRuleGroups?: InputMaybe<Scalars['String']>;
  shipperHQPackingBoxes?: InputMaybe<Scalars['String']>;
  shipperHQShippingGroups?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variants?: InputMaybe<Array<InputMaybe<VariantInventoryVariantsModel>>>;
  weight?: InputMaybe<Scalars['Decimal']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

export type VariantInventoryVariantsModel = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDefaultSelection?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  itemNumberExtension?: InputMaybe<Scalars['String']>;
  itemNumberSortOrder?: InputMaybe<Scalars['Short']>;
  priceAdjustment?: InputMaybe<Scalars['Decimal']>;
  priceAdjustmentType?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Short']>;
  swatchFile?: InputMaybe<Scalars['String']>;
  swatchThumbnail?: InputMaybe<Scalars['String']>;
  swatchThumbnailColor?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantGroupId?: InputMaybe<Scalars['Int']>;
  variantInventoryId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightType?: InputMaybe<Scalars['String']>;
};

export type address = {
  __typename?: 'address';
  addressId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  isResidential?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  objectCreated: Scalars['DateTime'];
  objectOwner?: Maybe<Scalars['String']>;
  objectUpdated: Scalars['DateTime'];
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  street3?: Maybe<Scalars['String']>;
  streetNo?: Maybe<Scalars['String']>;
  test: Scalars['Boolean'];
  validationResults?: Maybe<validationResults>;
  zip?: Maybe<Scalars['String']>;
};

export type attributes = {
  __typename?: 'attributes';
  capacity: Scalars['Int'];
  count: Scalars['Int'];
  item?: Maybe<Scalars['String']>;
};

export type batchShipment = {
  __typename?: 'batchShipment';
  addressTo?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type batchShipmentInput = {
  carrierAccount?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
  serviceLevelToken?: InputMaybe<Scalars['String']>;
  shipment: CreateShipmentInput;
};

export type batchShipments = {
  __typename?: 'batchShipments';
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<result>>>;
};

export type billing = {
  __typename?: 'billing';
  payments?: Maybe<Array<Maybe<payment>>>;
};

export type extra = {
  __typename?: 'extra';
  insurance?: Maybe<insurance>;
  reference1?: Maybe<Scalars['String']>;
  reference2?: Maybe<Scalars['String']>;
};

export type getInventoryInput = {
  gtin?: InputMaybe<Scalars['String']>;
  itemName?: InputMaybe<Scalars['String']>;
  itemNumber?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  variantInventoryId?: InputMaybe<Scalars['Int']>;
};

export type getRequestInput = {
  count?: Scalars['Int'];
  expand?: Scalars['String'];
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: Scalars['String'];
  includeLookups?: Scalars['Boolean'];
  page?: Scalars['Int'];
  sort?: Scalars['String'];
};

export type insurance = {
  __typename?: 'insurance';
  amount?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type mcm_ChannelType = {
  __typename?: 'mcm_ChannelType';
  /** The site enum value */
  channel: mcm_SiteType;
  /** The channel code associated with the channel */
  channelCode?: Maybe<Scalars['String']>;
  /** The channel Id associated with the channel */
  channelId: Scalars['Int'];
  /** The display name for the channel */
  displayName?: Maybe<Scalars['String']>;
};

export type mcm_CreateOrderInput = {
  businessId: Scalars['Int'];
  order?: InputMaybe<mcm_orderInput>;
};

export type mcm_CreateOrderPayload = {
  __typename?: 'mcm_CreateOrderPayload';
  order?: Maybe<mcm_order>;
};

export enum mcm_CurrencyCode {
  AUD = 'AUD',
  BRL = 'BRL',
  CAD = 'CAD',
  CHF = 'CHF',
  CNY = 'CNY',
  CZK = 'CZK',
  DEFAULT = 'DEFAULT',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  HKD = 'HKD',
  HUF = 'HUF',
  JPY = 'JPY',
  MXN = 'MXN',
  NOK = 'NOK',
  NONE = 'NONE',
  NZD = 'NZD',
  PLN = 'PLN',
  RUB = 'RUB',
  SEK = 'SEK',
  SGD = 'SGD',
  USD = 'USD'
}

export type mcm_DeleteProductPayload = {
  __typename?: 'mcm_DeleteProductPayload';
  productIds?: Maybe<Array<Scalars['Int']>>;
  variations?: Maybe<Array<Scalars['Int']>>;
};

export type mcm_DisableIntegrationInput = {
  businessId: Scalars['Int'];
  /** Channel code, example: amazon-us, amazon-uk etc */
  channelCode: Scalars['String'];
};

export enum mcm_EmailType {
  INTEGRATION_DISCONNECTION = 'INTEGRATION_DISCONNECTION',
  ISSUE_SUMMARY_REPORT_DAILY = 'ISSUE_SUMMARY_REPORT_DAILY',
  ISSUE_SUMMARY_REPORT_MONTHLY = 'ISSUE_SUMMARY_REPORT_MONTHLY',
  ISSUE_SUMMARY_REPORT_WEEKLY = 'ISSUE_SUMMARY_REPORT_WEEKLY',
  MARKETPLACE_SALES_REPORT_DAILY = 'MARKETPLACE_SALES_REPORT_DAILY',
  MARKETPLACE_SALES_REPORT_MONTHLY = 'MARKETPLACE_SALES_REPORT_MONTHLY',
  MARKETPLACE_SALES_REPORT_WEEKLY = 'MARKETPLACE_SALES_REPORT_WEEKLY'
}

export type mcm_GetEmailSubscriptionsInput = {
  businessId: Scalars['Int'];
};

export type mcm_GetProductsInput = {
  businessId: Scalars['Int'];
  productIds?: InputMaybe<Array<Scalars['Int']>>;
  productSearchInput?: InputMaybe<mcm_ProductSearchInput>;
  skUs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type mcm_GetVendorInput = {
  businessId: Scalars['Int'];
  vendorId: Scalars['Int'];
};

export type mcm_GetVendorsInput = {
  businessId: Scalars['Int'];
};

export type mcm_HealthResult = {
  __typename?: 'mcm_HealthResult';
  database?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
};

export enum mcm_JobQueueType {
  DEFAULT = 'DEFAULT',
  HIGH_PRIORITY = 'HIGH_PRIORITY'
}

export enum mcm_JobRunType {
  KUBE_JOB = 'KUBE_JOB',
  WORKER = 'WORKER'
}

export enum mcm_JobType {
  AMAZON_SUPPRESSED_LISTINGS = 'AMAZON_SUPPRESSED_LISTINGS',
  AUGMENT_PRODUCT_DATA = 'AUGMENT_PRODUCT_DATA',
  AUGMENT_PRODUCT_IMAGES = 'AUGMENT_PRODUCT_IMAGES',
  CANCEL_ORDERS = 'CANCEL_ORDERS',
  CHANNEL_CATALOG_IMPORT = 'CHANNEL_CATALOG_IMPORT',
  CHANNEL_DATA_COMPARISON = 'CHANNEL_DATA_COMPARISON',
  CHECK_AMAZON_SHIPPING_PRICES = 'CHECK_AMAZON_SHIPPING_PRICES',
  CHECK_API_RATE_LIMITS = 'CHECK_API_RATE_LIMITS',
  CHECK_AUTHENTICATION_STATUS = 'CHECK_AUTHENTICATION_STATUS',
  CHECK_CHANNEL_TASKS = 'CHECK_CHANNEL_TASKS',
  CHECK_CHANNEL_TASKS_BY_GROUP = 'CHECK_CHANNEL_TASKS_BY_GROUP',
  DROPSHIP_EMAIL = 'DROPSHIP_EMAIL',
  DYNAMIC_PRICE_CALCULATOR = 'DYNAMIC_PRICE_CALCULATOR',
  EXPORT_CHANNEL_POLICY_SKU = 'EXPORT_CHANNEL_POLICY_SKU',
  EXPORT_FULFILLMENT_LAG_TIMES = 'EXPORT_FULFILLMENT_LAG_TIMES',
  EXPORT_FULFILLMENT_PRODUCTS = 'EXPORT_FULFILLMENT_PRODUCTS',
  EXPORT_INVENTORY = 'EXPORT_INVENTORY',
  EXPORT_OFFERS = 'EXPORT_OFFERS',
  EXPORT_ORDERS = 'EXPORT_ORDERS',
  EXPORT_REQUEST = 'EXPORT_REQUEST',
  FBA_ORDER_STATUS_UPDATE = 'FBA_ORDER_STATUS_UPDATE',
  HUB_SPOT_DAILY_SYNC = 'HUB_SPOT_DAILY_SYNC',
  HUB_SPOT_SUBSCRIPTION_SYNC = 'HUB_SPOT_SUBSCRIPTION_SYNC',
  IMPORT_ADVANCE_SHIP_NOTICES = 'IMPORT_ADVANCE_SHIP_NOTICES',
  IMPORT_AMAZON_SHIPPING_GROUPS = 'IMPORT_AMAZON_SHIPPING_GROUPS',
  IMPORT_CATEGORIES_AND_PROPERTIES = 'IMPORT_CATEGORIES_AND_PROPERTIES',
  IMPORT_CHANNEL_POLICIES = 'IMPORT_CHANNEL_POLICIES',
  IMPORT_CHANNEL_POLICY_DETAILS = 'IMPORT_CHANNEL_POLICY_DETAILS',
  IMPORT_CHANNEL_POLICY_SKU = 'IMPORT_CHANNEL_POLICY_SKU',
  IMPORT_ESTIMATED_FEES = 'IMPORT_ESTIMATED_FEES',
  IMPORT_ESTIMATED_FEES_BATCH = 'IMPORT_ESTIMATED_FEES_BATCH',
  IMPORT_INVENTORY = 'IMPORT_INVENTORY',
  IMPORT_LISTING_STATUS = 'IMPORT_LISTING_STATUS',
  IMPORT_MARKET_DATA = 'IMPORT_MARKET_DATA',
  IMPORT_ORDERS = 'IMPORT_ORDERS',
  IMPORT_ORDER_FEES = 'IMPORT_ORDER_FEES',
  IMPORT_PRODUCTS = 'IMPORT_PRODUCTS',
  IMPORT_PRODUCTS_STATISTICS = 'IMPORT_PRODUCTS_STATISTICS',
  IMPORT_RETURNS = 'IMPORT_RETURNS',
  IMPORT_SETTLEMENTS = 'IMPORT_SETTLEMENTS',
  IMPORT_TRACKING = 'IMPORT_TRACKING',
  IMPORT_WALMART_ASSORTMENT_RECOMMENDATIONS = 'IMPORT_WALMART_ASSORTMENT_RECOMMENDATIONS',
  IMPORT_WALMART_PRODUCT_REVIEWS = 'IMPORT_WALMART_PRODUCT_REVIEWS',
  IMPORT_WALMART_REVIEW_ACCELERATOR_ITEMS = 'IMPORT_WALMART_REVIEW_ACCELERATOR_ITEMS',
  IMPORT_WFS_INVENTORY_HEALTH = 'IMPORT_WFS_INVENTORY_HEALTH',
  INVENTORY_SITE_TO_LISTING = 'INVENTORY_SITE_TO_LISTING',
  INVENTORY_TO_CART_DAILY_DATA_SYNC = 'INVENTORY_TO_CART_DAILY_DATA_SYNC',
  INVENTORY_TO_PRODUCT_DATA_MIGRATION = 'INVENTORY_TO_PRODUCT_DATA_MIGRATION',
  KEEPA_TOKEN_STATUS = 'KEEPA_TOKEN_STATUS',
  OCEAN_X_CHECK_AUTHENTICATION_STATUS = 'OCEAN_X_CHECK_AUTHENTICATION_STATUS',
  OCEAN_X_EXPORT_ORDERS = 'OCEAN_X_EXPORT_ORDERS',
  OCEAN_X_IMPORT_ORDERS = 'OCEAN_X_IMPORT_ORDERS',
  ORDERS_TO_CART_DAILY_DATA_SYNC = 'ORDERS_TO_CART_DAILY_DATA_SYNC',
  ORDERS_TO_CART_HISTORICAL_DATA_SYNC = 'ORDERS_TO_CART_HISTORICAL_DATA_SYNC',
  ORDER_ADJUSTMENTS_TO_CART_DAILY_DATA_SYNC = 'ORDER_ADJUSTMENTS_TO_CART_DAILY_DATA_SYNC',
  ORG_SERVICE_DAILY_SYNC = 'ORG_SERVICE_DAILY_SYNC',
  ORG_SERVICE_SUBSCRIPTION_SYNC = 'ORG_SERVICE_SUBSCRIPTION_SYNC',
  PARENT_CHILD_QUANTITY_SYNC = 'PARENT_CHILD_QUANTITY_SYNC',
  PRICE_HISTORY_WRITER = 'PRICE_HISTORY_WRITER',
  PRODUCTS_TO_CART_DAILY_DATA_SYNC = 'PRODUCTS_TO_CART_DAILY_DATA_SYNC',
  PRODUCTS_UNAUGMENTED_STATUS = 'PRODUCTS_UNAUGMENTED_STATUS',
  PRODUCT_PARENT_SKU_RESOLVER = 'PRODUCT_PARENT_SKU_RESOLVER',
  PUBLISH_LISTINGS = 'PUBLISH_LISTINGS',
  PUBLISH_LISTINGS_BY_GROUP = 'PUBLISH_LISTINGS_BY_GROUP',
  QUEUE_PRODUCT_CATEGORIES_UPDATE = 'QUEUE_PRODUCT_CATEGORIES_UPDATE',
  REDACT_PERSONAL_INFORMATION = 'REDACT_PERSONAL_INFORMATION',
  REFRESH_MARKET_DATA_QUEUE = 'REFRESH_MARKET_DATA_QUEUE',
  REPRICING_FOR_MIRRORING_PRICE = 'REPRICING_FOR_MIRRORING_PRICE',
  REPRICING_FOR_VELOCITY_PRICING = 'REPRICING_FOR_VELOCITY_PRICING',
  REPRICING_FOR_WALMART_PRICE_EVENTS = 'REPRICING_FOR_WALMART_PRICE_EVENTS',
  SEND_DAILY_REPORTS = 'SEND_DAILY_REPORTS',
  SEND_MONTHLY_REPORTS = 'SEND_MONTHLY_REPORTS',
  SEND_ORDER_CHANGES_TO_CORE = 'SEND_ORDER_CHANGES_TO_CORE',
  SEND_WEEKLY_REPORTS = 'SEND_WEEKLY_REPORTS',
  SET_LISTINGS_QUANTITY_TO_ZERO = 'SET_LISTINGS_QUANTITY_TO_ZERO',
  STORES_TO_CART_DAILY_DATA_SYNC = 'STORES_TO_CART_DAILY_DATA_SYNC',
  STRIP_ZOOM_IMAGE_CLEANUP = 'STRIP_ZOOM_IMAGE_CLEANUP',
  SUBSCRIBER_HISTORY_TO_CART_DAILY_DATA_SYNC = 'SUBSCRIBER_HISTORY_TO_CART_DAILY_DATA_SYNC',
  SUBSCRIBER_TO_CART_DAILY_DATA_SYNC = 'SUBSCRIBER_TO_CART_DAILY_DATA_SYNC',
  SYNC_INVENTORY = 'SYNC_INVENTORY',
  SYNC_ORDERS = 'SYNC_ORDERS',
  SYNC_QUANTITIES = 'SYNC_QUANTITIES',
  UPDATE_CHANNEL_CATEGORIES = 'UPDATE_CHANNEL_CATEGORIES',
  UPDATE_DEMO_DATA = 'UPDATE_DEMO_DATA',
  UPDATE_EXCHANGE_RATES = 'UPDATE_EXCHANGE_RATES',
  UPDATE_PENDING_FBA_ORDERS = 'UPDATE_PENDING_FBA_ORDERS',
  UPDATE_SELLER_USAGE = 'UPDATE_SELLER_USAGE',
  UPDATE_SUBSCRIPTIONS = 'UPDATE_SUBSCRIPTIONS',
  UPDATE_SUBSCRIPTION_PLANS = 'UPDATE_SUBSCRIPTION_PLANS',
  WALMART_ADVERTISER_REPORTS = 'WALMART_ADVERTISER_REPORTS',
  WFS_FULFILLMENT_FEE_CACHE = 'WFS_FULFILLMENT_FEE_CACHE'
}

export type mcm_ProductSearchInput = {
  /** Max number of results to return */
  limit: Scalars['Int'];
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type mcm_QueueJobInput = {
  /** Seller account to run job for. */
  accountId: Scalars['Int'];
  /** Type of job to run. */
  jobType: mcm_JobType;
  /** Additional values for running job if needed. */
  launchValues?: InputMaybe<Scalars['Any']>;
  /** Priority of queue to run job in. */
  queueType?: mcm_JobQueueType;
  /** How to run the job, local or as a container. */
  runType?: mcm_JobRunType;
  /** Site or marketplace to run job for. */
  site: mcm_SiteType;
};

export type mcm_QueueJobPayload = {
  __typename?: 'mcm_QueueJobPayload';
  /** Whether or not the queue was successful. */
  success: Scalars['Boolean'];
};

export type mcm_RemoveProductInput = {
  businessId: Scalars['Int'];
  productIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type mcm_RemoveVendorInput = {
  businessId: Scalars['Int'];
  vendorId: Scalars['Int'];
};

export type mcm_RemoveVendorPayload = {
  __typename?: 'mcm_RemoveVendorPayload';
  id: Scalars['Int'];
};

export type mcm_ShippingAddress = {
  __typename?: 'mcm_ShippingAddress';
  /** Address line 1 */
  address1?: Maybe<Scalars['String']>;
  /** Address line 2 */
  address2?: Maybe<Scalars['String']>;
  /** Address line 3 */
  address3?: Maybe<Scalars['String']>;
  /** The city for the address */
  city?: Maybe<Scalars['String']>;
  /** The country for the address */
  country?: Maybe<Scalars['String']>;
  /** The whole name for the person attached to the address */
  name?: Maybe<Scalars['String']>;
  /** The phone number for the address */
  phone?: Maybe<Scalars['String']>;
  /** The postal code for the address */
  postalCode?: Maybe<Scalars['String']>;
  /** The state or region for the address */
  stateOrRegion?: Maybe<Scalars['String']>;
};

export type mcm_ShippingAddressInput = {
  /** Address line 1 */
  address1?: InputMaybe<Scalars['String']>;
  /** Address line 2 */
  address2?: InputMaybe<Scalars['String']>;
  /** Address line 3 */
  address3?: InputMaybe<Scalars['String']>;
  /** The city for the address */
  city?: InputMaybe<Scalars['String']>;
  /** The country for the address */
  country?: InputMaybe<Scalars['String']>;
  /** The whole name for the person attached to the address */
  name?: InputMaybe<Scalars['String']>;
  /** The phone number for the address */
  phone?: InputMaybe<Scalars['String']>;
  /** The postal code for the address */
  postalCode?: InputMaybe<Scalars['String']>;
  /** The state or region for the address */
  stateOrRegion?: InputMaybe<Scalars['String']>;
};

export type mcm_ShippingAddressPayload = {
  __typename?: 'mcm_ShippingAddressPayload';
  address?: Maybe<mcm_ShippingAddress>;
  orderId: Scalars['Int'];
};

export enum mcm_SiteType {
  AMAZON = 'AMAZON',
  AMAZON_AU = 'AMAZON_AU',
  AMAZON_CA = 'AMAZON_CA',
  AMAZON_DE = 'AMAZON_DE',
  AMAZON_ES = 'AMAZON_ES',
  AMAZON_FR = 'AMAZON_FR',
  AMAZON_IT = 'AMAZON_IT',
  AMAZON_MX = 'AMAZON_MX',
  AMAZON_UK = 'AMAZON_UK',
  BIG_COMMERCE = 'BIG_COMMERCE',
  BING = 'BING',
  CATCHALL = 'CATCHALL',
  CRITEO = 'CRITEO',
  CUSTOM = 'CUSTOM',
  DELIVERR = 'DELIVERR',
  EASY_POST = 'EASY_POST',
  EBAY = 'EBAY',
  ETSY = 'ETSY',
  FULFIL_IO = 'FULFIL_IO',
  JAZZ = 'JAZZ',
  MANUAL = 'MANUAL',
  META = 'META',
  NEWEGG = 'NEWEGG',
  NEWEGG_B2B = 'NEWEGG_B2B',
  NEWEGG_CA = 'NEWEGG_CA',
  NONE = 'NONE',
  ORACLE_NETSUITE = 'ORACLE_NETSUITE',
  PAYPAL = 'PAYPAL',
  PINTEREST = 'PINTEREST',
  QUICKBOOKS = 'QUICKBOOKS',
  QUICKBOOKS_ONLINE = 'QUICKBOOKS_ONLINE',
  SEARS_MARKETPLACE = 'SEARS_MARKETPLACE',
  SELLERACTIVE = 'SELLERACTIVE',
  SHIFT4_SHOP = 'SHIFT4_SHOP',
  SHIPWORKS = 'SHIPWORKS',
  SHIP_STATION = 'SHIP_STATION',
  SHIP_WIRE = 'SHIP_WIRE',
  SHIP_WISE = 'SHIP_WISE',
  SHOPIFY = 'SHOPIFY',
  SHOPIFY_POS = 'SHOPIFY_POS',
  SKU_VAULT = 'SKU_VAULT',
  SNAPCHAT = 'SNAPCHAT',
  STOREFRONT = 'STOREFRONT',
  THREE_D_CART = 'THREE_D_CART',
  TIKTOK = 'TIKTOK',
  TOP_SHELF = 'TOP_SHELF',
  VOLUSION = 'VOLUSION',
  WALMART = 'WALMART',
  WFS = 'WFS',
  WOO_COMMERCE = 'WOO_COMMERCE',
  WSM = 'WSM'
}

export type mcm_UpdateEmailSubscriptionInput = {
  updates?: InputMaybe<Array<InputMaybe<mcm_UpdateEmailSubscriptionUpdateInput>>>;
};

export type mcm_UpdateEmailSubscriptionUpdateInput = {
  businessId: Scalars['Int'];
  emailType: mcm_EmailType;
  enabled: Scalars['Boolean'];
};

export type mcm_UpsertJobScheduleInput = {
  /** Whether or not this job is enabled to run. */
  enabled: Scalars['Boolean'];
  /** The internal in seconds to repeat this job. */
  intervalSeconds: Scalars['Int'];
  /** Type of job to run. */
  jobType: mcm_JobType;
  /** Last time this job was scheduled. */
  lastScheduled: Scalars['DateTime'];
  /** Priority of queue to run job in. */
  queueType: mcm_JobQueueType;
  /** How to run the job, local or as a container. */
  runType: mcm_JobRunType;
  /** Site or marketplace to run job for. */
  site: mcm_SiteType;
  /** The SQL stored procedure to use to get account IDs. */
  storedProcedureName?: InputMaybe<Scalars['String']>;
};

export type mcm_UpsertVendorInput = {
  businessId: Scalars['Int'];
  vendor?: InputMaybe<mcm_vendorInput>;
};

export type mcm_UpsertVendorPayload = {
  __typename?: 'mcm_UpsertVendorPayload';
  vendor?: Maybe<mcm_vendor>;
};

export type mcm_emailSubscription = {
  __typename?: 'mcm_emailSubscription';
  businessId: Scalars['Int'];
  businessName?: Maybe<Scalars['String']>;
  emailType: mcm_EmailType;
  enabled: Scalars['Boolean'];
};

export type mcm_jobSchedule = {
  __typename?: 'mcm_jobSchedule';
  /** Whether or not this job is enabled to run. */
  enabled: Scalars['Boolean'];
  /** The interval in seconds to repeat this job. */
  intervalSeconds: Scalars['Int'];
  /** Type of job to run. */
  jobType: mcm_JobType;
  /** Last time this job was scheduled. */
  lastScheduled: Scalars['DateTime'];
  /** Priority of queue to run job in. */
  queueType: mcm_JobQueueType;
  /** How to run the job: worker or as a kube job. */
  runType: mcm_JobRunType;
  /** Site or marketplace to run job for. */
  site: mcm_SiteType;
  /** The SQL stored procedure to use to get account IDs. */
  storedProcedureName?: Maybe<Scalars['String']>;
};

export type mcm_order = {
  __typename?: 'mcm_order';
  buyerEmail: Scalars['String'];
  discountAmount?: Maybe<Scalars['Decimal']>;
  note?: Maybe<Scalars['String']>;
  orderItems?: Maybe<Array<Maybe<mcm_orderItem>>>;
  shippingAddress?: Maybe<mcm_ShippingAddress>;
};

export type mcm_orderInput = {
  buyerEmail: Scalars['String'];
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  note?: InputMaybe<Scalars['String']>;
  orderItems?: InputMaybe<Array<InputMaybe<mcm_orderItemInput>>>;
  shippingAddress?: InputMaybe<mcm_ShippingAddressInput>;
};

export type mcm_orderItem = {
  __typename?: 'mcm_orderItem';
  currencyCode: mcm_CurrencyCode;
  giftMessage?: Maybe<Scalars['String']>;
  itemTax: Scalars['Decimal'];
  quantityOrdered: Scalars['Int'];
  shippingPrice: Scalars['Decimal'];
  shippingServiceOrdered?: Maybe<Scalars['String']>;
  shippingTax: Scalars['Decimal'];
  sku: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Decimal'];
};

export type mcm_orderItemInput = {
  currencyCode: mcm_CurrencyCode;
  giftMessage?: InputMaybe<Scalars['String']>;
  itemTax: Scalars['Decimal'];
  quantityOrdered: Scalars['Int'];
  shippingPrice: Scalars['Decimal'];
  shippingServiceOrdered?: InputMaybe<Scalars['String']>;
  shippingTax: Scalars['Decimal'];
  sku: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  unitPrice: Scalars['Decimal'];
};

export type mcm_product = {
  __typename?: 'mcm_product';
  cost?: Maybe<Scalars['Decimal']>;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  map?: Maybe<Scalars['Decimal']>;
  modified: Scalars['DateTime'];
  msrp?: Maybe<Scalars['Decimal']>;
  parentId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  productTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  quantities?: Maybe<Array<Maybe<mcm_quantity>>>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type mcm_quantity = {
  __typename?: 'mcm_quantity';
  priority?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  quantityAvailable: Scalars['Int'];
  sku?: Maybe<Scalars['String']>;
};

export type mcm_shippingAddressUpdateInput = {
  address?: InputMaybe<mcm_ShippingAddressInput>;
  businessId: Scalars['Int'];
  orderId: Scalars['Int'];
};

export type mcm_vendor = {
  __typename?: 'mcm_vendor';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  autoEmailCCAddress?: Maybe<Scalars['String']>;
  autoEmailOrders: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  daysToRestock: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  phone1?: Maybe<Scalars['String']>;
  phone2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  shippingAccountNumber?: Maybe<Scalars['String']>;
  stateOrRegion?: Maybe<Scalars['String']>;
  vendorAccountNumber?: Maybe<Scalars['String']>;
};

export type mcm_vendorInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  autoEmailCCAddress?: InputMaybe<Scalars['String']>;
  autoEmailOrders: Scalars['Boolean'];
  city?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  daysToRestock: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  phone1?: InputMaybe<Scalars['String']>;
  phone2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  shippingAccountNumber?: InputMaybe<Scalars['String']>;
  stateOrRegion?: InputMaybe<Scalars['String']>;
  vendorAccountNumber?: InputMaybe<Scalars['String']>;
};

export type message = {
  __typename?: 'message';
  code?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type objectResults = {
  __typename?: 'objectResults';
  creationFailed: Scalars['Int'];
  creationSucceeded: Scalars['Int'];
  purchaseFailed: Scalars['Int'];
  purchaseSucceeded: Scalars['Int'];
};

export type paginationOptions = {
  count?: Scalars['Int'];
  page?: Scalars['Int'];
};

export type parcel = {
  __typename?: 'parcel';
  distanceUnit?: Maybe<Scalars['String']>;
  extra?: Maybe<parcelExtra>;
  height?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  massUnit?: Maybe<Scalars['String']>;
  parcelId?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type parcelExtra = {
  __typename?: 'parcelExtra';
  insurance?: Maybe<parcelInsurance>;
};

export type parcelInsurance = {
  __typename?: 'parcelInsurance';
  amount: Scalars['Decimal'];
  content?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

export type payment = {
  __typename?: 'payment';
  tBD?: Maybe<Scalars['String']>;
};

export type rate = {
  __typename?: 'rate';
  amount: Scalars['Decimal'];
  amountLocal: Scalars['Decimal'];
  arrivesBy?: Maybe<Scalars['String']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  carrierAccount?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  currencyLocal?: Maybe<Scalars['String']>;
  durationTerms?: Maybe<Scalars['String']>;
  estimatedDays: Scalars['Int'];
  isFlatRate: Scalars['Boolean'];
  messages?: Maybe<Array<Maybe<rateMessage>>>;
  objectCreated: Scalars['DateTime'];
  objectOwner?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerImage75?: Maybe<Scalars['String']>;
  providerImage200?: Maybe<Scalars['String']>;
  rateId?: Maybe<Scalars['String']>;
  serviceLevel?: Maybe<serviceLevel>;
  shipmentObjectId?: Maybe<Scalars['String']>;
  test: Scalars['Boolean'];
  zone?: Maybe<Scalars['String']>;
};

export type rateMessage = {
  __typename?: 'rateMessage';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type result = {
  __typename?: 'result';
  carrierAccount?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  metadata?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['String']>;
  servicelevelToken?: Maybe<Scalars['String']>;
  shipment?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transaction?: Maybe<Scalars['String']>;
};

export type serviceLevel = {
  __typename?: 'serviceLevel';
  extendedToken?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentServiceLevel?: Maybe<serviceLevel>;
  terms?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type store_Address = {
  __typename?: 'store_Address';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  alternatePhone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  fax?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDefaultBillingAddress: Scalars['Boolean'];
  isDefaultShippingAddress: Scalars['Boolean'];
  isNew?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_CustomerPaymentField = {
  __typename?: 'store_CustomerPaymentField';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerPaymentMethodId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isEncrypted?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isValueMasked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type store_CustomerPaymentMethod = {
  __typename?: 'store_CustomerPaymentMethod';
  addressID?: Maybe<Scalars['Int']>;
  cardId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  fields?: Maybe<Array<Maybe<store_CustomerPaymentField>>>;
  id?: Maybe<Scalars['Int']>;
  isDefault: Scalars['Boolean'];
  isNew?: Maybe<Scalars['Boolean']>;
  paymentMethodId?: Maybe<Scalars['Int']>;
  paymentType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_CustomerPaymentMethodsAvailability = {
  __typename?: 'store_CustomerPaymentMethodsAvailability';
  customerId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isNew?: Maybe<Scalars['Boolean']>;
  paymentMethodId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  storePaymentMethodId?: Maybe<Scalars['Int']>;
};

export type store_attribute = {
  __typename?: 'store_attribute';
  attributeGroupId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlRewrite?: Maybe<Scalars['String']>;
};

export type store_attributeGroup = {
  __typename?: 'store_attributeGroup';
  allowDrillDown?: Maybe<Scalars['Boolean']>;
  allowMultiple?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  tieVariantInventory?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_attributeGroupListResult = {
  __typename?: 'store_attributeGroupListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_attributeGroup>>>;
};

export type store_attributeListResult = {
  __typename?: 'store_attributeListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_attribute>>>;
};

export type store_cart = {
  __typename?: 'store_cart';
  cartId?: Maybe<Scalars['Int']>;
  childItems?: Maybe<Array<Maybe<store_cart>>>;
  configuration?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fitment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isSubscriptionProduct?: Maybe<Scalars['Boolean']>;
  itemName?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  itemThumbnail?: Maybe<Scalars['String']>;
  itemUrl?: Maybe<Scalars['String']>;
  parentCartItemId?: Maybe<Scalars['Int']>;
  parentProductId?: Maybe<Scalars['Int']>;
  personalizations?: Maybe<Array<Maybe<store_cartItemPersonalization>>>;
  price?: Maybe<Scalars['Decimal']>;
  productId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  shippingAddressID?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<Array<Maybe<store_cartItemVariant>>>;
  vendorStoreId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
};

export type store_cartInfo = {
  __typename?: 'store_cartInfo';
  additionalFees?: Maybe<Scalars['Decimal']>;
  associatedOrderId?: Maybe<Scalars['Int']>;
  cartType?: Maybe<Scalars['String']>;
  couponCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  customerPaymentMethodId?: Maybe<Scalars['Int']>;
  discountTotal?: Maybe<Scalars['Decimal']>;
  discountedShippingTotal?: Maybe<Scalars['Decimal']>;
  giftCertificateDiscount?: Maybe<Scalars['Decimal']>;
  grandTotal?: Maybe<Scalars['Decimal']>;
  handlingTotal?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  isPaymentCartOnly?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isShippingBilledToAccount?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<store_cart>>>;
  lookupKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nonShippingDiscount?: Maybe<Scalars['Decimal']>;
  paymentMethodId?: Maybe<Scalars['Int']>;
  regionMarkupAmount?: Maybe<Scalars['Decimal']>;
  sessionId?: Maybe<Scalars['Int']>;
  shippingEstimateCity?: Maybe<Scalars['String']>;
  shippingEstimateCountryCode?: Maybe<Scalars['String']>;
  shippingEstimatePostalCode?: Maybe<Scalars['String']>;
  shippingEstimateStateCode?: Maybe<Scalars['String']>;
  shippingTotal?: Maybe<Scalars['Decimal']>;
  storeId?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Decimal']>;
  taxRate?: Maybe<Scalars['Decimal']>;
  taxTotal?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_cartItemPersonalization = {
  __typename?: 'store_cartItemPersonalization';
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type store_cartItemVariant = {
  __typename?: 'store_cartItemVariant';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  variantGroupId?: Maybe<Scalars['Int']>;
};

export type store_cartListResult = {
  __typename?: 'store_cartListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_cart>>>;
};

export type store_categories = {
  __typename?: 'store_categories';
  alternateThumbnail?: Maybe<Scalars['String']>;
  areSubcategoryProductsDisplayed?: Maybe<Scalars['Boolean']>;
  catImageAltText?: Maybe<Scalars['String']>;
  categoryImage?: Maybe<Scalars['String']>;
  categoryThumbnail?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFields?: Maybe<Array<Maybe<store_customFieldValueSimple>>>;
  defaultProductPicture?: Maybe<Scalars['String']>;
  externalContentUrl?: Maybe<Scalars['String']>;
  headTags?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isCategoryContentDisplayed?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isHideFromSiteMaps?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  lookupPath?: Maybe<Scalars['String']>;
  maxQuantity?: Maybe<Scalars['Int']>;
  metaDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  parentCategoryId?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<store_product>>>;
  shortDescription?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  thumbImageAltText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlRewrite?: Maybe<Scalars['String']>;
  vendorStoreId?: Maybe<Scalars['Int']>;
};

export type store_categoriesListResult = {
  __typename?: 'store_categoriesListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_categories>>>;
};

export type store_changeInventory = {
  __typename?: 'store_changeInventory';
  gtin?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  variantInventoryId?: Maybe<Scalars['Int']>;
};

export type store_customField = {
  __typename?: 'store_customField';
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultValue?: Maybe<Scalars['String']>;
  displayLocation?: Maybe<Scalars['String']>;
  fieldWidth?: Maybe<Scalars['Int']>;
  formatString?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inputType?: Maybe<Scalars['String']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isMultiSelect?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  isSearchable?: Maybe<Scalars['Boolean']>;
  isVisibleAllStores?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  listItems?: Maybe<Array<Maybe<store_customFieldListItem>>>;
  name?: Maybe<Scalars['String']>;
  readOnly?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  showOnOnePageCheckout?: Maybe<Scalars['Boolean']>;
  showOnOrderPage?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
  stores?: Maybe<Array<Maybe<store_customFieldStores>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  valueType?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<store_customFieldValue>>>;
};

export type store_customFieldListItem = {
  __typename?: 'store_customFieldListItem';
  customFieldId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isNew?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type store_customFieldListItemListResult = {
  __typename?: 'store_customFieldListItemListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_customFieldListItem>>>;
};

export type store_customFieldListResult = {
  __typename?: 'store_customFieldListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_customField>>>;
};

export type store_customFieldStores = {
  __typename?: 'store_customFieldStores';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type store_customFieldStoresListResult = {
  __typename?: 'store_customFieldStoresListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_customFieldStores>>>;
};

export type store_customFieldValue = {
  __typename?: 'store_customFieldValue';
  createdAt?: Maybe<Scalars['DateTime']>;
  customFieldId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isNew?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type store_customFieldValueInput = {
  customFieldId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

export type store_customFieldValueInputSimple = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type store_customFieldValueListResult = {
  __typename?: 'store_customFieldValueListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_customFieldValue>>>;
};

export type store_customFieldValueSimple = {
  __typename?: 'store_customFieldValueSimple';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type store_customer = {
  __typename?: 'store_customer';
  adcode?: Maybe<Scalars['String']>;
  adcodeId?: Maybe<Scalars['Int']>;
  addresses?: Maybe<Array<Maybe<store_Address>>>;
  affiliateId?: Maybe<Scalars['Int']>;
  alternatePhoneNumber?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditLimit?: Maybe<Scalars['Decimal']>;
  customFields?: Maybe<Array<Maybe<store_customFieldValueSimple>>>;
  customerNumber?: Maybe<Scalars['String']>;
  customerPaymentMethodsAvailability?: Maybe<Array<Maybe<store_CustomerPaymentMethodsAvailability>>>;
  customerTypeId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isAffiliateCustomer?: Maybe<Scalars['Boolean']>;
  isContactInformationOnly?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isNoTaxCustomer?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastVisitAt?: Maybe<Scalars['DateTime']>;
  lockDefaultAddress?: Maybe<Scalars['Boolean']>;
  noAccount?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  paymentNetTerm?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  rewardPoints?: Maybe<Array<Maybe<store_rewardPoints>>>;
  rewardTierId?: Maybe<Scalars['Int']>;
  salesPerson?: Maybe<Scalars['String']>;
  salesPersonUserID?: Maybe<Scalars['Int']>;
  searchString?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceGroup?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['Int']>;
  storePaymentMethodsEnabled?: Maybe<Array<Maybe<Scalars['String']>>>;
  sub?: Maybe<Scalars['String']>;
  taxExemptionNumber?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type store_customerListResult = {
  __typename?: 'store_customerListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_customer>>>;
};

export type store_customerPaymentFieldListResult = {
  __typename?: 'store_customerPaymentFieldListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_customer>>>;
};

export type store_deleteMessage = {
  __typename?: 'store_deleteMessage';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type store_manufacturer = {
  __typename?: 'store_manufacturer';
  brandCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  headTags?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  manufacturerLogoUrl?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlRewrite?: Maybe<Scalars['String']>;
};

export type store_manufacturerListResult = {
  __typename?: 'store_manufacturerListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_manufacturer>>>;
};

export type store_order = {
  __typename?: 'store_order';
  adcode?: Maybe<Scalars['String']>;
  adcodeId?: Maybe<Scalars['Int']>;
  additionalFees?: Maybe<Scalars['Decimal']>;
  adminComments?: Maybe<Scalars['String']>;
  affiliateId?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<store_orderAddress>;
  campaignCode?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  costTotal?: Maybe<Scalars['Decimal']>;
  couponCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFields?: Maybe<Array<Maybe<store_customFieldValueSimple>>>;
  customer?: Maybe<store_customer>;
  customerId?: Maybe<Scalars['Int']>;
  customerTypeId?: Maybe<Scalars['Int']>;
  deliveryTax?: Maybe<Scalars['Decimal']>;
  device?: Maybe<Scalars['String']>;
  discountTotal?: Maybe<Scalars['Decimal']>;
  discountedShippingTotal?: Maybe<Scalars['Decimal']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  enteredBy?: Maybe<Scalars['String']>;
  enteredByType?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  exportedToAccountingSystem?: Maybe<Scalars['Int']>;
  fromQuoteId?: Maybe<Scalars['Int']>;
  fromSubscriptionId?: Maybe<Scalars['Int']>;
  giftMessage?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['Decimal']>;
  handlingTotal?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  instructions?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  isGift?: Maybe<Scalars['Boolean']>;
  isPaymentOrderOnly?: Maybe<Scalars['Boolean']>;
  isPpc?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<store_orderItem>>>;
  manufacturerInvoiceAmount?: Maybe<Scalars['Decimal']>;
  manufacturerInvoiceNumber?: Maybe<Scalars['String']>;
  manufacturerInvoicePaid?: Maybe<Scalars['Boolean']>;
  orderBillingAddressId?: Maybe<Scalars['Int']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderShippingAddressId?: Maybe<Scalars['Int']>;
  orderStatus?: Maybe<store_orderStatus>;
  orderStatusId?: Maybe<Scalars['Int']>;
  orderStatusLastChangedAt?: Maybe<Scalars['DateTime']>;
  orderType?: Maybe<Scalars['String']>;
  orderedAt?: Maybe<Scalars['DateTime']>;
  payments?: Maybe<Array<Maybe<store_orderPayment>>>;
  ppcKeyword?: Maybe<Scalars['String']>;
  previousOrderStatusId?: Maybe<Scalars['Int']>;
  publicComments?: Maybe<Scalars['String']>;
  referrer?: Maybe<Scalars['String']>;
  rewardPointsCredited?: Maybe<Scalars['Boolean']>;
  salesAgentUserID?: Maybe<Scalars['Int']>;
  searchPhrase?: Maybe<Scalars['String']>;
  selectedShippingMethod?: Maybe<Scalars['String']>;
  selectedShippingProviderService?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['Int']>;
  shipments?: Maybe<Array<Maybe<store_orderShipping>>>;
  shippingAddress?: Maybe<store_orderAddress>;
  shippingSelections?: Maybe<Array<Maybe<store_shippingSelections>>>;
  shippingTotal?: Maybe<Scalars['Decimal']>;
  source?: Maybe<Scalars['String']>;
  sourceGroup?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Decimal']>;
  taxTotal?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_orderAddress = {
  __typename?: 'store_orderAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  alternatePhone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  fax?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_orderAddressListResult = {
  __typename?: 'store_orderAddressListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderAddress>>>;
};

export type store_orderItem = {
  __typename?: 'store_orderItem';
  adminComments?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['Decimal']>;
  discountPercentage?: Maybe<Scalars['Decimal']>;
  doNotDiscount?: Maybe<Scalars['Boolean']>;
  fitment?: Maybe<Scalars['String']>;
  giftMessage?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  isDiscountItem?: Maybe<Scalars['Boolean']>;
  isNonShippingItem?: Maybe<Scalars['Boolean']>;
  isQuantityBoundToParent?: Maybe<Scalars['Boolean']>;
  isSubscriptionProduct?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  itemName?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  itemNumberFull?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Decimal']>;
  lineItemNote?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  orderShippingAddressId?: Maybe<Scalars['Int']>;
  parentOrderItemId?: Maybe<Scalars['Int']>;
  personalizations?: Maybe<Array<Maybe<store_orderItemVariant>>>;
  price?: Maybe<Scalars['Decimal']>;
  productId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  selectedShippingMethod?: Maybe<Scalars['String']>;
  selectedShippingMethodId?: Maybe<Scalars['Int']>;
  selectedShippingProviderService?: Maybe<Scalars['String']>;
  shippingClassificationCode?: Maybe<Scalars['String']>;
  shippingTotal?: Maybe<Scalars['Decimal']>;
  sizeUnit?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Decimal']>;
  taxCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variantInventoryID?: Maybe<Scalars['Int']>;
  variants?: Maybe<Array<Maybe<store_orderItemVariant>>>;
  vendorStoreId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightUnit?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Decimal']>;
};

export type store_orderItemListResult = {
  __typename?: 'store_orderItemListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderItem>>>;
};

export type store_orderItemPersonalization = {
  __typename?: 'store_orderItemPersonalization';
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type store_orderItemVariant = {
  __typename?: 'store_orderItemVariant';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  variantGroupId?: Maybe<Scalars['Int']>;
};

export type store_orderListResult = {
  __typename?: 'store_orderListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_order>>>;
};

export type store_orderPayment = {
  __typename?: 'store_orderPayment';
  amount?: Maybe<Scalars['Decimal']>;
  approvedAt?: Maybe<Scalars['String']>;
  authorizationCode?: Maybe<Scalars['String']>;
  avsCode?: Maybe<Scalars['String']>;
  cardExpirationMonth: Scalars['Int'];
  cardExpirationYear: Scalars['Int'];
  cardType?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  customerPaymentMethodId?: Maybe<Scalars['Int']>;
  cvvResponseCode?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<store_orderPaymentField>>>;
  gatewayResponseCode?: Maybe<Scalars['String']>;
  giftCertificateId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isCaptured?: Maybe<Scalars['Boolean']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isVoid?: Maybe<Scalars['Boolean']>;
  lastFour?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentMethodId?: Maybe<Scalars['Int']>;
  paymentMethodName?: Maybe<Scalars['String']>;
  paymentNote?: Maybe<Scalars['String']>;
  paymentRefNum?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  rejectReason?: Maybe<Scalars['String']>;
  sentToSparkPay?: Maybe<Scalars['Boolean']>;
  storePaymentMethodId?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_orderPaymentField = {
  __typename?: 'store_orderPaymentField';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isEncrypted?: Maybe<Scalars['Boolean']>;
  isMasked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  orderPaymentId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type store_orderPaymentFieldListResult = {
  __typename?: 'store_orderPaymentFieldListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderPaymentField>>>;
};

export type store_orderPaymentListResult = {
  __typename?: 'store_orderPaymentListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderPayment>>>;
};

export type store_orderShipping = {
  __typename?: 'store_orderShipping';
  createdAt?: Maybe<Scalars['DateTime']>;
  emailSent?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<store_orderShippingOrderItems>>>;
  numberOfPackages?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
  privateComment?: Maybe<Scalars['String']>;
  providerBaseShippingCost?: Maybe<Scalars['String']>;
  providerHandlingCost?: Maybe<Scalars['Decimal']>;
  providerInsuranceCost?: Maybe<Scalars['Decimal']>;
  providerOtherCharges?: Maybe<Scalars['Decimal']>;
  providerTotalShippingCost?: Maybe<Scalars['Decimal']>;
  shipmentName?: Maybe<Scalars['String']>;
  shippedAt?: Maybe<Scalars['DateTime']>;
  shippingComment?: Maybe<Scalars['String']>;
  shippingMethod?: Maybe<Scalars['String']>;
  shippingMethodId?: Maybe<Scalars['Int']>;
  shippingMethodType?: Maybe<Scalars['String']>;
  shippingProviderName?: Maybe<Scalars['String']>;
  totalWeight?: Maybe<Scalars['Decimal']>;
  trackingNumbers?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_orderShippingListResult = {
  __typename?: 'store_orderShippingListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderShipping>>>;
};

export type store_orderShippingOrderItems = {
  __typename?: 'store_orderShippingOrderItems';
  id?: Maybe<Scalars['Int']>;
  itemName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  quantityShipped?: Maybe<Scalars['Int']>;
};

export type store_orderShippingOrderItemsListResult = {
  __typename?: 'store_orderShippingOrderItemsListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderShippingOrderItems>>>;
};

export type store_orderShippingSelectionsListResult = {
  __typename?: 'store_orderShippingSelectionsListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderItem>>>;
};

export type store_orderStatus = {
  __typename?: 'store_orderStatus';
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emailTemplateId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isFullyRefunded?: Maybe<Scalars['Boolean']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  isPartiallyRefunded?: Maybe<Scalars['Boolean']>;
  isPartiallyShipped?: Maybe<Scalars['Boolean']>;
  isQuoteStatus?: Maybe<Scalars['Boolean']>;
  isShipped?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_orderStatusListResult = {
  __typename?: 'store_orderStatusListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_orderStatus>>>;
};

export type store_personalize = {
  __typename?: 'store_personalize';
  createdAt?: Maybe<Scalars['DateTime']>;
  displayType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isMultiLine?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  isStep?: Maybe<Scalars['Boolean']>;
  markupFee?: Maybe<Scalars['Decimal']>;
  maxLength?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  stepGroup?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_personalizeListResult = {
  __typename?: 'store_personalizeListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_personalize>>>;
};

export type store_postManyResult = {
  __typename?: 'store_postManyResult';
  results?: Maybe<Array<Maybe<store_postResult>>>;
  totalErrors: Scalars['Int'];
};

export type store_postResult = {
  __typename?: 'store_postResult';
  details?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['Int']>;
  lineItem: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
};

export type store_product = {
  __typename?: 'store_product';
  addToCartMessage?: Maybe<Scalars['String']>;
  additionalAttributes?: Maybe<Scalars['String']>;
  additionalPointsEarned?: Maybe<Scalars['Int']>;
  allowedVariableSubscriptionTypes?: Maybe<Scalars['String']>;
  approvalRequired?: Maybe<Scalars['Boolean']>;
  attributes?: Maybe<Array<Maybe<store_productAttribute>>>;
  availableRegionId?: Maybe<Scalars['Int']>;
  averageReviewRating?: Maybe<Scalars['Decimal']>;
  breakOutShipping?: Maybe<Scalars['Boolean']>;
  bullets?: Maybe<Scalars['String']>;
  bulletsExternalUrl?: Maybe<Scalars['String']>;
  callForPricing?: Maybe<Scalars['Int']>;
  callForShipping?: Maybe<Scalars['Int']>;
  callForShippingOnWholeOrder?: Maybe<Scalars['Boolean']>;
  cartProductId?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Maybe<store_productcategories>>>;
  categoryList?: Maybe<Scalars['String']>;
  childProducts?: Maybe<Array<Maybe<store_productGroupRelations>>>;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFields?: Maybe<Array<Maybe<store_customFieldValueSimple>>>;
  customFlag1?: Maybe<Scalars['Boolean']>;
  customFlag2?: Maybe<Scalars['Boolean']>;
  customFlag3?: Maybe<Scalars['Boolean']>;
  customFlag4?: Maybe<Scalars['Boolean']>;
  customFlag5?: Maybe<Scalars['Boolean']>;
  customUpsellUrl?: Maybe<Scalars['String']>;
  daysUntilReorderAllowed?: Maybe<Scalars['Int']>;
  doNotDiscount?: Maybe<Scalars['Boolean']>;
  doNotSendReviewRequest?: Maybe<Scalars['Boolean']>;
  dropShip?: Maybe<Scalars['Boolean']>;
  eProductAllowMultipleDeliveries?: Maybe<Scalars['Int']>;
  eProductDeliveryAction?: Maybe<Scalars['String']>;
  eProductEmail?: Maybe<Scalars['String']>;
  eProductGenericPassword?: Maybe<Scalars['String']>;
  eProductGenericUsername?: Maybe<Scalars['String']>;
  eProductPassword?: Maybe<Scalars['String']>;
  eProductSerialNumberFilePath?: Maybe<Scalars['String']>;
  eProductType?: Maybe<Scalars['String']>;
  eProductUrl?: Maybe<Scalars['String']>;
  eProductVerificationLinkExpiration?: Maybe<Scalars['Int']>;
  earnsPoints?: Maybe<Scalars['Boolean']>;
  enableLowStockWarning?: Maybe<Scalars['Boolean']>;
  enabledConfigurator?: Maybe<Scalars['String']>;
  etaDate?: Maybe<Scalars['DateTime']>;
  excludeChildrenFromDisplay?: Maybe<Scalars['Boolean']>;
  excludeFromCommissions?: Maybe<Scalars['Boolean']>;
  excludeParentFromDisplay?: Maybe<Scalars['Boolean']>;
  extUpdateDate?: Maybe<Scalars['DateTime']>;
  forceSeparateOrder?: Maybe<Scalars['Boolean']>;
  freightClass?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  hSCode?: Maybe<Scalars['String']>;
  handlingFee?: Maybe<Scalars['Decimal']>;
  hasVisibleVariants?: Maybe<Scalars['Boolean']>;
  headTags?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  hideVariantSurcharges?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  inStockNotificationEmailTemplateId?: Maybe<Scalars['Int']>;
  inactiveStoreIds?: Maybe<Array<Scalars['Int']>>;
  insuranceCost?: Maybe<Scalars['Decimal']>;
  isChildProduct?: Maybe<Scalars['Boolean']>;
  isDiscontinued?: Maybe<Scalars['Boolean']>;
  isEnableVariantsOnParent?: Maybe<Scalars['Boolean']>;
  isFeaturedItem?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Int']>;
  isHideChildrenOnParent?: Maybe<Scalars['Boolean']>;
  isKit?: Maybe<Scalars['Boolean']>;
  isLinkedProduct?: Maybe<Scalars['Boolean']>;
  isNonInventory?: Maybe<Scalars['Boolean']>;
  isNonShippingItem?: Maybe<Scalars['Boolean']>;
  isNonTaxable?: Maybe<Scalars['Int']>;
  isShippedIndividually?: Maybe<Scalars['Int']>;
  isSpotlightItem?: Maybe<Scalars['Int']>;
  isSubscriptionProduct?: Maybe<Scalars['Boolean']>;
  itemName?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  lastItemNumber?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  longDescription1?: Maybe<Scalars['String']>;
  longDescription2?: Maybe<Scalars['String']>;
  longDescription3?: Maybe<Scalars['String']>;
  longDescription4?: Maybe<Scalars['String']>;
  longDescription5?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl1?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl2?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl3?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl4?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl5?: Maybe<Scalars['String']>;
  longDescriptionTabName1?: Maybe<Scalars['String']>;
  longDescriptionTabName2?: Maybe<Scalars['String']>;
  longDescriptionTabName3?: Maybe<Scalars['String']>;
  longDescriptionTabName4?: Maybe<Scalars['String']>;
  longDescriptionTabName5?: Maybe<Scalars['String']>;
  lowStockWarningThreshold?: Maybe<Scalars['Int']>;
  manufacturerId?: Maybe<Scalars['Int']>;
  manufacturerPartNumber?: Maybe<Scalars['String']>;
  masterProductId?: Maybe<Scalars['Int']>;
  materialCode?: Maybe<Scalars['String']>;
  maximumQuantity?: Maybe<Scalars['Short']>;
  metaDescription?: Maybe<Scalars['String']>;
  minimumQuantity?: Maybe<Scalars['Short']>;
  noPriceMask?: Maybe<Scalars['String']>;
  overrideThemeUseTabs?: Maybe<Scalars['Boolean']>;
  packSlipSortOrder?: Maybe<Scalars['Int']>;
  pageTitle?: Maybe<Scalars['String']>;
  personalizations?: Maybe<Array<Maybe<store_personalize>>>;
  pictures?: Maybe<Array<Maybe<store_productPicture>>>;
  price?: Maybe<Scalars['Decimal']>;
  pricing?: Maybe<Array<Maybe<store_productPricing>>>;
  primaryCategoryId?: Maybe<Scalars['Int']>;
  productLineCode?: Maybe<Scalars['String']>;
  productRatingDimensionGroupOverrideId?: Maybe<Scalars['Int']>;
  productStatusId?: Maybe<Scalars['Int']>;
  profileId?: Maybe<Scalars['Int']>;
  quantityIncrement?: Maybe<Scalars['Int']>;
  quantityOnHand?: Maybe<Scalars['Int']>;
  quantityOnOrder?: Maybe<Scalars['Int']>;
  quickbooksItemId?: Maybe<Scalars['String']>;
  rateAdjustmentType?: Maybe<Scalars['String']>;
  related?: Maybe<Array<Maybe<store_relatedProducts>>>;
  relatedName?: Maybe<Scalars['String']>;
  retail?: Maybe<Scalars['Decimal']>;
  reviewCount?: Maybe<Scalars['Int']>;
  reviews?: Maybe<Array<Maybe<store_profilePost>>>;
  shipperHQDimensionalRuleGroups?: Maybe<Scalars['String']>;
  shipperHQPackingBoxes?: Maybe<Scalars['String']>;
  shipperHQShippingGroups?: Maybe<Scalars['String']>;
  shippingClassificationCode?: Maybe<Scalars['String']>;
  shippingOverride?: Maybe<Scalars['Decimal']>;
  shippingRateAdjustments?: Maybe<Array<Maybe<store_shippingRateAdjustments>>>;
  shortDescription?: Maybe<Scalars['String']>;
  sizeUnit?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  startingQuantity?: Maybe<Scalars['Int']>;
  subscriptionFrequency?: Maybe<Scalars['Int']>;
  subscriptionFrequencyType?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlRewrite?: Maybe<Scalars['String']>;
  useMapPricing?: Maybe<Scalars['Boolean']>;
  usePricingFromParent?: Maybe<Scalars['Boolean']>;
  useTabs?: Maybe<Scalars['Boolean']>;
  useVariantInventory?: Maybe<Scalars['Boolean']>;
  variantInventory?: Maybe<Array<Maybe<store_variantInventory>>>;
  variants?: Maybe<Array<Maybe<store_productVariant>>>;
  vendorStoreId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightUnit?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type store_productAttribute = {
  __typename?: 'store_productAttribute';
  attributeGroupId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlRewrite?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type store_productAttributeListResult = {
  __typename?: 'store_productAttributeListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productAttribute>>>;
};

export type store_productGroupRelations = {
  __typename?: 'store_productGroupRelations';
  addToCartMessage?: Maybe<Scalars['String']>;
  additionalAttributes?: Maybe<Scalars['String']>;
  additionalPointsEarned?: Maybe<Scalars['Int']>;
  allowedVariableSubscriptionTypes?: Maybe<Scalars['String']>;
  approvalRequired?: Maybe<Scalars['Boolean']>;
  attributes?: Maybe<Array<Maybe<store_productAttribute>>>;
  autoEntryLower?: Maybe<Scalars['Int']>;
  autoEntryUpper?: Maybe<Scalars['Int']>;
  availableRegionId?: Maybe<Scalars['Int']>;
  averageReviewRating?: Maybe<Scalars['Decimal']>;
  bindQuantityToParent?: Maybe<Scalars['Boolean']>;
  breakOutShipping?: Maybe<Scalars['Boolean']>;
  bullets?: Maybe<Scalars['String']>;
  bulletsExternalUrl?: Maybe<Scalars['String']>;
  callForPricing?: Maybe<Scalars['Int']>;
  callForShipping?: Maybe<Scalars['Int']>;
  callForShippingOnWholeOrder?: Maybe<Scalars['Boolean']>;
  cartProductId?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Maybe<store_productcategories>>>;
  categoryList?: Maybe<Scalars['String']>;
  childIsRequired?: Maybe<Scalars['Boolean']>;
  childProducts?: Maybe<Array<Maybe<store_productGroupRelations>>>;
  childRequiredQuantity?: Maybe<Scalars['Int']>;
  childSortOrder?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFields?: Maybe<Array<Maybe<store_customFieldValueSimple>>>;
  customFlag1?: Maybe<Scalars['Boolean']>;
  customFlag2?: Maybe<Scalars['Boolean']>;
  customFlag3?: Maybe<Scalars['Boolean']>;
  customFlag4?: Maybe<Scalars['Boolean']>;
  customFlag5?: Maybe<Scalars['Boolean']>;
  customUpsellUrl?: Maybe<Scalars['String']>;
  daysUntilReorderAllowed?: Maybe<Scalars['Int']>;
  doNotDiscount?: Maybe<Scalars['Boolean']>;
  doNotSendReviewRequest?: Maybe<Scalars['Boolean']>;
  dropShip?: Maybe<Scalars['Boolean']>;
  eProductAllowMultipleDeliveries?: Maybe<Scalars['Int']>;
  eProductDeliveryAction?: Maybe<Scalars['String']>;
  eProductEmail?: Maybe<Scalars['String']>;
  eProductGenericPassword?: Maybe<Scalars['String']>;
  eProductGenericUsername?: Maybe<Scalars['String']>;
  eProductPassword?: Maybe<Scalars['String']>;
  eProductSerialNumberFilePath?: Maybe<Scalars['String']>;
  eProductType?: Maybe<Scalars['String']>;
  eProductUrl?: Maybe<Scalars['String']>;
  eProductVerificationLinkExpiration?: Maybe<Scalars['Int']>;
  earnsPoints?: Maybe<Scalars['Boolean']>;
  enableLowStockWarning?: Maybe<Scalars['Boolean']>;
  enabledConfigurator?: Maybe<Scalars['String']>;
  etaDate?: Maybe<Scalars['DateTime']>;
  excludeChildrenFromDisplay?: Maybe<Scalars['Boolean']>;
  excludeFromCommissions?: Maybe<Scalars['Boolean']>;
  excludeParentFromDisplay?: Maybe<Scalars['Boolean']>;
  extUpdateDate?: Maybe<Scalars['DateTime']>;
  forceSeparateOrder?: Maybe<Scalars['Boolean']>;
  freightClass?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  hSCode?: Maybe<Scalars['String']>;
  handlingFee?: Maybe<Scalars['Decimal']>;
  hasVisibleVariants?: Maybe<Scalars['Boolean']>;
  headTags?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  hideVariantSurcharges?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  inStockNotificationEmailTemplateId?: Maybe<Scalars['Int']>;
  inactiveStoreIds?: Maybe<Array<Scalars['Int']>>;
  insuranceCost?: Maybe<Scalars['Decimal']>;
  isChildProduct?: Maybe<Scalars['Boolean']>;
  isDefaultChild?: Maybe<Scalars['Boolean']>;
  isDiscontinued?: Maybe<Scalars['Boolean']>;
  isEnableVariantsOnParent?: Maybe<Scalars['Boolean']>;
  isFeaturedItem?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Int']>;
  isHideChildrenOnParent?: Maybe<Scalars['Boolean']>;
  isKit?: Maybe<Scalars['Boolean']>;
  isLinkedProduct?: Maybe<Scalars['Boolean']>;
  isNonInventory?: Maybe<Scalars['Boolean']>;
  isNonShippingItem?: Maybe<Scalars['Boolean']>;
  isNonTaxable?: Maybe<Scalars['Int']>;
  isShippedIndividually?: Maybe<Scalars['Int']>;
  isSpotlightItem?: Maybe<Scalars['Int']>;
  isSubscriptionProduct?: Maybe<Scalars['Boolean']>;
  itemName?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  lastItemNumber?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  longDescription1?: Maybe<Scalars['String']>;
  longDescription2?: Maybe<Scalars['String']>;
  longDescription3?: Maybe<Scalars['String']>;
  longDescription4?: Maybe<Scalars['String']>;
  longDescription5?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl1?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl2?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl3?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl4?: Maybe<Scalars['String']>;
  longDescriptionExternalUrl5?: Maybe<Scalars['String']>;
  longDescriptionTabName1?: Maybe<Scalars['String']>;
  longDescriptionTabName2?: Maybe<Scalars['String']>;
  longDescriptionTabName3?: Maybe<Scalars['String']>;
  longDescriptionTabName4?: Maybe<Scalars['String']>;
  longDescriptionTabName5?: Maybe<Scalars['String']>;
  lowStockWarningThreshold?: Maybe<Scalars['Int']>;
  manufacturerId?: Maybe<Scalars['Int']>;
  manufacturerPartNumber?: Maybe<Scalars['String']>;
  masterProductId?: Maybe<Scalars['Int']>;
  materialCode?: Maybe<Scalars['String']>;
  maximumQuantity?: Maybe<Scalars['Short']>;
  metaDescription?: Maybe<Scalars['String']>;
  minimumQuantity?: Maybe<Scalars['Short']>;
  noPriceMask?: Maybe<Scalars['String']>;
  offsetType?: Maybe<Scalars['String']>;
  overrideThemeUseTabs?: Maybe<Scalars['Boolean']>;
  packSlipSortOrder?: Maybe<Scalars['Int']>;
  pageTitle?: Maybe<Scalars['String']>;
  parentProductId?: Maybe<Scalars['Int']>;
  personalizations?: Maybe<Array<Maybe<store_personalize>>>;
  pictures?: Maybe<Array<Maybe<store_productPicture>>>;
  price?: Maybe<Scalars['Decimal']>;
  priceOffset?: Maybe<Scalars['Decimal']>;
  pricing?: Maybe<Array<Maybe<store_productPricing>>>;
  primaryCategoryId?: Maybe<Scalars['Int']>;
  productLineCode?: Maybe<Scalars['String']>;
  productRatingDimensionGroupOverrideId?: Maybe<Scalars['Int']>;
  productStatusId?: Maybe<Scalars['Int']>;
  profileId?: Maybe<Scalars['Int']>;
  quantityIncrement?: Maybe<Scalars['Int']>;
  quantityOnHand?: Maybe<Scalars['Int']>;
  quantityOnOrder?: Maybe<Scalars['Int']>;
  quickbooksItemId?: Maybe<Scalars['String']>;
  rateAdjustmentType?: Maybe<Scalars['String']>;
  related?: Maybe<Array<Maybe<store_relatedProducts>>>;
  relatedName?: Maybe<Scalars['String']>;
  relationDescription?: Maybe<Scalars['String']>;
  retail?: Maybe<Scalars['Decimal']>;
  reviewCount?: Maybe<Scalars['Int']>;
  reviews?: Maybe<Array<Maybe<store_profilePost>>>;
  shipperHQDimensionalRuleGroups?: Maybe<Scalars['String']>;
  shipperHQPackingBoxes?: Maybe<Scalars['String']>;
  shipperHQShippingGroups?: Maybe<Scalars['String']>;
  shippingClassificationCode?: Maybe<Scalars['String']>;
  shippingOverride?: Maybe<Scalars['Decimal']>;
  shippingRateAdjustments?: Maybe<Array<Maybe<store_shippingRateAdjustments>>>;
  shortDescription?: Maybe<Scalars['String']>;
  sizeUnit?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  startingQuantity?: Maybe<Scalars['Int']>;
  subscriptionFrequency?: Maybe<Scalars['Int']>;
  subscriptionFrequencyType?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlRewrite?: Maybe<Scalars['String']>;
  useMapPricing?: Maybe<Scalars['Boolean']>;
  usePricingFromParent?: Maybe<Scalars['Boolean']>;
  useTabs?: Maybe<Scalars['Boolean']>;
  useVariantInventory?: Maybe<Scalars['Boolean']>;
  variantInvID?: Maybe<Scalars['Int']>;
  variantInventory?: Maybe<Array<Maybe<store_variantInventory>>>;
  variants?: Maybe<Array<Maybe<store_productVariant>>>;
  vendorStoreId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightUnit?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type store_productGroupRelationsListResult = {
  __typename?: 'store_productGroupRelationsListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productGroupRelations>>>;
};

export type store_productListResult = {
  __typename?: 'store_productListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_product>>>;
};

export type store_productPicture = {
  __typename?: 'store_productPicture';
  alt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  downloadExternalImage?: Maybe<Scalars['Boolean']>;
  flashPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageFile?: Maybe<Scalars['String']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isVideoScreenShot?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  thumbnailFile?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  videoContent?: Maybe<Scalars['String']>;
};

export type store_productPictureListResult = {
  __typename?: 'store_productPictureListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productPicture>>>;
};

export type store_productPricing = {
  __typename?: 'store_productPricing';
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerTypeId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  priceCalculationId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  saleTypeId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startingQuantity?: Maybe<Scalars['Int']>;
  storeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variantId?: Maybe<Scalars['Int']>;
  variantInventoryId?: Maybe<Scalars['Int']>;
  variantPriceSurcharge?: Maybe<Scalars['String']>;
};

export type store_productPricingListResult = {
  __typename?: 'store_productPricingListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productPricing>>>;
};

export type store_productStatus = {
  __typename?: 'store_productStatus';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isBackOrdered?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isUnavailable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  showQuantity?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_productStatusListResult = {
  __typename?: 'store_productStatusListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productStatus>>>;
};

export type store_productVariant = {
  __typename?: 'store_productVariant';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDefaultSelection?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  itemNumberExtension?: Maybe<Scalars['String']>;
  itemNumberSortOrder?: Maybe<Scalars['Short']>;
  priceAdjustment?: Maybe<Scalars['Decimal']>;
  priceAdjustmentType?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Short']>;
  swatchFile?: Maybe<Scalars['String']>;
  swatchThumbnail?: Maybe<Scalars['String']>;
  swatchThumbnailColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variantGroupId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightType?: Maybe<Scalars['String']>;
};

export type store_productVariantGroup = {
  __typename?: 'store_productVariantGroup';
  createdAt?: Maybe<Scalars['DateTime']>;
  displayType?: Maybe<Scalars['String']>;
  groupFooterHtml?: Maybe<Scalars['String']>;
  groupHeaderHtml?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isNonInventory?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  publicDescriptionHtml?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<Array<Maybe<store_productVariant>>>;
};

export type store_productVariantGroupListResult = {
  __typename?: 'store_productVariantGroupListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productVariantGroup>>>;
};

export type store_productVariantListResult = {
  __typename?: 'store_productVariantListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productVariant>>>;
};

export type store_productcategories = {
  __typename?: 'store_productcategories';
  id?: Maybe<Scalars['Int']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lookupPath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
};

export type store_productcategoriesListResult = {
  __typename?: 'store_productcategoriesListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_productcategories>>>;
};

export type store_profilePost = {
  __typename?: 'store_profilePost';
  approvalStatus?: Maybe<Scalars['String']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedByUserId?: Maybe<Scalars['Int']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorEmail?: Maybe<Scalars['String']>;
  authorLocation?: Maybe<Scalars['String']>;
  authorWebsite?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  originStoreId?: Maybe<Scalars['Int']>;
  overallRating?: Maybe<Scalars['Decimal']>;
  productId?: Maybe<Scalars['Int']>;
  profileId?: Maybe<Scalars['Int']>;
  profilePostType?: Maybe<Scalars['String']>;
  publishedDate?: Maybe<Scalars['DateTime']>;
  ratings?: Maybe<Array<Maybe<store_reviewRating>>>;
  reviewCons?: Maybe<Scalars['String']>;
  reviewPros?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadedImage?: Maybe<Scalars['String']>;
};

export type store_profilePostListResult = {
  __typename?: 'store_profilePostListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_profilePost>>>;
};

export type store_quote = {
  __typename?: 'store_quote';
  adcode?: Maybe<Scalars['String']>;
  adcodeId?: Maybe<Scalars['Int']>;
  additionalFees?: Maybe<Scalars['Decimal']>;
  adminComments?: Maybe<Scalars['String']>;
  affiliateId?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<store_orderAddress>;
  campaignCode?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  costTotal?: Maybe<Scalars['Decimal']>;
  couponCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFields?: Maybe<Array<Maybe<store_customFieldValueSimple>>>;
  customer?: Maybe<store_customer>;
  customerId?: Maybe<Scalars['Int']>;
  customerTypeId?: Maybe<Scalars['Int']>;
  deliveryTax?: Maybe<Scalars['Decimal']>;
  device?: Maybe<Scalars['String']>;
  discountTotal?: Maybe<Scalars['Decimal']>;
  discountedShippingTotal?: Maybe<Scalars['Decimal']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  enteredBy?: Maybe<Scalars['String']>;
  enteredByType?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  exportedToAccountingSystem?: Maybe<Scalars['Int']>;
  fromQuoteId?: Maybe<Scalars['Int']>;
  fromSubscriptionId?: Maybe<Scalars['Int']>;
  giftMessage?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['Decimal']>;
  handlingTotal?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  instructions?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  isGift?: Maybe<Scalars['Boolean']>;
  isPaymentOrderOnly?: Maybe<Scalars['Boolean']>;
  isPpc?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<store_orderItem>>>;
  manufacturerInvoiceAmount?: Maybe<Scalars['Decimal']>;
  manufacturerInvoiceNumber?: Maybe<Scalars['String']>;
  manufacturerInvoicePaid?: Maybe<Scalars['Boolean']>;
  orderBillingAddressId?: Maybe<Scalars['Int']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderShippingAddressId?: Maybe<Scalars['Int']>;
  orderStatus?: Maybe<store_orderStatus>;
  orderStatusId?: Maybe<Scalars['Int']>;
  orderStatusLastChangedAt?: Maybe<Scalars['DateTime']>;
  orderType?: Maybe<Scalars['String']>;
  orderedAt?: Maybe<Scalars['DateTime']>;
  payments?: Maybe<Array<Maybe<store_orderPayment>>>;
  ppcKeyword?: Maybe<Scalars['String']>;
  previousOrderStatusId?: Maybe<Scalars['Int']>;
  publicComments?: Maybe<Scalars['String']>;
  referrer?: Maybe<Scalars['String']>;
  rewardPointsCredited?: Maybe<Scalars['Boolean']>;
  salesAgentUserID?: Maybe<Scalars['Int']>;
  searchPhrase?: Maybe<Scalars['String']>;
  selectedShippingMethod?: Maybe<Scalars['String']>;
  selectedShippingProviderService?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['Int']>;
  shipments?: Maybe<Array<Maybe<store_orderShipping>>>;
  shippingAddress?: Maybe<store_orderAddress>;
  shippingSelections?: Maybe<Array<Maybe<store_shippingSelections>>>;
  shippingTotal?: Maybe<Scalars['Decimal']>;
  source?: Maybe<Scalars['String']>;
  sourceGroup?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Decimal']>;
  taxTotal?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_quoteListResult = {
  __typename?: 'store_quoteListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_quote>>>;
};

export type store_relatedProducts = {
  __typename?: 'store_relatedProducts';
  id?: Maybe<Scalars['Int']>;
  isHidden: Scalars['Boolean'];
  isUpsell?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
  upsellAdjustedPrice?: Maybe<Scalars['Decimal']>;
  upsellFreeShipping?: Maybe<Scalars['Boolean']>;
  upsellQuantity?: Maybe<Scalars['Int']>;
};

export type store_relatedProductsListResult = {
  __typename?: 'store_relatedProductsListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_relatedProducts>>>;
};

export type store_reviewRating = {
  __typename?: 'store_reviewRating';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Decimal']>;
};

export type store_rewardPoints = {
  __typename?: 'store_rewardPoints';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  earnedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isNew?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  pointsEarned?: Maybe<Scalars['Int']>;
  pointsRemaining?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_shippingRateAdjustments = {
  __typename?: 'store_shippingRateAdjustments';
  amount?: Maybe<Scalars['Decimal']>;
  availableRegionId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isUnavailable?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['Int']>;
  shippingMethodName?: Maybe<Scalars['String']>;
  shippingProvider?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  useCalculatedRate?: Maybe<Scalars['Boolean']>;
};

export type store_shippingRateAdjustmentsListResult = {
  __typename?: 'store_shippingRateAdjustmentsListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_shippingRateAdjustments>>>;
};

export type store_shippingSelections = {
  __typename?: 'store_shippingSelections';
  classificationCode?: Maybe<Scalars['String']>;
  shippingMethod?: Maybe<Scalars['String']>;
  shippingProvider?: Maybe<Scalars['String']>;
};

export type store_store = {
  __typename?: 'store_store';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  averageTestimonialRating?: Maybe<Scalars['Decimal']>;
  billingFirstName?: Maybe<Scalars['String']>;
  billingLastName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domainName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isMicroStore?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isVendor?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentStoreId?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  techEmail?: Maybe<Scalars['String']>;
  techFirstName?: Maybe<Scalars['String']>;
  techLastName?: Maybe<Scalars['String']>;
  techSameAsBilling?: Maybe<Scalars['Boolean']>;
  testimonialCount?: Maybe<Scalars['Int']>;
  vendorKey?: Maybe<Scalars['String']>;
};

export type store_storeListResult = {
  __typename?: 'store_storeListResult';
  count: Scalars['Int'];
  nextPage: Scalars['String'];
  previousPage: Scalars['String'];
  results?: Maybe<Array<Maybe<store_store>>>;
};

export type store_subscription = {
  __typename?: 'store_subscription';
  billingAddressId?: Maybe<Scalars['Int']>;
  cartInfo?: Maybe<store_cartInfo>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<store_customer>;
  customerId?: Maybe<Scalars['Int']>;
  customerNotice?: Maybe<Scalars['String']>;
  customerPaymentMethod?: Maybe<store_CustomerPaymentMethod>;
  customerPaymentMethodId?: Maybe<Scalars['Int']>;
  dripSeriesId?: Maybe<Scalars['Int']>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isRenewalPaymentDeclined?: Maybe<Scalars['Boolean']>;
  latestRenewalOrderId?: Maybe<Scalars['Int']>;
  nextDueAt?: Maybe<Scalars['DateTime']>;
  oneTimeCustomerNotice?: Maybe<Scalars['String']>;
  originalOrderId?: Maybe<Scalars['Int']>;
  renewalCount?: Maybe<Scalars['Int']>;
  savedCartId?: Maybe<Scalars['Int']>;
  shippingAddress?: Maybe<store_orderAddress>;
  shippingAddressId?: Maybe<Scalars['Int']>;
  shippingMethodName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type store_subscriptionListResult = {
  __typename?: 'store_subscriptionListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_subscription>>>;
};

export type store_variantInventory = {
  __typename?: 'store_variantInventory';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  inventory?: Maybe<Scalars['Int']>;
  itemNumber?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Decimal']>;
  lowStockWarningAt?: Maybe<Scalars['Int']>;
  lowStockWarningEnabled?: Maybe<Scalars['Boolean']>;
  manufacturerItemNumber?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<Maybe<store_productPricing>>>;
  productId?: Maybe<Scalars['Int']>;
  productStatusId?: Maybe<Scalars['Int']>;
  quickbooksItemId?: Maybe<Scalars['String']>;
  retail?: Maybe<Scalars['Decimal']>;
  shipperHQDimensionalRuleGroups?: Maybe<Scalars['String']>;
  shipperHQPackingBoxes?: Maybe<Scalars['String']>;
  shipperHQShippingGroups?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<Array<Maybe<store_variantInventoryVariants>>>;
  weight?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
};

export type store_variantInventoryListResult = {
  __typename?: 'store_variantInventoryListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_variantInventory>>>;
};

export type store_variantInventoryVariants = {
  __typename?: 'store_variantInventoryVariants';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDefaultSelection?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  itemNumberExtension?: Maybe<Scalars['String']>;
  itemNumberSortOrder?: Maybe<Scalars['Short']>;
  priceAdjustment?: Maybe<Scalars['Decimal']>;
  priceAdjustmentType?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Short']>;
  swatchFile?: Maybe<Scalars['String']>;
  swatchThumbnail?: Maybe<Scalars['String']>;
  swatchThumbnailColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variantGroupId?: Maybe<Scalars['Int']>;
  variantInventoryId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightType?: Maybe<Scalars['String']>;
};

export type store_variantInventoryVariantsListResult = {
  __typename?: 'store_variantInventoryVariantsListResult';
  count: Scalars['Int'];
  nextPage?: Maybe<Scalars['String']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<store_variantInventoryVariants>>>;
};

export type transactionMessage = {
  __typename?: 'transactionMessage';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type validationResultMessage = {
  __typename?: 'validationResultMessage';
  code?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type validationResults = {
  __typename?: 'validationResults';
  isValid?: Maybe<Scalars['Boolean']>;
  messages?: Maybe<Array<Maybe<validationResultMessage>>>;
};

export type UserPhoneNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPhoneNumberQuery = { __typename?: 'Query', me: { __typename?: 'Me', user?: { __typename?: 'User', userData?: { __typename?: 'UserData', phone?: string | null } | null } | null } };

export type DFWEmailMutationVariables = Exact<{
  emailDfw: EmailDFW;
}>;


export type DFWEmailMutation = { __typename?: 'Mutation', org_emailDFW: string };

export type cannySsoMutationVariables = Exact<{ [key: string]: never; }>;


export type cannySsoMutation = { __typename?: 'Mutation', org_userCannySso: string };

export type OrgSelectUserInvitesQueryVariables = Exact<{
  input: UserInviteMeInput;
}>;


export type OrgSelectUserInvitesQuery = { __typename?: 'Query', org_userInviteMe: Array<{ __typename?: 'UserInvite', organizationName?: string | null, businessName?: string | null, inviteToken: string, inviteStatus?: string | null }> };

export type ConsumeUserInviteMutationVariables = Exact<{
  consumeInviteUserInput: ConsumeInviteUserInput;
}>;


export type ConsumeUserInviteMutation = { __typename?: 'Mutation', org_userConsumeInvite: { __typename?: 'User', id: number, primaryEmail: string } };

export type OrgProductInstancesQueryVariables = Exact<{
  input: ListProductInstanceOrgInput;
}>;


export type OrgProductInstancesQuery = { __typename?: 'Query', org_productInstanceOrgList: Array<{ __typename?: 'ProductInstance', businessId?: number | null, instanceType?: InstanceType | null, subscriptionStatus?: SubscriptionStatus | null }> };

export type CreateOrganizationMutationVariables = Exact<{
  createOrganizationInput: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', org_organizationCreate: { __typename?: 'Organization', id: number, name: string, roleName?: string | null, businessEntityTerminology?: string | null, createdAt?: any | null, businesses?: Array<{ __typename?: 'Business', id: number, name: string }> | null } };

export type BusinessShowQueryVariables = Exact<{
  orgBusinessShowId: Scalars['Int'];
}>;


export type BusinessShowQuery = { __typename?: 'Query', org_businessShow: { __typename?: 'Business', name: string, id: number, createdAt?: any | null, organization?: { __typename?: 'Organization', name: string } | null } };

export type BusinessNameMutationVariables = Exact<{
  updateBusinessInput: UpdateBusinessInput;
}>;


export type BusinessNameMutation = { __typename?: 'Mutation', org_businessUpdate: { __typename?: 'Business', id: number, name: string } };

export type BusinessServicesQueryVariables = Exact<{
  orgBusinessShowId: Scalars['Int'];
}>;


export type BusinessServicesQuery = { __typename?: 'Query', org_businessShow: { __typename?: 'Business', id: number, businessServices?: { __typename?: 'BusinessService', id: number, feedManagementEnabled: boolean, fulfillmentEnabled: boolean, mcmEnabled: boolean, storefrontEnabled: boolean, unifiedAnalyticsEnabled: boolean } | null } };

export type BusinessUsersQueryVariables = Exact<{
  orgBusinessShowId: Scalars['Int'];
}>;


export type BusinessUsersQuery = { __typename?: 'Query', org_businessShow: { __typename?: 'Business', members: Array<{ __typename?: 'Member', status: string, id: number, primaryEmail: string, createdAt?: any | null, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, invite?: { __typename?: 'UserInvite', inviteStatus?: string | null } | null, role: { __typename?: 'Role', name: string, displayName?: string | null } }> } };

export type OrganizationBusinessQueryVariables = Exact<{
  orgBusinessShowId: Scalars['Int'];
}>;


export type OrganizationBusinessQuery = { __typename?: 'Query', org_businessShow: { __typename?: 'Business', name: string, id: number, createdAt?: any | null, organization?: { __typename?: 'Organization', name: string } | null, businessServices?: { __typename?: 'BusinessService', id: number, mcmEnabled: boolean } | null } };

export type OrganizationUsersInviteMutationVariables = Exact<{
  inviteUserInput: InviteUserInput;
}>;


export type OrganizationUsersInviteMutation = { __typename?: 'Mutation', org_userInvite: Array<{ __typename?: 'UserInvite', inviteEmail: string }> };

export type OrganizationRoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationRoleListQuery = { __typename?: 'Query', org_roleList: { __typename?: 'PaginatedRole', data?: Array<{ __typename?: 'Role', id: number, displayName?: string | null, description?: string | null, name: string }> | null } };

export type BusinessListByOrgIdQueryVariables = Exact<{
  organizationId: Scalars['Int'];
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type BusinessListByOrgIdQuery = { __typename?: 'Query', org_businessListByOrgId: { __typename?: 'PaginatedBusiness', skip?: number | null, take?: number | null, totalCount?: number | null, data?: Array<{ __typename?: 'Business', createdAt?: any | null, id: number, name: string, numUsers?: number | null }> | null } };

export type AssignedRoleListMeQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['Int']>;
}>;


export type AssignedRoleListMeQuery = { __typename?: 'Query', org_assignedRoleListMe: { __typename?: 'PaginatedAssignedRole', data?: Array<{ __typename?: 'AssignedRole', business?: { __typename?: 'Business', createdAt?: any | null, id: number, name: string, numUsers?: number | null } | null }> | null } };

export type AssignedRoleCreateMutationVariables = Exact<{
  createAssignedroleInput: CreateAssignedRoleInput;
}>;


export type AssignedRoleCreateMutation = { __typename?: 'Mutation', org_assignedRoleCreate: { __typename?: 'AssignedRole', id: number, role?: { __typename?: 'Role', name: string } | null } };

export type BusinessCreateMutationVariables = Exact<{
  createBusinessInput: CreateBusinessInput;
}>;


export type BusinessCreateMutation = { __typename?: 'Mutation', org_businessCreate: { __typename?: 'Business', id: number, name: string, assignedRoles?: Array<{ __typename?: 'AssignedRole', id: number, roleId?: number | null, role?: { __typename?: 'Role', id: number, name: string } | null }> | null } };

export type OrganizationShowQueryVariables = Exact<{
  orgOrganizationShowId: Scalars['Int'];
}>;


export type OrganizationShowQuery = { __typename?: 'Query', org_organizationShow: { __typename?: 'Organization', businessEntityTerminology?: string | null, createdAt?: any | null, id: number, name: string, assignedRoles?: Array<{ __typename?: 'AssignedRole', role?: { __typename?: 'Role', displayName?: string | null } | null, user?: { __typename?: 'User', firstName?: string | null, id: number, lastName?: string | null, primaryEmail: string } | null }> | null, businesses?: Array<{ __typename?: 'Business', id: number, name: string }> | null, organizationData?: { __typename?: 'OrganizationData', phone?: string | null, website?: string | null } | null } };

export type OrganizationUpdateMutationVariables = Exact<{
  updateOrganizationInput: UpdateOrganizationInput;
}>;


export type OrganizationUpdateMutation = { __typename?: 'Mutation', org_organizationUpdate: { __typename?: 'Organization', businessEntityTerminology?: string | null, name: string } };

export type OrganizationUsersQueryVariables = Exact<{
  orgOrganizationShowId: Scalars['Int'];
}>;


export type OrganizationUsersQuery = { __typename?: 'Query', org_organizationShow: { __typename?: 'Organization', id: number, name: string, businesses?: Array<{ __typename?: 'Business', id: number, name: string, assignedRoles?: Array<{ __typename?: 'AssignedRole', id: number, userId?: number | null, role?: { __typename?: 'Role', name: string, displayName?: string | null } | null }> | null }> | null, members: Array<{ __typename?: 'Member', id: number, auth0Id?: string | null, createdAt?: any | null, status: string, primaryEmail: string, firstName?: string | null, lastName?: string | null, role: { __typename?: 'Role', name: string, displayName?: string | null } }> } };

export type orgSettings_UnblockUserMutationVariables = Exact<{
  orgUserId: Scalars['Int'];
}>;


export type orgSettings_UnblockUserMutation = { __typename?: 'Mutation', org_userUnblock: { __typename?: 'User', id: number } };

export type OrganizationUsersRemoveMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type OrganizationUsersRemoveMutation = { __typename?: 'Mutation', org_assignedRoleDelete: Array<{ __typename?: 'AssignedRole', id: number }> };

export type OrganizationRemoveUserMutationVariables = Exact<{
  organizationId: Scalars['Int'];
  userIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type OrganizationRemoveUserMutation = { __typename?: 'Mutation', org_organizationRemoveUser: Array<{ __typename?: 'User', id: number }> };

export type BusinessRemoveUserMutationVariables = Exact<{
  businessId: Scalars['Int'];
  userIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type BusinessRemoveUserMutation = { __typename?: 'Mutation', org_businessRemoveUser: Array<{ __typename?: 'User', id: number }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Me', user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, primaryEmail: string, id: number, userData?: { __typename?: 'UserData', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, id: number, phone?: string | null, state?: string | null, zip?: string | null } | null } | null } };

export type UserUpdateMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', org_userUpdate: { __typename?: 'User', firstName?: string | null, lastName?: string | null, primaryEmail: string, id: number, userData?: { __typename?: 'UserData', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, phone?: string | null, state?: string | null, zip?: string | null } | null } };

export type OrgUserChangeOwnPasswordMutationVariables = Exact<{
  input: ChangeOwnPasswordInput;
}>;


export type OrgUserChangeOwnPasswordMutation = { __typename?: 'Mutation', org_userChangeOwnPassword: { __typename?: 'User', id: number } };

export type MeMfaAccessTokenQueryVariables = Exact<{
  mfaInput: MfaDataInput;
}>;


export type MeMfaAccessTokenQuery = { __typename?: 'Query', me: { __typename?: 'Me', user?: { __typename?: 'User', mfaData: { __typename?: 'MfaData', access_token: string } } | null } };

export type Org_userConfirmMfaEnrollmentMutationVariables = Exact<{
  confirmEnrollmentInput: ConfirmMfaEnrollmentInput;
}>;


export type Org_userConfirmMfaEnrollmentMutation = { __typename?: 'Mutation', org_userConfirmMfaEnrollment: { __typename?: 'MfaData', access_token: string } };

export type Org_userToggleMfaMutationVariables = Exact<{
  toggleUserMfaInput: ToggleUserMfaInput;
}>;


export type Org_userToggleMfaMutation = { __typename?: 'Mutation', org_userToggleMfa: { __typename?: 'ToggleMfaData', success: boolean } };

export type mfa_userMfaDeleteMutationVariables = Exact<{ [key: string]: never; }>;


export type mfa_userMfaDeleteMutation = { __typename?: 'Mutation', org_userMfaDelete: boolean };

export type OrgProductInstanceListQueryVariables = Exact<{
  input: ListProductInstanceInput;
}>;


export type OrgProductInstanceListQuery = { __typename?: 'Query', org_productInstanceList: Array<{ __typename?: 'ProductInstance', id?: number | null, instanceType?: InstanceType | null }> };

export type OrganizationListQueryVariables = Exact<{
  searchArgs?: InputMaybe<SearchOrganizationInput>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type OrganizationListQuery = { __typename?: 'Query', org_organizationList: { __typename?: 'PaginatedOrganization', data?: Array<{ __typename?: 'Organization', id: number, name: string }> | null } };

export type Org_businessListByOrgIdQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type Org_businessListByOrgIdQuery = { __typename?: 'Query', org_businessListByOrgId: { __typename?: 'PaginatedBusiness', data?: Array<{ __typename?: 'Business', id: number, name: string }> | null } };

export type RegisterUserMutationVariables = Exact<{
  registerUserInput: RegisterUserInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', org_registerUser: { __typename?: 'User', id: number, auth0Id?: string | null } };

export type UserShowQueryVariables = Exact<{
  primaryEmail?: InputMaybe<Scalars['String']>;
}>;


export type UserShowQuery = { __typename?: 'Query', org_userShow: { __typename?: 'User', id: number, organizations?: Array<{ __typename?: 'Organization', id: number }> | null, businesses?: Array<{ __typename?: 'Business', id: number }> | null } };

export type MemberStructureQueryVariables = Exact<{
  orgUserShowId?: InputMaybe<Scalars['Int']>;
}>;


export type MemberStructureQuery = { __typename?: 'Query', org_userShow: { __typename?: 'User', userInvitations?: Array<{ __typename?: 'UserInvite', organizationName?: string | null, inviteStatus?: string | null, assignedRoles?: Array<{ __typename?: 'AssignedRole', business?: { __typename?: 'Business', name: string, id: number, organization?: { __typename?: 'Organization', name: string, id: number } | null } | null, role?: { __typename?: 'Role', displayName?: string | null } | null }> | null }> | null, organizations?: Array<{ __typename?: 'Organization', id: number, name: string, assignedRoles?: Array<{ __typename?: 'AssignedRole', role?: { __typename?: 'Role', id: number, displayName?: string | null, name: string } | null, user?: { __typename?: 'User', id: number } | null }> | null, businesses?: Array<{ __typename?: 'Business', id: number, name: string, userStatus?: string | null, assignedRoles?: Array<{ __typename?: 'AssignedRole', role?: { __typename?: 'Role', displayName?: string | null } | null }> | null }> | null }> | null } };

export type OrgAssignedPermissionCheckQueryVariables = Exact<{
  permissionName?: InputMaybe<Scalars['String']>;
}>;


export type OrgAssignedPermissionCheckQuery = { __typename?: 'Query', org_assignedPermissionCheck: { __typename?: 'PermissionCheck', access: boolean } };

export type ResetUserPasswordMutationVariables = Exact<{
  userEmail: Scalars['String'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', org_userResetPassword: { __typename?: 'User', id: number } };

export type UserDetailsQueryVariables = Exact<{
  orgUserShowId?: InputMaybe<Scalars['Int']>;
}>;


export type UserDetailsQuery = { __typename?: 'Query', org_userShow: { __typename?: 'User', auth0Id?: string | null, createdAt?: any | null, firstName?: string | null, id: number, lastName?: string | null, primaryEmail: string, userData?: { __typename?: 'UserData', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, createdAt?: any | null, phone?: string | null, state?: string | null, updatedAt?: any | null, zip?: string | null } | null } };

export type UserSearchQueryVariables = Exact<{
  idOrEmail: Scalars['String'];
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type UserSearchQuery = { __typename?: 'Query', org_userList: { __typename?: 'PaginatedUser', data?: Array<{ __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, primaryEmail: string }> | null } };

export type bc_validatePhoneQueryVariables = Exact<{
  phone: Scalars['String'];
}>;


export type bc_validatePhoneQuery = { __typename?: 'Query', org_validatePhone: boolean };


export const UserPhoneNumberDocument = gql`
    query UserPhoneNumber {
  me {
    user {
      userData {
        phone
      }
    }
  }
}
    `;

/**
 * __useUserPhoneNumberQuery__
 *
 * To run a query within a React component, call `useUserPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPhoneNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPhoneNumberQuery(baseOptions?: Apollo.QueryHookOptions<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>(UserPhoneNumberDocument, options);
      }
export function useUserPhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>(UserPhoneNumberDocument, options);
        }
export type UserPhoneNumberQueryHookResult = ReturnType<typeof useUserPhoneNumberQuery>;
export type UserPhoneNumberLazyQueryHookResult = ReturnType<typeof useUserPhoneNumberLazyQuery>;
export type UserPhoneNumberQueryResult = Apollo.QueryResult<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>;
export const DFWEmailDocument = gql`
    mutation DFWEmail($emailDfw: EmailDFW!) {
  org_emailDFW(emailDFW: $emailDfw)
}
    `;
export type DFWEmailMutationFn = Apollo.MutationFunction<DFWEmailMutation, DFWEmailMutationVariables>;

/**
 * __useDFWEmailMutation__
 *
 * To run a mutation, you first call `useDFWEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDFWEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dfwEmailMutation, { data, loading, error }] = useDFWEmailMutation({
 *   variables: {
 *      emailDfw: // value for 'emailDfw'
 *   },
 * });
 */
export function useDFWEmailMutation(baseOptions?: Apollo.MutationHookOptions<DFWEmailMutation, DFWEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DFWEmailMutation, DFWEmailMutationVariables>(DFWEmailDocument, options);
      }
export type DFWEmailMutationHookResult = ReturnType<typeof useDFWEmailMutation>;
export type DFWEmailMutationResult = Apollo.MutationResult<DFWEmailMutation>;
export type DFWEmailMutationOptions = Apollo.BaseMutationOptions<DFWEmailMutation, DFWEmailMutationVariables>;
export const cannySsoDocument = gql`
    mutation cannySso {
  org_userCannySso
}
    `;
export type cannySsoMutationFn = Apollo.MutationFunction<cannySsoMutation, cannySsoMutationVariables>;

/**
 * __usecannySsoMutation__
 *
 * To run a mutation, you first call `usecannySsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecannySsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cannySsoMutation, { data, loading, error }] = usecannySsoMutation({
 *   variables: {
 *   },
 * });
 */
export function usecannySsoMutation(baseOptions?: Apollo.MutationHookOptions<cannySsoMutation, cannySsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<cannySsoMutation, cannySsoMutationVariables>(cannySsoDocument, options);
      }
export type cannySsoMutationHookResult = ReturnType<typeof usecannySsoMutation>;
export type cannySsoMutationResult = Apollo.MutationResult<cannySsoMutation>;
export type cannySsoMutationOptions = Apollo.BaseMutationOptions<cannySsoMutation, cannySsoMutationVariables>;
export const OrgSelectUserInvitesDocument = gql`
    query OrgSelectUserInvites($input: UserInviteMeInput!) {
  org_userInviteMe(input: $input) {
    organizationName
    businessName
    inviteToken
    inviteStatus
  }
}
    `;

/**
 * __useOrgSelectUserInvitesQuery__
 *
 * To run a query within a React component, call `useOrgSelectUserInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgSelectUserInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgSelectUserInvitesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgSelectUserInvitesQuery(baseOptions: Apollo.QueryHookOptions<OrgSelectUserInvitesQuery, OrgSelectUserInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgSelectUserInvitesQuery, OrgSelectUserInvitesQueryVariables>(OrgSelectUserInvitesDocument, options);
      }
export function useOrgSelectUserInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgSelectUserInvitesQuery, OrgSelectUserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgSelectUserInvitesQuery, OrgSelectUserInvitesQueryVariables>(OrgSelectUserInvitesDocument, options);
        }
export type OrgSelectUserInvitesQueryHookResult = ReturnType<typeof useOrgSelectUserInvitesQuery>;
export type OrgSelectUserInvitesLazyQueryHookResult = ReturnType<typeof useOrgSelectUserInvitesLazyQuery>;
export type OrgSelectUserInvitesQueryResult = Apollo.QueryResult<OrgSelectUserInvitesQuery, OrgSelectUserInvitesQueryVariables>;
export const ConsumeUserInviteDocument = gql`
    mutation ConsumeUserInvite($consumeInviteUserInput: ConsumeInviteUserInput!) {
  org_userConsumeInvite(consumeInviteUserInput: $consumeInviteUserInput) {
    id
    primaryEmail
  }
}
    `;
export type ConsumeUserInviteMutationFn = Apollo.MutationFunction<ConsumeUserInviteMutation, ConsumeUserInviteMutationVariables>;

/**
 * __useConsumeUserInviteMutation__
 *
 * To run a mutation, you first call `useConsumeUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeUserInviteMutation, { data, loading, error }] = useConsumeUserInviteMutation({
 *   variables: {
 *      consumeInviteUserInput: // value for 'consumeInviteUserInput'
 *   },
 * });
 */
export function useConsumeUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ConsumeUserInviteMutation, ConsumeUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumeUserInviteMutation, ConsumeUserInviteMutationVariables>(ConsumeUserInviteDocument, options);
      }
export type ConsumeUserInviteMutationHookResult = ReturnType<typeof useConsumeUserInviteMutation>;
export type ConsumeUserInviteMutationResult = Apollo.MutationResult<ConsumeUserInviteMutation>;
export type ConsumeUserInviteMutationOptions = Apollo.BaseMutationOptions<ConsumeUserInviteMutation, ConsumeUserInviteMutationVariables>;
export const OrgProductInstancesDocument = gql`
    query OrgProductInstances($input: ListProductInstanceOrgInput!) {
  org_productInstanceOrgList(input: $input) {
    businessId
    instanceType
    subscriptionStatus
  }
}
    `;

/**
 * __useOrgProductInstancesQuery__
 *
 * To run a query within a React component, call `useOrgProductInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgProductInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgProductInstancesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgProductInstancesQuery(baseOptions: Apollo.QueryHookOptions<OrgProductInstancesQuery, OrgProductInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgProductInstancesQuery, OrgProductInstancesQueryVariables>(OrgProductInstancesDocument, options);
      }
export function useOrgProductInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgProductInstancesQuery, OrgProductInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgProductInstancesQuery, OrgProductInstancesQueryVariables>(OrgProductInstancesDocument, options);
        }
export type OrgProductInstancesQueryHookResult = ReturnType<typeof useOrgProductInstancesQuery>;
export type OrgProductInstancesLazyQueryHookResult = ReturnType<typeof useOrgProductInstancesLazyQuery>;
export type OrgProductInstancesQueryResult = Apollo.QueryResult<OrgProductInstancesQuery, OrgProductInstancesQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($createOrganizationInput: CreateOrganizationInput!) {
  org_organizationCreate(createOrganizationInput: $createOrganizationInput) {
    id
    name
    roleName
    businessEntityTerminology
    businesses {
      id
      name
    }
    createdAt
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      createOrganizationInput: // value for 'createOrganizationInput'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const BusinessShowDocument = gql`
    query BusinessShow($orgBusinessShowId: Int!) {
  org_businessShow(id: $orgBusinessShowId) {
    name
    id
    createdAt
    organization {
      name
    }
  }
}
    `;

/**
 * __useBusinessShowQuery__
 *
 * To run a query within a React component, call `useBusinessShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessShowQuery({
 *   variables: {
 *      orgBusinessShowId: // value for 'orgBusinessShowId'
 *   },
 * });
 */
export function useBusinessShowQuery(baseOptions: Apollo.QueryHookOptions<BusinessShowQuery, BusinessShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessShowQuery, BusinessShowQueryVariables>(BusinessShowDocument, options);
      }
export function useBusinessShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessShowQuery, BusinessShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessShowQuery, BusinessShowQueryVariables>(BusinessShowDocument, options);
        }
export type BusinessShowQueryHookResult = ReturnType<typeof useBusinessShowQuery>;
export type BusinessShowLazyQueryHookResult = ReturnType<typeof useBusinessShowLazyQuery>;
export type BusinessShowQueryResult = Apollo.QueryResult<BusinessShowQuery, BusinessShowQueryVariables>;
export const BusinessNameDocument = gql`
    mutation BusinessName($updateBusinessInput: UpdateBusinessInput!) {
  org_businessUpdate(updateBusinessInput: $updateBusinessInput) {
    id
    name
  }
}
    `;
export type BusinessNameMutationFn = Apollo.MutationFunction<BusinessNameMutation, BusinessNameMutationVariables>;

/**
 * __useBusinessNameMutation__
 *
 * To run a mutation, you first call `useBusinessNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessNameMutation, { data, loading, error }] = useBusinessNameMutation({
 *   variables: {
 *      updateBusinessInput: // value for 'updateBusinessInput'
 *   },
 * });
 */
export function useBusinessNameMutation(baseOptions?: Apollo.MutationHookOptions<BusinessNameMutation, BusinessNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessNameMutation, BusinessNameMutationVariables>(BusinessNameDocument, options);
      }
export type BusinessNameMutationHookResult = ReturnType<typeof useBusinessNameMutation>;
export type BusinessNameMutationResult = Apollo.MutationResult<BusinessNameMutation>;
export type BusinessNameMutationOptions = Apollo.BaseMutationOptions<BusinessNameMutation, BusinessNameMutationVariables>;
export const BusinessServicesDocument = gql`
    query BusinessServices($orgBusinessShowId: Int!) {
  org_businessShow(id: $orgBusinessShowId) {
    id
    businessServices {
      id
      feedManagementEnabled
      fulfillmentEnabled
      mcmEnabled
      storefrontEnabled
      unifiedAnalyticsEnabled
    }
  }
}
    `;

/**
 * __useBusinessServicesQuery__
 *
 * To run a query within a React component, call `useBusinessServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessServicesQuery({
 *   variables: {
 *      orgBusinessShowId: // value for 'orgBusinessShowId'
 *   },
 * });
 */
export function useBusinessServicesQuery(baseOptions: Apollo.QueryHookOptions<BusinessServicesQuery, BusinessServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessServicesQuery, BusinessServicesQueryVariables>(BusinessServicesDocument, options);
      }
export function useBusinessServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessServicesQuery, BusinessServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessServicesQuery, BusinessServicesQueryVariables>(BusinessServicesDocument, options);
        }
export type BusinessServicesQueryHookResult = ReturnType<typeof useBusinessServicesQuery>;
export type BusinessServicesLazyQueryHookResult = ReturnType<typeof useBusinessServicesLazyQuery>;
export type BusinessServicesQueryResult = Apollo.QueryResult<BusinessServicesQuery, BusinessServicesQueryVariables>;
export const BusinessUsersDocument = gql`
    query BusinessUsers($orgBusinessShowId: Int!) {
  org_businessShow(id: $orgBusinessShowId) {
    members {
      invite {
        inviteStatus
      }
      status
      role {
        name
        displayName
      }
      id
      primaryEmail
      createdAt
      auth0Id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useBusinessUsersQuery__
 *
 * To run a query within a React component, call `useBusinessUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUsersQuery({
 *   variables: {
 *      orgBusinessShowId: // value for 'orgBusinessShowId'
 *   },
 * });
 */
export function useBusinessUsersQuery(baseOptions: Apollo.QueryHookOptions<BusinessUsersQuery, BusinessUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUsersQuery, BusinessUsersQueryVariables>(BusinessUsersDocument, options);
      }
export function useBusinessUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUsersQuery, BusinessUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUsersQuery, BusinessUsersQueryVariables>(BusinessUsersDocument, options);
        }
export type BusinessUsersQueryHookResult = ReturnType<typeof useBusinessUsersQuery>;
export type BusinessUsersLazyQueryHookResult = ReturnType<typeof useBusinessUsersLazyQuery>;
export type BusinessUsersQueryResult = Apollo.QueryResult<BusinessUsersQuery, BusinessUsersQueryVariables>;
export const OrganizationBusinessDocument = gql`
    query OrganizationBusiness($orgBusinessShowId: Int!) {
  org_businessShow(id: $orgBusinessShowId) {
    name
    id
    createdAt
    organization {
      name
    }
    businessServices {
      id
      mcmEnabled
    }
  }
}
    `;

/**
 * __useOrganizationBusinessQuery__
 *
 * To run a query within a React component, call `useOrganizationBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationBusinessQuery({
 *   variables: {
 *      orgBusinessShowId: // value for 'orgBusinessShowId'
 *   },
 * });
 */
export function useOrganizationBusinessQuery(baseOptions: Apollo.QueryHookOptions<OrganizationBusinessQuery, OrganizationBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationBusinessQuery, OrganizationBusinessQueryVariables>(OrganizationBusinessDocument, options);
      }
export function useOrganizationBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationBusinessQuery, OrganizationBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationBusinessQuery, OrganizationBusinessQueryVariables>(OrganizationBusinessDocument, options);
        }
export type OrganizationBusinessQueryHookResult = ReturnType<typeof useOrganizationBusinessQuery>;
export type OrganizationBusinessLazyQueryHookResult = ReturnType<typeof useOrganizationBusinessLazyQuery>;
export type OrganizationBusinessQueryResult = Apollo.QueryResult<OrganizationBusinessQuery, OrganizationBusinessQueryVariables>;
export const OrganizationUsersInviteDocument = gql`
    mutation OrganizationUsersInvite($inviteUserInput: InviteUserInput!) {
  org_userInvite(inviteUserInput: $inviteUserInput) {
    inviteEmail
  }
}
    `;
export type OrganizationUsersInviteMutationFn = Apollo.MutationFunction<OrganizationUsersInviteMutation, OrganizationUsersInviteMutationVariables>;

/**
 * __useOrganizationUsersInviteMutation__
 *
 * To run a mutation, you first call `useOrganizationUsersInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUsersInviteMutation, { data, loading, error }] = useOrganizationUsersInviteMutation({
 *   variables: {
 *      inviteUserInput: // value for 'inviteUserInput'
 *   },
 * });
 */
export function useOrganizationUsersInviteMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUsersInviteMutation, OrganizationUsersInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUsersInviteMutation, OrganizationUsersInviteMutationVariables>(OrganizationUsersInviteDocument, options);
      }
export type OrganizationUsersInviteMutationHookResult = ReturnType<typeof useOrganizationUsersInviteMutation>;
export type OrganizationUsersInviteMutationResult = Apollo.MutationResult<OrganizationUsersInviteMutation>;
export type OrganizationUsersInviteMutationOptions = Apollo.BaseMutationOptions<OrganizationUsersInviteMutation, OrganizationUsersInviteMutationVariables>;
export const OrganizationRoleListDocument = gql`
    query OrganizationRoleList {
  org_roleList {
    data {
      id
      displayName
      description
      name
    }
  }
}
    `;

/**
 * __useOrganizationRoleListQuery__
 *
 * To run a query within a React component, call `useOrganizationRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRoleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationRoleListQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationRoleListQuery, OrganizationRoleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationRoleListQuery, OrganizationRoleListQueryVariables>(OrganizationRoleListDocument, options);
      }
export function useOrganizationRoleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationRoleListQuery, OrganizationRoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationRoleListQuery, OrganizationRoleListQueryVariables>(OrganizationRoleListDocument, options);
        }
export type OrganizationRoleListQueryHookResult = ReturnType<typeof useOrganizationRoleListQuery>;
export type OrganizationRoleListLazyQueryHookResult = ReturnType<typeof useOrganizationRoleListLazyQuery>;
export type OrganizationRoleListQueryResult = Apollo.QueryResult<OrganizationRoleListQuery, OrganizationRoleListQueryVariables>;
export const BusinessListByOrgIdDocument = gql`
    query BusinessListByOrgId($organizationId: Int!, $paginationArgs: PaginationArgs) {
  org_businessListByOrgId(
    organizationId: $organizationId
    paginationArgs: $paginationArgs
  ) {
    data {
      createdAt
      id
      name
      numUsers
    }
    skip
    take
    totalCount
  }
}
    `;

/**
 * __useBusinessListByOrgIdQuery__
 *
 * To run a query within a React component, call `useBusinessListByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessListByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessListByOrgIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useBusinessListByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<BusinessListByOrgIdQuery, BusinessListByOrgIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessListByOrgIdQuery, BusinessListByOrgIdQueryVariables>(BusinessListByOrgIdDocument, options);
      }
export function useBusinessListByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessListByOrgIdQuery, BusinessListByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessListByOrgIdQuery, BusinessListByOrgIdQueryVariables>(BusinessListByOrgIdDocument, options);
        }
export type BusinessListByOrgIdQueryHookResult = ReturnType<typeof useBusinessListByOrgIdQuery>;
export type BusinessListByOrgIdLazyQueryHookResult = ReturnType<typeof useBusinessListByOrgIdLazyQuery>;
export type BusinessListByOrgIdQueryResult = Apollo.QueryResult<BusinessListByOrgIdQuery, BusinessListByOrgIdQueryVariables>;
export const AssignedRoleListMeDocument = gql`
    query AssignedRoleListMe($organizationId: Int) {
  org_assignedRoleListMe(organizationId: $organizationId) {
    data {
      business {
        createdAt
        id
        name
        numUsers
      }
    }
  }
}
    `;

/**
 * __useAssignedRoleListMeQuery__
 *
 * To run a query within a React component, call `useAssignedRoleListMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedRoleListMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedRoleListMeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAssignedRoleListMeQuery(baseOptions?: Apollo.QueryHookOptions<AssignedRoleListMeQuery, AssignedRoleListMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedRoleListMeQuery, AssignedRoleListMeQueryVariables>(AssignedRoleListMeDocument, options);
      }
export function useAssignedRoleListMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedRoleListMeQuery, AssignedRoleListMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedRoleListMeQuery, AssignedRoleListMeQueryVariables>(AssignedRoleListMeDocument, options);
        }
export type AssignedRoleListMeQueryHookResult = ReturnType<typeof useAssignedRoleListMeQuery>;
export type AssignedRoleListMeLazyQueryHookResult = ReturnType<typeof useAssignedRoleListMeLazyQuery>;
export type AssignedRoleListMeQueryResult = Apollo.QueryResult<AssignedRoleListMeQuery, AssignedRoleListMeQueryVariables>;
export const AssignedRoleCreateDocument = gql`
    mutation AssignedRoleCreate($createAssignedroleInput: CreateAssignedRoleInput!) {
  org_assignedRoleCreate(createAssignedroleInput: $createAssignedroleInput) {
    id
    role {
      name
    }
  }
}
    `;
export type AssignedRoleCreateMutationFn = Apollo.MutationFunction<AssignedRoleCreateMutation, AssignedRoleCreateMutationVariables>;

/**
 * __useAssignedRoleCreateMutation__
 *
 * To run a mutation, you first call `useAssignedRoleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignedRoleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignedRoleCreateMutation, { data, loading, error }] = useAssignedRoleCreateMutation({
 *   variables: {
 *      createAssignedroleInput: // value for 'createAssignedroleInput'
 *   },
 * });
 */
export function useAssignedRoleCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssignedRoleCreateMutation, AssignedRoleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignedRoleCreateMutation, AssignedRoleCreateMutationVariables>(AssignedRoleCreateDocument, options);
      }
export type AssignedRoleCreateMutationHookResult = ReturnType<typeof useAssignedRoleCreateMutation>;
export type AssignedRoleCreateMutationResult = Apollo.MutationResult<AssignedRoleCreateMutation>;
export type AssignedRoleCreateMutationOptions = Apollo.BaseMutationOptions<AssignedRoleCreateMutation, AssignedRoleCreateMutationVariables>;
export const BusinessCreateDocument = gql`
    mutation BusinessCreate($createBusinessInput: CreateBusinessInput!) {
  org_businessCreate(createBusinessInput: $createBusinessInput) {
    id
    name
    assignedRoles {
      id
      roleId
      role {
        id
        name
      }
    }
  }
}
    `;
export type BusinessCreateMutationFn = Apollo.MutationFunction<BusinessCreateMutation, BusinessCreateMutationVariables>;

/**
 * __useBusinessCreateMutation__
 *
 * To run a mutation, you first call `useBusinessCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessCreateMutation, { data, loading, error }] = useBusinessCreateMutation({
 *   variables: {
 *      createBusinessInput: // value for 'createBusinessInput'
 *   },
 * });
 */
export function useBusinessCreateMutation(baseOptions?: Apollo.MutationHookOptions<BusinessCreateMutation, BusinessCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessCreateMutation, BusinessCreateMutationVariables>(BusinessCreateDocument, options);
      }
export type BusinessCreateMutationHookResult = ReturnType<typeof useBusinessCreateMutation>;
export type BusinessCreateMutationResult = Apollo.MutationResult<BusinessCreateMutation>;
export type BusinessCreateMutationOptions = Apollo.BaseMutationOptions<BusinessCreateMutation, BusinessCreateMutationVariables>;
export const OrganizationShowDocument = gql`
    query OrganizationShow($orgOrganizationShowId: Int!) {
  org_organizationShow(id: $orgOrganizationShowId) {
    businessEntityTerminology
    createdAt
    id
    name
    assignedRoles {
      role {
        displayName
      }
      user {
        firstName
        id
        lastName
        primaryEmail
      }
    }
    businesses {
      id
      name
    }
    organizationData {
      phone
      website
    }
  }
}
    `;

/**
 * __useOrganizationShowQuery__
 *
 * To run a query within a React component, call `useOrganizationShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationShowQuery({
 *   variables: {
 *      orgOrganizationShowId: // value for 'orgOrganizationShowId'
 *   },
 * });
 */
export function useOrganizationShowQuery(baseOptions: Apollo.QueryHookOptions<OrganizationShowQuery, OrganizationShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationShowQuery, OrganizationShowQueryVariables>(OrganizationShowDocument, options);
      }
export function useOrganizationShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationShowQuery, OrganizationShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationShowQuery, OrganizationShowQueryVariables>(OrganizationShowDocument, options);
        }
export type OrganizationShowQueryHookResult = ReturnType<typeof useOrganizationShowQuery>;
export type OrganizationShowLazyQueryHookResult = ReturnType<typeof useOrganizationShowLazyQuery>;
export type OrganizationShowQueryResult = Apollo.QueryResult<OrganizationShowQuery, OrganizationShowQueryVariables>;
export const OrganizationUpdateDocument = gql`
    mutation OrganizationUpdate($updateOrganizationInput: UpdateOrganizationInput!) {
  org_organizationUpdate(updateOrganizationInput: $updateOrganizationInput) {
    businessEntityTerminology
    name
  }
}
    `;
export type OrganizationUpdateMutationFn = Apollo.MutationFunction<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;

/**
 * __useOrganizationUpdateMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMutation, { data, loading, error }] = useOrganizationUpdateMutation({
 *   variables: {
 *      updateOrganizationInput: // value for 'updateOrganizationInput'
 *   },
 * });
 */
export function useOrganizationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>(OrganizationUpdateDocument, options);
      }
export type OrganizationUpdateMutationHookResult = ReturnType<typeof useOrganizationUpdateMutation>;
export type OrganizationUpdateMutationResult = Apollo.MutationResult<OrganizationUpdateMutation>;
export type OrganizationUpdateMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;
export const OrganizationUsersDocument = gql`
    query OrganizationUsers($orgOrganizationShowId: Int!) {
  org_organizationShow(id: $orgOrganizationShowId) {
    id
    name
    businesses {
      id
      name
      assignedRoles {
        id
        userId
        role {
          name
          displayName
        }
      }
    }
    members {
      id
      auth0Id
      createdAt
      status
      primaryEmail
      firstName
      lastName
      role {
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUsersQuery({
 *   variables: {
 *      orgOrganizationShowId: // value for 'orgOrganizationShowId'
 *   },
 * });
 */
export function useOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<OrganizationUsersQuery, OrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationUsersQuery, OrganizationUsersQueryVariables>(OrganizationUsersDocument, options);
      }
export function useOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationUsersQuery, OrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationUsersQuery, OrganizationUsersQueryVariables>(OrganizationUsersDocument, options);
        }
export type OrganizationUsersQueryHookResult = ReturnType<typeof useOrganizationUsersQuery>;
export type OrganizationUsersLazyQueryHookResult = ReturnType<typeof useOrganizationUsersLazyQuery>;
export type OrganizationUsersQueryResult = Apollo.QueryResult<OrganizationUsersQuery, OrganizationUsersQueryVariables>;
export const orgSettings_UnblockUserDocument = gql`
    mutation orgSettings_UnblockUser($orgUserId: Int!) {
  org_userUnblock(id: $orgUserId) {
    id
  }
}
    `;
export type orgSettings_UnblockUserMutationFn = Apollo.MutationFunction<orgSettings_UnblockUserMutation, orgSettings_UnblockUserMutationVariables>;

/**
 * __useorgSettings_UnblockUserMutation__
 *
 * To run a mutation, you first call `useorgSettings_UnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useorgSettings_UnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgSettingsUnblockUserMutation, { data, loading, error }] = useorgSettings_UnblockUserMutation({
 *   variables: {
 *      orgUserId: // value for 'orgUserId'
 *   },
 * });
 */
export function useorgSettings_UnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<orgSettings_UnblockUserMutation, orgSettings_UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<orgSettings_UnblockUserMutation, orgSettings_UnblockUserMutationVariables>(orgSettings_UnblockUserDocument, options);
      }
export type orgSettings_UnblockUserMutationHookResult = ReturnType<typeof useorgSettings_UnblockUserMutation>;
export type orgSettings_UnblockUserMutationResult = Apollo.MutationResult<orgSettings_UnblockUserMutation>;
export type orgSettings_UnblockUserMutationOptions = Apollo.BaseMutationOptions<orgSettings_UnblockUserMutation, orgSettings_UnblockUserMutationVariables>;
export const OrganizationUsersRemoveDocument = gql`
    mutation OrganizationUsersRemove($ids: [Int!]!) {
  org_assignedRoleDelete(ids: $ids) {
    id
  }
}
    `;
export type OrganizationUsersRemoveMutationFn = Apollo.MutationFunction<OrganizationUsersRemoveMutation, OrganizationUsersRemoveMutationVariables>;

/**
 * __useOrganizationUsersRemoveMutation__
 *
 * To run a mutation, you first call `useOrganizationUsersRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUsersRemoveMutation, { data, loading, error }] = useOrganizationUsersRemoveMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOrganizationUsersRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUsersRemoveMutation, OrganizationUsersRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUsersRemoveMutation, OrganizationUsersRemoveMutationVariables>(OrganizationUsersRemoveDocument, options);
      }
export type OrganizationUsersRemoveMutationHookResult = ReturnType<typeof useOrganizationUsersRemoveMutation>;
export type OrganizationUsersRemoveMutationResult = Apollo.MutationResult<OrganizationUsersRemoveMutation>;
export type OrganizationUsersRemoveMutationOptions = Apollo.BaseMutationOptions<OrganizationUsersRemoveMutation, OrganizationUsersRemoveMutationVariables>;
export const OrganizationRemoveUserDocument = gql`
    mutation OrganizationRemoveUser($organizationId: Int!, $userIds: [Int!]!) {
  org_organizationRemoveUser(organizationId: $organizationId, userIds: $userIds) {
    id
  }
}
    `;
export type OrganizationRemoveUserMutationFn = Apollo.MutationFunction<OrganizationRemoveUserMutation, OrganizationRemoveUserMutationVariables>;

/**
 * __useOrganizationRemoveUserMutation__
 *
 * To run a mutation, you first call `useOrganizationRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationRemoveUserMutation, { data, loading, error }] = useOrganizationRemoveUserMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useOrganizationRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationRemoveUserMutation, OrganizationRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationRemoveUserMutation, OrganizationRemoveUserMutationVariables>(OrganizationRemoveUserDocument, options);
      }
export type OrganizationRemoveUserMutationHookResult = ReturnType<typeof useOrganizationRemoveUserMutation>;
export type OrganizationRemoveUserMutationResult = Apollo.MutationResult<OrganizationRemoveUserMutation>;
export type OrganizationRemoveUserMutationOptions = Apollo.BaseMutationOptions<OrganizationRemoveUserMutation, OrganizationRemoveUserMutationVariables>;
export const BusinessRemoveUserDocument = gql`
    mutation BusinessRemoveUser($businessId: Int!, $userIds: [Int!]!) {
  org_businessRemoveUser(businessId: $businessId, userIds: $userIds) {
    id
  }
}
    `;
export type BusinessRemoveUserMutationFn = Apollo.MutationFunction<BusinessRemoveUserMutation, BusinessRemoveUserMutationVariables>;

/**
 * __useBusinessRemoveUserMutation__
 *
 * To run a mutation, you first call `useBusinessRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessRemoveUserMutation, { data, loading, error }] = useBusinessRemoveUserMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useBusinessRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<BusinessRemoveUserMutation, BusinessRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessRemoveUserMutation, BusinessRemoveUserMutationVariables>(BusinessRemoveUserDocument, options);
      }
export type BusinessRemoveUserMutationHookResult = ReturnType<typeof useBusinessRemoveUserMutation>;
export type BusinessRemoveUserMutationResult = Apollo.MutationResult<BusinessRemoveUserMutation>;
export type BusinessRemoveUserMutationOptions = Apollo.BaseMutationOptions<BusinessRemoveUserMutation, BusinessRemoveUserMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    user {
      userData {
        address1
        address2
        city
        company
        country
        id
        phone
        state
        zip
      }
      firstName
      lastName
      primaryEmail
      id
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($updateUserInput: UpdateUserInput!) {
  org_userUpdate(updateUserInput: $updateUserInput) {
    firstName
    lastName
    primaryEmail
    userData {
      address1
      address2
      city
      company
      country
      phone
      state
      zip
    }
    id
  }
}
    `;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const OrgUserChangeOwnPasswordDocument = gql`
    mutation OrgUserChangeOwnPassword($input: ChangeOwnPasswordInput!) {
  org_userChangeOwnPassword(input: $input) {
    id
  }
}
    `;
export type OrgUserChangeOwnPasswordMutationFn = Apollo.MutationFunction<OrgUserChangeOwnPasswordMutation, OrgUserChangeOwnPasswordMutationVariables>;

/**
 * __useOrgUserChangeOwnPasswordMutation__
 *
 * To run a mutation, you first call `useOrgUserChangeOwnPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgUserChangeOwnPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgUserChangeOwnPasswordMutation, { data, loading, error }] = useOrgUserChangeOwnPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgUserChangeOwnPasswordMutation(baseOptions?: Apollo.MutationHookOptions<OrgUserChangeOwnPasswordMutation, OrgUserChangeOwnPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrgUserChangeOwnPasswordMutation, OrgUserChangeOwnPasswordMutationVariables>(OrgUserChangeOwnPasswordDocument, options);
      }
export type OrgUserChangeOwnPasswordMutationHookResult = ReturnType<typeof useOrgUserChangeOwnPasswordMutation>;
export type OrgUserChangeOwnPasswordMutationResult = Apollo.MutationResult<OrgUserChangeOwnPasswordMutation>;
export type OrgUserChangeOwnPasswordMutationOptions = Apollo.BaseMutationOptions<OrgUserChangeOwnPasswordMutation, OrgUserChangeOwnPasswordMutationVariables>;
export const MeMfaAccessTokenDocument = gql`
    query MeMfaAccessToken($mfaInput: MfaDataInput!) {
  me {
    user {
      mfaData(mfaInput: $mfaInput) {
        access_token
      }
    }
  }
}
    `;

/**
 * __useMeMfaAccessTokenQuery__
 *
 * To run a query within a React component, call `useMeMfaAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeMfaAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeMfaAccessTokenQuery({
 *   variables: {
 *      mfaInput: // value for 'mfaInput'
 *   },
 * });
 */
export function useMeMfaAccessTokenQuery(baseOptions: Apollo.QueryHookOptions<MeMfaAccessTokenQuery, MeMfaAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeMfaAccessTokenQuery, MeMfaAccessTokenQueryVariables>(MeMfaAccessTokenDocument, options);
      }
export function useMeMfaAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeMfaAccessTokenQuery, MeMfaAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeMfaAccessTokenQuery, MeMfaAccessTokenQueryVariables>(MeMfaAccessTokenDocument, options);
        }
export type MeMfaAccessTokenQueryHookResult = ReturnType<typeof useMeMfaAccessTokenQuery>;
export type MeMfaAccessTokenLazyQueryHookResult = ReturnType<typeof useMeMfaAccessTokenLazyQuery>;
export type MeMfaAccessTokenQueryResult = Apollo.QueryResult<MeMfaAccessTokenQuery, MeMfaAccessTokenQueryVariables>;
export const Org_userConfirmMfaEnrollmentDocument = gql`
    mutation Org_userConfirmMfaEnrollment($confirmEnrollmentInput: ConfirmMfaEnrollmentInput!) {
  org_userConfirmMfaEnrollment(confirmEnrollmentInput: $confirmEnrollmentInput) {
    access_token
  }
}
    `;
export type Org_userConfirmMfaEnrollmentMutationFn = Apollo.MutationFunction<Org_userConfirmMfaEnrollmentMutation, Org_userConfirmMfaEnrollmentMutationVariables>;

/**
 * __useOrg_userConfirmMfaEnrollmentMutation__
 *
 * To run a mutation, you first call `useOrg_userConfirmMfaEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrg_userConfirmMfaEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgUserConfirmMfaEnrollmentMutation, { data, loading, error }] = useOrg_userConfirmMfaEnrollmentMutation({
 *   variables: {
 *      confirmEnrollmentInput: // value for 'confirmEnrollmentInput'
 *   },
 * });
 */
export function useOrg_userConfirmMfaEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<Org_userConfirmMfaEnrollmentMutation, Org_userConfirmMfaEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Org_userConfirmMfaEnrollmentMutation, Org_userConfirmMfaEnrollmentMutationVariables>(Org_userConfirmMfaEnrollmentDocument, options);
      }
export type Org_userConfirmMfaEnrollmentMutationHookResult = ReturnType<typeof useOrg_userConfirmMfaEnrollmentMutation>;
export type Org_userConfirmMfaEnrollmentMutationResult = Apollo.MutationResult<Org_userConfirmMfaEnrollmentMutation>;
export type Org_userConfirmMfaEnrollmentMutationOptions = Apollo.BaseMutationOptions<Org_userConfirmMfaEnrollmentMutation, Org_userConfirmMfaEnrollmentMutationVariables>;
export const Org_userToggleMfaDocument = gql`
    mutation Org_userToggleMfa($toggleUserMfaInput: ToggleUserMfaInput!) {
  org_userToggleMfa(toggleUserMfaInput: $toggleUserMfaInput) {
    success
  }
}
    `;
export type Org_userToggleMfaMutationFn = Apollo.MutationFunction<Org_userToggleMfaMutation, Org_userToggleMfaMutationVariables>;

/**
 * __useOrg_userToggleMfaMutation__
 *
 * To run a mutation, you first call `useOrg_userToggleMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrg_userToggleMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgUserToggleMfaMutation, { data, loading, error }] = useOrg_userToggleMfaMutation({
 *   variables: {
 *      toggleUserMfaInput: // value for 'toggleUserMfaInput'
 *   },
 * });
 */
export function useOrg_userToggleMfaMutation(baseOptions?: Apollo.MutationHookOptions<Org_userToggleMfaMutation, Org_userToggleMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Org_userToggleMfaMutation, Org_userToggleMfaMutationVariables>(Org_userToggleMfaDocument, options);
      }
export type Org_userToggleMfaMutationHookResult = ReturnType<typeof useOrg_userToggleMfaMutation>;
export type Org_userToggleMfaMutationResult = Apollo.MutationResult<Org_userToggleMfaMutation>;
export type Org_userToggleMfaMutationOptions = Apollo.BaseMutationOptions<Org_userToggleMfaMutation, Org_userToggleMfaMutationVariables>;
export const mfa_userMfaDeleteDocument = gql`
    mutation mfa_userMfaDelete {
  org_userMfaDelete
}
    `;
export type mfa_userMfaDeleteMutationFn = Apollo.MutationFunction<mfa_userMfaDeleteMutation, mfa_userMfaDeleteMutationVariables>;

/**
 * __usemfa_userMfaDeleteMutation__
 *
 * To run a mutation, you first call `usemfa_userMfaDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usemfa_userMfaDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaUserMfaDeleteMutation, { data, loading, error }] = usemfa_userMfaDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function usemfa_userMfaDeleteMutation(baseOptions?: Apollo.MutationHookOptions<mfa_userMfaDeleteMutation, mfa_userMfaDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<mfa_userMfaDeleteMutation, mfa_userMfaDeleteMutationVariables>(mfa_userMfaDeleteDocument, options);
      }
export type mfa_userMfaDeleteMutationHookResult = ReturnType<typeof usemfa_userMfaDeleteMutation>;
export type mfa_userMfaDeleteMutationResult = Apollo.MutationResult<mfa_userMfaDeleteMutation>;
export type mfa_userMfaDeleteMutationOptions = Apollo.BaseMutationOptions<mfa_userMfaDeleteMutation, mfa_userMfaDeleteMutationVariables>;
export const OrgProductInstanceListDocument = gql`
    query OrgProductInstanceList($input: ListProductInstanceInput!) {
  org_productInstanceList(input: $input) {
    id
    instanceType
  }
}
    `;

/**
 * __useOrgProductInstanceListQuery__
 *
 * To run a query within a React component, call `useOrgProductInstanceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgProductInstanceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgProductInstanceListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgProductInstanceListQuery(baseOptions: Apollo.QueryHookOptions<OrgProductInstanceListQuery, OrgProductInstanceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgProductInstanceListQuery, OrgProductInstanceListQueryVariables>(OrgProductInstanceListDocument, options);
      }
export function useOrgProductInstanceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgProductInstanceListQuery, OrgProductInstanceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgProductInstanceListQuery, OrgProductInstanceListQueryVariables>(OrgProductInstanceListDocument, options);
        }
export type OrgProductInstanceListQueryHookResult = ReturnType<typeof useOrgProductInstanceListQuery>;
export type OrgProductInstanceListLazyQueryHookResult = ReturnType<typeof useOrgProductInstanceListLazyQuery>;
export type OrgProductInstanceListQueryResult = Apollo.QueryResult<OrgProductInstanceListQuery, OrgProductInstanceListQueryVariables>;
export const OrganizationListDocument = gql`
    query OrganizationList($searchArgs: SearchOrganizationInput, $paginationArgs: PaginationArgs) {
  org_organizationList(searchArgs: $searchArgs, paginationArgs: $paginationArgs) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useOrganizationListQuery__
 *
 * To run a query within a React component, call `useOrganizationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationListQuery({
 *   variables: {
 *      searchArgs: // value for 'searchArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useOrganizationListQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationListQuery, OrganizationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationListQuery, OrganizationListQueryVariables>(OrganizationListDocument, options);
      }
export function useOrganizationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationListQuery, OrganizationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationListQuery, OrganizationListQueryVariables>(OrganizationListDocument, options);
        }
export type OrganizationListQueryHookResult = ReturnType<typeof useOrganizationListQuery>;
export type OrganizationListLazyQueryHookResult = ReturnType<typeof useOrganizationListLazyQuery>;
export type OrganizationListQueryResult = Apollo.QueryResult<OrganizationListQuery, OrganizationListQueryVariables>;
export const Org_businessListByOrgIdDocument = gql`
    query Org_businessListByOrgId($organizationId: Int!) {
  org_businessListByOrgId(organizationId: $organizationId) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useOrg_businessListByOrgIdQuery__
 *
 * To run a query within a React component, call `useOrg_businessListByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrg_businessListByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrg_businessListByOrgIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrg_businessListByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<Org_businessListByOrgIdQuery, Org_businessListByOrgIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Org_businessListByOrgIdQuery, Org_businessListByOrgIdQueryVariables>(Org_businessListByOrgIdDocument, options);
      }
export function useOrg_businessListByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Org_businessListByOrgIdQuery, Org_businessListByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Org_businessListByOrgIdQuery, Org_businessListByOrgIdQueryVariables>(Org_businessListByOrgIdDocument, options);
        }
export type Org_businessListByOrgIdQueryHookResult = ReturnType<typeof useOrg_businessListByOrgIdQuery>;
export type Org_businessListByOrgIdLazyQueryHookResult = ReturnType<typeof useOrg_businessListByOrgIdLazyQuery>;
export type Org_businessListByOrgIdQueryResult = Apollo.QueryResult<Org_businessListByOrgIdQuery, Org_businessListByOrgIdQueryVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($registerUserInput: RegisterUserInput!) {
  org_registerUser(registerUserInput: $registerUserInput) {
    id
    auth0Id
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      registerUserInput: // value for 'registerUserInput'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const UserShowDocument = gql`
    query UserShow($primaryEmail: String) {
  org_userShow(primaryEmail: $primaryEmail) {
    id
    organizations {
      id
    }
    businesses {
      id
    }
  }
}
    `;

/**
 * __useUserShowQuery__
 *
 * To run a query within a React component, call `useUserShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserShowQuery({
 *   variables: {
 *      primaryEmail: // value for 'primaryEmail'
 *   },
 * });
 */
export function useUserShowQuery(baseOptions?: Apollo.QueryHookOptions<UserShowQuery, UserShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserShowQuery, UserShowQueryVariables>(UserShowDocument, options);
      }
export function useUserShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserShowQuery, UserShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserShowQuery, UserShowQueryVariables>(UserShowDocument, options);
        }
export type UserShowQueryHookResult = ReturnType<typeof useUserShowQuery>;
export type UserShowLazyQueryHookResult = ReturnType<typeof useUserShowLazyQuery>;
export type UserShowQueryResult = Apollo.QueryResult<UserShowQuery, UserShowQueryVariables>;
export const MemberStructureDocument = gql`
    query MemberStructure($orgUserShowId: Int) {
  org_userShow(id: $orgUserShowId) {
    userInvitations {
      organizationName
      inviteStatus
      assignedRoles {
        business {
          organization {
            name
            id
          }
          name
          id
        }
        role {
          displayName
        }
      }
    }
    organizations {
      id
      name
      assignedRoles {
        role {
          id
          displayName
          name
        }
        user {
          id
        }
      }
      businesses(userId: $orgUserShowId) {
        id
        name
        userStatus @client
        assignedRoles(userId: $orgUserShowId) {
          role {
            displayName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMemberStructureQuery__
 *
 * To run a query within a React component, call `useMemberStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberStructureQuery({
 *   variables: {
 *      orgUserShowId: // value for 'orgUserShowId'
 *   },
 * });
 */
export function useMemberStructureQuery(baseOptions?: Apollo.QueryHookOptions<MemberStructureQuery, MemberStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberStructureQuery, MemberStructureQueryVariables>(MemberStructureDocument, options);
      }
export function useMemberStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberStructureQuery, MemberStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberStructureQuery, MemberStructureQueryVariables>(MemberStructureDocument, options);
        }
export type MemberStructureQueryHookResult = ReturnType<typeof useMemberStructureQuery>;
export type MemberStructureLazyQueryHookResult = ReturnType<typeof useMemberStructureLazyQuery>;
export type MemberStructureQueryResult = Apollo.QueryResult<MemberStructureQuery, MemberStructureQueryVariables>;
export const OrgAssignedPermissionCheckDocument = gql`
    query OrgAssignedPermissionCheck($permissionName: String) {
  org_assignedPermissionCheck(permissionName: $permissionName) {
    access
  }
}
    `;

/**
 * __useOrgAssignedPermissionCheckQuery__
 *
 * To run a query within a React component, call `useOrgAssignedPermissionCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgAssignedPermissionCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgAssignedPermissionCheckQuery({
 *   variables: {
 *      permissionName: // value for 'permissionName'
 *   },
 * });
 */
export function useOrgAssignedPermissionCheckQuery(baseOptions?: Apollo.QueryHookOptions<OrgAssignedPermissionCheckQuery, OrgAssignedPermissionCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgAssignedPermissionCheckQuery, OrgAssignedPermissionCheckQueryVariables>(OrgAssignedPermissionCheckDocument, options);
      }
export function useOrgAssignedPermissionCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgAssignedPermissionCheckQuery, OrgAssignedPermissionCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgAssignedPermissionCheckQuery, OrgAssignedPermissionCheckQueryVariables>(OrgAssignedPermissionCheckDocument, options);
        }
export type OrgAssignedPermissionCheckQueryHookResult = ReturnType<typeof useOrgAssignedPermissionCheckQuery>;
export type OrgAssignedPermissionCheckLazyQueryHookResult = ReturnType<typeof useOrgAssignedPermissionCheckLazyQuery>;
export type OrgAssignedPermissionCheckQueryResult = Apollo.QueryResult<OrgAssignedPermissionCheckQuery, OrgAssignedPermissionCheckQueryVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($userEmail: String!) {
  org_userResetPassword(userEmail: $userEmail) {
    id
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const UserDetailsDocument = gql`
    query UserDetails($orgUserShowId: Int) {
  org_userShow(id: $orgUserShowId) {
    auth0Id
    createdAt
    firstName
    id
    lastName
    primaryEmail
    userData {
      address1
      address2
      city
      company
      country
      createdAt
      phone
      state
      updatedAt
      zip
    }
  }
}
    `;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *      orgUserShowId: // value for 'orgUserShowId'
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsQueryResult = Apollo.QueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export const UserSearchDocument = gql`
    query UserSearch($idOrEmail: String!, $paginationArgs: PaginationArgs) {
  org_userList(idOrEmail: $idOrEmail, paginationArgs: $paginationArgs) {
    data {
      id
      firstName
      lastName
      primaryEmail
    }
  }
}
    `;

/**
 * __useUserSearchQuery__
 *
 * To run a query within a React component, call `useUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchQuery({
 *   variables: {
 *      idOrEmail: // value for 'idOrEmail'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useUserSearchQuery(baseOptions: Apollo.QueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, options);
      }
export function useUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, options);
        }
export type UserSearchQueryHookResult = ReturnType<typeof useUserSearchQuery>;
export type UserSearchLazyQueryHookResult = ReturnType<typeof useUserSearchLazyQuery>;
export type UserSearchQueryResult = Apollo.QueryResult<UserSearchQuery, UserSearchQueryVariables>;
export const bc_validatePhoneDocument = gql`
    query bc_validatePhone($phone: String!) {
  org_validatePhone(phone: $phone)
}
    `;

/**
 * __usebc_validatePhoneQuery__
 *
 * To run a query within a React component, call `usebc_validatePhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `usebc_validatePhoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usebc_validatePhoneQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function usebc_validatePhoneQuery(baseOptions: Apollo.QueryHookOptions<bc_validatePhoneQuery, bc_validatePhoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<bc_validatePhoneQuery, bc_validatePhoneQueryVariables>(bc_validatePhoneDocument, options);
      }
export function usebc_validatePhoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<bc_validatePhoneQuery, bc_validatePhoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<bc_validatePhoneQuery, bc_validatePhoneQueryVariables>(bc_validatePhoneDocument, options);
        }
export type bc_validatePhoneQueryHookResult = ReturnType<typeof usebc_validatePhoneQuery>;
export type bc_validatePhoneLazyQueryHookResult = ReturnType<typeof usebc_validatePhoneLazyQuery>;
export type bc_validatePhoneQueryResult = Apollo.QueryResult<bc_validatePhoneQuery, bc_validatePhoneQueryVariables>;